(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5682],{

/***/ 54290:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(6557);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),

/***/ 98913:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(22545),
    castFunction = __webpack_require__(54290),
    toInteger = __webpack_require__(40554);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */
function times(n, iteratee) {
  n = toInteger(n);
  if (n < 1 || n > MAX_SAFE_INTEGER) {
    return [];
  }
  var index = MAX_ARRAY_LENGTH,
      length = nativeMin(n, MAX_ARRAY_LENGTH);

  iteratee = castFunction(iteratee);
  n -= MAX_ARRAY_LENGTH;

  var result = baseTimes(length, iteratee);
  while (++index < n) {
    iteratee(index);
  }
  return result;
}

module.exports = times;


/***/ }),

/***/ 87944:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[urlKey]/cpd/[productSku]",
      function () {
        return __webpack_require__(44956);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 66707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lib_useElementSize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56055);



var AccordionItemBody = function(param) {
    var children = param.children, isExpanded = param.isExpanded, isPreRendered = param.isPreRendered;
    var onContentSizeChange = function onContentSizeChange(size) {
        if (size && contentHeight !== size) {
            setContentHeight("".concat(size.height, "px"));
        }
    };
    // Using height 100% doesn't break functionality
    // despite animations not working
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isContainerRendered = ref[0], setIsContainerRendered = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("100%"), contentHeight = ref1[0], setContentHeight = ref1[1];
    var setContainerRef = (0,_lib_useElementSize__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(onContentSizeChange);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isExpanded || isPreRendered) {
            setIsContainerRendered(true);
        }
    }, [
        isExpanded,
        isPreRendered
    ]);
    var containerHeight = isExpanded ? contentHeight : 0;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "overflow-hidden transition-[height] ease-in-out duration-[300ms]",
        style: {
            height: containerHeight
        },
        children: isContainerRendered && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            ref: setContainerRef,
            className: "pb-8",
            children: children
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (AccordionItemBody);


/***/ }),

/***/ 85929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Header; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/Icons/ArrowDown.js
var ArrowDown = __webpack_require__(26206);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
;// CONCATENATED MODULE: ./components/Accordion/Item/HeaderToggleButton.js



var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteName = _publicRuntimeConfig.settings.websiteName;
var isBricoStore = websiteName === "bricostore";
var HeaderToggleButton = function(param) {
    var onToggle = param.onToggle, isExpanded = param.isExpanded;
    // TODO: website-next - Replace with Button component
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("button", {
        className: isBricoStore ? "rounded-full bg-gray-lighter px-3 py-2" : "rounded bg-filterYellow px-3 py-2",
        onClick: onToggle,
        children: isExpanded ? "Ascunde" : "Detalii"
    });
};
/* harmony default export */ var Item_HeaderToggleButton = (HeaderToggleButton);

;// CONCATENATED MODULE: ./components/Accordion/Item/Header.js



var AccordionItemHeader = function(param) {
    var isExpanded = param.isExpanded, isToggleable = param.isToggleable, _hasToggleButton = param.hasToggleButton, hasToggleButton = _hasToggleButton === void 0 ? false : _hasToggleButton, renderToggleButton = param.renderToggleButton, onToggle = param.onToggle, children = param.children;
    if (!hasToggleButton) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center justify-between py-7 ".concat(isToggleable ? "cursor-pointer" : ""),
            onClick: onToggle,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: children
                }),
                isToggleable && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "transition-transform ease-linear ".concat(isExpanded ? "rotate-180" : "rotate-0"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                        width: "16px",
                        height: "16px"
                    })
                })
            ]
        }));
    }
    var toggleButton = renderToggleButton && renderToggleButton({
        toggleItem: onToggle,
        isItemExpanded: isExpanded
    }) || /*#__PURE__*/ (0,jsx_runtime.jsx)(Item_HeaderToggleButton, {
        isExpanded: isExpanded,
        onToggle: onToggle
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center justify-between py-4 ",
        children: [
            children,
            isToggleable && toggleButton
        ]
    }));
};
/* harmony default export */ var Header = (AccordionItemHeader);


/***/ }),

/***/ 4259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_Accordion_accordionContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84849);



var AccordionItem = function(param) {
    var id = param.id, children = param.children, _isPreRendered = param.isPreRendered, isPreRendered = _isPreRendered === void 0 ? true : _isPreRendered;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_components_Accordion_accordionContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z), onItemToggle = ref.onItemToggle, isItemToggleable = ref.isItemToggleable, isItemExpanded = ref.isItemExpanded;
    var handleToggle = function(event) {
        return onItemToggle(id, event);
    };
    var isExpanded = isItemExpanded(id);
    var isToggleable = isItemToggleable(id);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: id,
        children: react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, function(child) {
            /*#__PURE__*/ return (0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(child) ? /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(child, {
                id: id,
                isPreRendered: isPreRendered,
                isExpanded: isExpanded,
                isToggleable: isToggleable,
                onToggle: handleToggle
            }) : child;
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (AccordionItem);


/***/ }),

/***/ 84849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var AccordionContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
/* harmony default export */ __webpack_exports__["Z"] = (AccordionContext);


/***/ }),

/***/ 71604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Accordion; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/Accordion/useAccordion.js

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var useAccordion = function(param) {
    var _mode = param.mode, mode = _mode === void 0 ? "closable" : _mode, _expandedItems = param.expandedItems, expandedItems = _expandedItems === void 0 ? [] : _expandedItems, _onToggle = param.onToggle, onToggle = _onToggle === void 0 ? function() {} : _onToggle;
    if (![
        "closable",
        "always-one",
        "max-one"
    ].includes(mode)) {
        throw new Error("Unrecognized \"".concat(mode, "\" for Accordion"));
    }
    if (mode === "always-one" && expandedItems.length !== 1) {
        throw new Error("always-one mode requires only one initial item");
    }
    if (mode === "max-one" && expandedItems.length > 1) {
        throw new Error("max-one mode allows none or only one initial item");
    }
    var ref = (0,react.useState)(expandedItems), expanded = ref[0], setExpanded = ref[1];
    var isItemExpanded = function(item) {
        return expanded === null || expanded === void 0 ? void 0 : expanded.includes(item);
    };
    var isItemToggleable = function(item) {
        return mode === "always-one" ? !isItemExpanded(item) : true;
    };
    (0,react.useEffect)(function() {
        setExpanded(expandedItems);
    }, [
        expandedItems
    ]);
    var onItemToggle = function(item, event) {
        switch(mode){
            case "always-one":
                {
                    if (!isItemExpanded(item)) {
                        setExpanded([
                            item
                        ]);
                        onToggle({
                            item: item,
                            expanded: true
                        }, event);
                    }
                    break;
                }
            case "max-one":
                {
                    if (isItemExpanded(item)) {
                        setExpanded([]);
                        onToggle({
                            item: item,
                            expanded: false
                        }, event);
                    } else {
                        setExpanded([
                            item
                        ]);
                        onToggle({
                            item: item,
                            expanded: true
                        }, event);
                    }
                    break;
                }
            case "closable":
            default:
                {
                    if (isItemExpanded(item)) {
                        setExpanded(expanded.filter(function(expandedItem) {
                            return item !== expandedItem;
                        }));
                        onToggle({
                            item: item,
                            expanded: false
                        }, event);
                    } else {
                        setExpanded(_toConsumableArray(expanded).concat([
                            item
                        ]));
                        onToggle({
                            item: item,
                            expanded: true
                        }, event);
                    }
                }
        }
    };
    return {
        isItemToggleable: isItemToggleable,
        isItemExpanded: isItemExpanded,
        onItemToggle: onItemToggle
    };
};
/* harmony default export */ var Accordion_useAccordion = (useAccordion);

// EXTERNAL MODULE: ./components/Accordion/accordionContext.js
var accordionContext = __webpack_require__(84849);
;// CONCATENATED MODULE: ./components/Accordion/index.js



var Accordion = function(param) {
    var mode = param.mode, expandedItems = param.expandedItems, onToggle = param.onToggle, children = param.children;
    var ref = Accordion_useAccordion({
        mode: mode,
        expandedItems: expandedItems,
        onToggle: onToggle
    }), isItemExpanded = ref.isItemExpanded, isItemToggleable = ref.isItemToggleable, onItemToggle = ref.onItemToggle;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(accordionContext/* default.Provider */.Z.Provider, {
        value: {
            isItemExpanded: isItemExpanded,
            isItemToggleable: isItemToggleable,
            onItemToggle: onItemToggle
        },
        children: children
    }));
};
/* harmony default export */ var components_Accordion = (Accordion);


/***/ }),

/***/ 13812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26209);
/* harmony import */ var _containers_ModalErrorBoundary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33849);
/* harmony import */ var _components_LoginModal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23409);
/* harmony import */ var _store_app_actions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27173);
/* harmony import */ var _components_RegisterModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70187);
/* harmony import */ var _components_ResetPassModal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16586);








var loginModalId = "login-modal-credex-cashback";
var registerModalId = "register-modal-credex-cashback";
var resetPassModalId = "reset-pass-modal-credex-cashback";
var CredexCashbackBanner = function(param) {
    var credexCashback = param.credexCashback, isLoggedIn = param.isLoggedIn, addModal1 = param.addModal;
    var ref = credexCashback || {}, label = ref.label, link = ref.link, enabled = ref.enabled;
    if (!enabled) {
        return null;
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex gap-[16px] items-center justify-between bg-[#EEEAFF] py-[12px] px-[16px] border border-[#DBCDEE] rounded font-medium text-[#7E5E9C]",
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                dangerouslySetInnerHTML: {
                    __html: label
                }
            }),
            isLoggedIn ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                href: link,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    className: "px-[16px] py-[8px] bg-white rounded-full text-[#7E5E9C] content-center max-h-fit",
                    title: "aplica pentru card de credit credex",
                    children: "Aplica"
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: "px-[16px] py-[8px] bg-white rounded-full text-[#7E5E9C] content-center max-h-fit",
                title: "aplica pentru card de credit credex",
                onClick: function() {
                    return addModal1(loginModalId);
                },
                children: "Aplica"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_ModalErrorBoundary__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_LoginModal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    location: "pop-up-credex-cashback",
                    modalId: loginModalId,
                    registerModalId: registerModalId,
                    resetPassModalId: resetPassModalId,
                    redirect: link
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_ModalErrorBoundary__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_RegisterModal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    modalId: registerModalId,
                    loginModalId: loginModalId
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_ModalErrorBoundary__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ResetPassModal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    modalId: resetPassModalId
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .connect */ .$j)(function(state) {
    var ref;
    return {
        isLoggedIn: state.user.isLoggedIn,
        credexCashback: (ref = state.credex.data) === null || ref === void 0 ? void 0 : ref.cashbackBanner
    };
}, {
    addModal: _store_app_actions__WEBPACK_IMPORTED_MODULE_5__/* .addModal */ .Y_
})(CredexCashbackBanner));


/***/ }),

/***/ 87246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_CredexUserPromoBanner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./lib/templateToJsx.js
var templateToJsx = __webpack_require__(60024);
;// CONCATENATED MODULE: ./components/CredexUserPromoBanner/CredexUserPromoBannerDefaultLabel.js


var CredexUserPromoBannerDefaultLabel = function(param) {
    var firstName = param.firstName, credexConfig = param.credexConfig;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col",
        children: [
            firstName && credexConfig.bannerTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[14px] font-medium",
                children: (0,templateToJsx/* default */.Z)(credexConfig.bannerTitle, {
                    firstName: firstName
                })
            }),
            credexConfig.bannerSubTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[12px]",
                children: credexConfig.bannerSubTitle
            })
        ]
    });
};
/* harmony default export */ var CredexUserPromoBanner_CredexUserPromoBannerDefaultLabel = (CredexUserPromoBannerDefaultLabel);

;// CONCATENATED MODULE: ./components/CredexUserPromoBanner/CredexUserPromoBannerExtraInfoLabel.js


var CredexUserPromoBannerExtraInfoLabel = function(param) {
    var firstName = param.firstName, credexConfig = param.credexConfig, installmentValue = param.installmentValue;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col",
        children: [
            firstName && credexConfig && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[14px] font-medium",
                children: (0,templateToJsx/* default */.Z)(credexConfig.productPageLabel.userPromo, {
                    firstName: firstName,
                    promoRates: credexConfig.promoRates,
                    promoInterest: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: credexConfig.promoInterest
                    }),
                    installmentValue: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: installmentValue
                    })
                })
            }),
            credexConfig.bannerSubTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[12px]",
                children: credexConfig.bannerSubTitle
            })
        ]
    });
};
/* harmony default export */ var CredexUserPromoBanner_CredexUserPromoBannerExtraInfoLabel = (CredexUserPromoBannerExtraInfoLabel);

;// CONCATENATED MODULE: ./components/CredexUserPromoBanner/index.js





var ref = (0,config["default"])(), settings = ref.publicRuntimeConfig.settings;
var layoutLabel = {
    default: CredexUserPromoBanner_CredexUserPromoBannerDefaultLabel,
    extraInfo: CredexUserPromoBanner_CredexUserPromoBannerExtraInfoLabel
};
// Bussiness has revoked credex modal. Development code is not finished but kept for future reference.
var CredexUserPromoBanner = function(param) {
    var _layout = param.layout, layout = _layout === void 0 ? "default" : _layout, customer = param.customer, installmentValue = param.installmentValue, credexConfig = param.credexConfig;
    var LabelComponent = layoutLabel[layout];
    if (!credexConfig || !customer) {
        return null;
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative flex items-center justify-between gap-[8px] overflow-hidden rounded-[4px] text-white bg-cover bg-top bg-no-repeat px-[16px] py-[12px]",
        role: "region",
        "aria-label": "informational-banner",
        style: {
            backgroundImage: "url(".concat(settings.websiteStatics, "/images/credex/credex-customer-promo.png)")
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "z-[2]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelComponent, {
                firstName: customer === null || customer === void 0 ? void 0 : customer.first_name,
                credexConfig: credexConfig,
                installmentValue: installmentValue
            })
        })
    }));
};
/* harmony default export */ var components_CredexUserPromoBanner = ((0,es/* connect */.$j)(function(state) {
    return {
        customer: state.user.customer,
        credexConfig: state.credex.data
    };
})(CredexUserPromoBanner));


/***/ }),

/***/ 7708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);


var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_1__["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteName = _publicRuntimeConfig.settings.websiteName;
var ArrowRight = function(param) {
    var _width = param.width, width = _width === void 0 ? "8" : _width, _height = param.height, height = _height === void 0 ? "13" : _height;
    return websiteName === "bricostore" ? // Material Design "chevron_right" (Apache-2.0). viewBox cropped to the glyph bounding box
    // so it fills the width/height box like the original icon. Color via currentColor.
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "8.59 6 7.41 12",
        fill: "currentColor",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6Z"
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "#000",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M1.4 0 .7.7l5.6 5.7L.6 12l.7.7L7 7.1l.7-.7-.7-.7L1.4 0Z"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArrowRight);


/***/ }),

/***/ 22202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);


var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_1__["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteName = _publicRuntimeConfig.settings.websiteName;
var DeliveryIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? "16px" : _width, _height = param.height, height = _height === void 0 ? "16px" : _height;
    return websiteName === "bricostore" ? // Material UI icons "LocalShippingOutlined" (24x24, Apache-2.0). Color via currentColor.
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zm-.5 1.5 1.96 2.5H17V9.5h2.5zM6 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2.22-3c-.55-.61-1.33-1-2.22-1s-1.67.39-2.22 1H3V6h12v9H8.22zM18 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 16 16",
        width: width,
        height: height,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M8 8H2v1h6V8ZM6 5.5H1v1h5v-1Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "m14.96 8.3-1.5-3.5a.5.5 0 0 0-.46-.3h-1.5v-1A.5.5 0 0 0 11 3H3v1h7.5v6.28a2 2 0 0 0-.93 1.22H6.43a2 2 0 1 0 0 1h3.14a1.99 1.99 0 0 0 3.86 0h1.07a.5.5 0 0 0 .5-.5V8.5a.5.5 0 0 0-.04-.2ZM4.5 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm7-7.5h1.17L13.74 8H11.5V5.5Zm0 7.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm2.5-1.5h-.57A2 2 0 0 0 11.5 10V9H14v2.5Z"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DeliveryIcon);


/***/ }),

/***/ 10177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11752);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_2__["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteStatics = _publicRuntimeConfig.settings.websiteStatics;
// TODO replace with site wide fallback
var DEFAULT_FALLBACK = "".concat(websiteStatics, "/images/benefits-placeholder.svg");
// onError is not fired sometimes because of next.js, so this may fail sometimes
var ImageWithFallback = function(props) {
    var fallback = props.fallback || DEFAULT_FALLBACK;
    var src = props.src || fallback;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", _objectSpread({}, props, {
        src: src,
        onError: function(e) {
            return e.target.src = fallback;
        }
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageWithFallback);


/***/ }),

/***/ 23409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26209);
/* harmony import */ var _components_Modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12280);
/* harmony import */ var _containers_Account_LoginForm__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77485);
/* harmony import */ var _store_app_actions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27173);





var LoginModal = function(param) {
    var addModal1 = param.addModal, location = param.location, modalId = param.modalId, registerModalId = param.registerModalId, resetPassModalId = param.resetPassModalId, redirect = param.redirect;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Modal__WEBPACK_IMPORTED_MODULE_2__["default"], {
        id: modalId,
        header: "Intra in cont",
        size: "small",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_Account_LoginForm__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                recoverPassInModal: true,
                location: location,
                registerModalId: registerModalId,
                resetPassModalId: resetPassModalId,
                redirect: redirect
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    type: "button",
                    onClick: function() {
                        return addModal1(registerModalId);
                    },
                    className: "text-sm text-red-brand hover:text-bleu-hover underline",
                    children: "Creeaza cont nou"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .connect */ .$j)(null, {
    addModal: _store_app_actions__WEBPACK_IMPORTED_MODULE_4__/* .addModal */ .Y_
})(LoginModal));


/***/ }),

/***/ 5625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lib_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15722);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11752);




var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_3__["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteName = _publicRuntimeConfig.settings.websiteName;
var isBricoStore = websiteName === "bricostore";
// bricostore-only pagination overrides (circular/pill shape + red active border); altex/MG untouched
// replace (not append) the radius so there's a single rounded-* class → no cascade conflict
var pageRadius = isBricoStore ? "rounded-full" : "rounded-md";
var activePageClass = isBricoStore ? "bg-red-brand text-white border-red-brand" : "bg-alertRed text-white";
var Pagination = function(param) {
    var pages = param.pages, goTo = param.goTo, activePage = param.activePage, _meta = param.meta, meta = _meta === void 0 ? {} : _meta, _showMeta = param.showMeta, showMeta = _showMeta === void 0 ? false : _showMeta, _alignment = param.alignment, alignment = _alignment === void 0 ? "justify-end" : _alignment;
    if (!pages || !goTo || !activePage || pages < 2) {
        return null;
    }
    var pagesArr = [];
    for(var index = 1; index <= pages; index++){
        pagesArr.push(index);
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "Toolbar flow-root",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-wrap items-center py-3 lg:pb-15px ".concat(alignment),
            children: [
                showMeta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "text-sm w-full text-center mb-20px sm:mb-0 sm:text-left sm:w-auto sm:block md:pr-2",
                    children: [
                        meta.limit * meta.page + 1,
                        " -",
                        (meta.page + 1) * meta.limit < meta.size ? meta.limit * (meta.page + 1) : meta.size,
                        " ",
                        "din ",
                        meta.size,
                        " de recenzii"
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                    type: "button",
                    className: "".concat(activePage == 1 ? "text-gray cursor-not-allowed pointer-events-none" : "", " inline-block py-1 px-2 mx-1 text-sm border border-gray-1100 ").concat(pageRadius, " items-center text-center bg-white"),
                    title: "Inapoi",
                    onClick: function(e) {
                        activePage > 1 ? goTo(activePage - 1) : e.preventDefault();
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "hidden md:inline-block",
                            children: "Pagina anterioara"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "Toolbar-previous md:hidden"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                    className: "flex justify-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                        className: "flex list-none m-0 p-0",
                        children: (0,_lib_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getPaginationInterval */ .CR)(pagesArr, activePage - 1).map(function(page, i) {
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                children: (page <= 20 || page === "...") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    defaultValue: activePage,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        type: "button",
                                        className: "\n                    mx-1 text-sm flex w-8 h-8 items-center justify-center border border-gray-1100 ".concat(pageRadius, "\n                    ").concat(page == activePage ? activePageClass : "bg-white", "\n                    ").concat(page == activePage || page == "..." ? "cursor-not-allowed pointer-events-none" : "", "\n                  "),
                                        onClick: function() {
                                            goTo(page);
                                        },
                                        children: page
                                    })
                                }, "".concat(page, "-").concat(i))
                            }, "fragment-".concat(page, "-").concat(i));
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                    type: "button",
                    className: "".concat(activePage == pages ? "text-gray cursor-not-allowed pointer-events-none" : "", " inline-block py-1 px-2 mx-1 text-sm border border-gray-1100 ").concat(pageRadius, " items-center text-center bg-white"),
                    title: "Inainte",
                    onClick: function(e) {
                        activePage != pages ? goTo(activePage + 1) : e.preventDefault();
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "hidden md:inline-block",
                            children: "Pagina urmatoare"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "Toolbar-next md:hidden"
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);


/***/ }),

/***/ 31485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProductsCompareTable_ProductsCompareTable; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./components/Ratings/index.js + 1 modules
var Ratings = __webpack_require__(57983);
// EXTERNAL MODULE: ./lib/helpers.js
var helpers = __webpack_require__(15722);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./components/Price/index.js + 1 modules
var Price = __webpack_require__(40641);
// EXTERNAL MODULE: ./containers/Catalog/Actions/AddToCart.js + 6 modules
var AddToCart = __webpack_require__(38973);
;// CONCATENATED MODULE: ./components/ProductsCompareTable/ProductsCompareTableProductCard.js







// TODO: We should use a standard product card
var ProductsCompareTableProductCard = function(param) {
    var product = param.product, onClick = param.onClick;
    var isResealed = (0,helpers/* productHelper */.gU)(product).isResealed;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative mt-0 lg:pt-12 pt-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                    href: "/".concat(product.url_key, "/cpd/").concat(product.sku, "/"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        title: product.name,
                        onClick: function() {
                            return onClick(product);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (0,helpers/* resizeImage */.tg)(product.thumbnail, "300x300"),
                            alt: product.name,
                            className: "mx-auto sm:w-120px mb-[36px]"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                    href: "/".concat(product.url_key, "/cpd/").concat(product.sku, "/"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: "Product-name truncate-3-lines text-sm min-h-[70px]",
                        title: product.name,
                        onClick: function() {
                            return onClick(product);
                        },
                        children: [
                            isResealed && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Resigilat:"
                            }),
                            product.name
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-[20px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Ratings/* default */.Z, {
                    reviewsCount: get_default()(product, "reviews_count", 0),
                    ratingSummary: get_default()(product, "reviews_value", null),
                    displayReviewsNo: true,
                    productUrl: "/".concat(product.url_key, "/cpd/").concat(product.sku, "/")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-end min-h-[66px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                    productId: parseInt(product.id),
                    price: product.price,
                    regularPrice: product.regular_price,
                    formatted: true,
                    discountType: product.discount_type,
                    size: "smaller"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCart/* default */.Z, {
                product: product,
                isCatalog: true
            })
        ]
    }));
};
/* harmony default export */ var ProductsCompareTable_ProductsCompareTableProductCard = (ProductsCompareTableProductCard);

;// CONCATENATED MODULE: ./components/ProductsCompareTable/lib.js
var getProductAttributeValue = function(attributeCode, product, groupName) {
    var value = "-";
    var group1 = product.info.groups.find(function(group) {
        return group.name === groupName;
    });
    if (group1) {
        var attribute = group1.attributes.find(function(at) {
            return at.attribute_code === attributeCode;
        });
        if (attribute) {
            value = attribute.value;
        }
    }
    return value;
};

// EXTERNAL MODULE: ./components/Icons/Close.js
var Close = __webpack_require__(30002);
;// CONCATENATED MODULE: ./components/ProductsCompareTable/ProductsCompareTable.js





var getProductCountClassNames = function(products) {
    return classnames_default()("grid grid-flow-col", {
        "grid-cols-[repeat(2,_minmax(200px,_50%))] md:grid-cols-[repeat(3,33.3%)] lg:grid-cols-[repeat(3,320px)]": products.length === 2,
        "grid-cols-[repeat(3,_minmax(200px,_33.3%))] lg:grid-cols-[repeat(4,25%)]": products.length === 3,
        "grid-cols-[repeat(4,_minmax(200px,_25%))] lg:grid-cols-[repeat(5,20%)]": products.length === 4
    });
};
var getProductCardContainerClassNames = function(productIndex) {
    var isFirstProduct = productIndex === 0;
    return classnames_default()("border-gray-1100 px-3", {
        "border-l border-r border-t border-b md:border-r md:border-t md:border-b md:border-l": isFirstProduct,
        "border-t border-b border-r md:border-t md:border-b md:border-r": !isFirstProduct
    });
};
var getProductAttributeClassNames = function(attributeIndex, attributesLength, productIndex) {
    var isFirstRow = attributeIndex === 0;
    var isEvenRow = attributeIndex % 2 === 0;
    var isFirstColumn = productIndex === 0;
    var isLastRow = attributeIndex === attributesLength - 1;
    return classnames_default()("border-gray-1100 border-l border-r border-t border-b", {
        "bg-gray-lighter": isEvenRow,
        "bg-white": !isEvenRow,
        "border-t md:border-t": isFirstRow,
        "md:border-t-0": !isFirstRow,
        "md:border-b-0": !isLastRow,
        "md:border-b": isLastRow,
        "md:border-l-0": !isFirstColumn,
        "border-l-0": !isFirstColumn
    });
};
var ProductsCompareTable = function(param) {
    var products = param.products, productsAttributeGroups = param.productsAttributeGroups, onProductRemove = param.onProductRemove, _canRemove = param.canRemove, canRemove = _canRemove === void 0 ? true : _canRemove, onProductClick = param.onProductClick;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "overflow-x-scroll",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()({
                "min-w-[400px] md:min-w-auto": products.length === 2,
                "min-w-[600px]": products.length === 3,
                "min-w-[800px] lg:min-w-auto": products.length === 4
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: getProductCountClassNames(products),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("hidden", {
                                "md:block": products.length === 2,
                                "lg:block": products.length > 2
                            })
                        }),
                        products.map(function(product, productIndex) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                className: "relative ".concat(getProductCardContainerClassNames(productIndex)),
                                children: [
                                    canRemove && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "absolute top-2 right-2 z-10 p-1 block appearance-none bg-transparent text-gray-light",
                                        onClick: function() {
                                            return onProductRemove(product.sku);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                            width: "15px",
                                            height: "15px"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsCompareTable_ProductsCompareTableProductCard, {
                                        product: product,
                                        onRemove: onProductRemove,
                                        onClick: onProductClick
                                    })
                                ]
                            }, product.sku);
                        })
                    ]
                }),
                productsAttributeGroups && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-6",
                    children: productsAttributeGroups.map(function(group) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                            className: "mb-12",
                            children: [
                                group.name && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()(// bd-claim: Macan Stencil first letter (Brico only; no-op for altex/MG)
                                    "lg:pb-1 text-xl lg:text-2xl text-red-brand break-words bd-claim", {
                                        "min-w-[400px]": products.length === 2
                                    }),
                                    children: group.name
                                }),
                                group.attributes.map(function(attribute, attributeIndex) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-2 mb-3 md:mt-0 md:mb-0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classnames_default()("text-sm break-words mb-2", {
                                                    "min-w-[400px] md:hidden": products.length === 2,
                                                    "lg:hidden": products.length > 2
                                                }),
                                                children: attribute.label
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: getProductCountClassNames(products),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "pt-3 pb-1 hidden md:block",
                                                        children: attribute.label
                                                    }),
                                                    products.map(function(product, productIndex) {
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                            className: "p-3 text-sm break-words ".concat(getProductAttributeClassNames(attributeIndex, group.attributes.length, productIndex)),
                                                            children: getProductAttributeValue(attribute.attribute_code, product, group.name)
                                                        }, product.sku);
                                                    })
                                                ]
                                            })
                                        ]
                                    }, attribute.attribute_code);
                                })
                            ]
                        }, group.name);
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var ProductsCompareTable_ProductsCompareTable = (ProductsCompareTable);


/***/ }),

/***/ 30866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_PromoToasts; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./components/Alert.js + 10 modules
var Alert = __webpack_require__(16479);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./lib/api/helpers.js
var helpers = __webpack_require__(45963);
// EXTERNAL MODULE: ./lib/api/index.js
var api = __webpack_require__(2642);
// EXTERNAL MODULE: ./lib/clientStore.js
var clientStore = __webpack_require__(66208);
;// CONCATENATED MODULE: ./components/PromoToasts/useToasts.js





function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var LOCAL_EXPIRATION_DURATION = 86400000;
// generate localstorage key
var getLocalStoreKey = function(toastId) {
    return "promo-toast-".concat(toastId);
};
var useToasts = function(param) {
    var type = param.type, params = param.params, userInitial = param.userInitial, setPromoToastVisible = param.setPromoToastVisible;
    var ref1 = (0,react.useState)(null), toast = ref1[0], setToast = ref1[1];
    (0,react.useEffect)(function() {
        var initialize = function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                var ref, res, serverToast, localStoreKey, isLocalDismissed;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            _ctx.next = 3;
                            return (0,helpers/* makeApiCall */.Vo)({
                                apiArgs: [
                                    _objectSpread({}, params, {
                                        type: type
                                    })
                                ],
                                apiCall: api/* getPromoNotificationsApi */.H6W,
                                returnResponse: true
                            });
                        case 3:
                            res = _ctx.sent;
                            if ((res === null || res === void 0 ? void 0 : res.ok) && (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref[0])) {
                                serverToast = res.data[0];
                                localStoreKey = getLocalStoreKey(serverToast.id);
                                isLocalDismissed = clientStore/* localClientStore.get */.C.get(localStoreKey);
                                if (!isLocalDismissed) {
                                    setToast(serverToast);
                                }
                            }
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function initialize() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!userInitial && (type === "homepage" || type === "category" && (params === null || params === void 0 ? void 0 : params.categoryId) || type === "product" && (params === null || params === void 0 ? void 0 : params.sku))) {
            initialize();
        }
    }, [
        type,
        params,
        userInitial
    ]);
    (0,react.useEffect)(function() {
        if (toast) {
            setPromoToastVisible(true);
        } else {
            setPromoToastVisible(false);
        }
        return function() {
            return setPromoToastVisible(false);
        };
    }, [
        toast,
        setPromoToastVisible
    ]);
    var setToastRead = function(id) {
        // localstorage key for current toast
        var localStoreKey = getLocalStoreKey(id);
        var expiration = new Date().getTime() + LOCAL_EXPIRATION_DURATION;
        // set the new dismissed toast in localstorage
        clientStore/* localClientStore.set */.C.set(localStoreKey, "dismissed", expiration);
        setToast(null);
    };
    return {
        toast: toast,
        setToastRead: setToastRead
    };
};
/* harmony default export */ var PromoToasts_useToasts = (useToasts);

// EXTERNAL MODULE: ./store/app/actions.js
var actions = __webpack_require__(27173);
;// CONCATENATED MODULE: ./components/PromoToasts/index.js








var ref = (0,config["default"])(), settings = ref.publicRuntimeConfig.settings;
var PromoToasts = function(param) {
    var type = param.type, params = param.params, user = param.user, setPromoToastVisible1 = param.setPromoToastVisible, userDismissedNewsletter = param.userDismissedNewsletter;
    var ref1 = PromoToasts_useToasts({
        type: type,
        params: params,
        userInitial: user.isInitial,
        setPromoToastVisible: setPromoToastVisible1
    }), toast = ref1.toast, setToastRead = ref1.setToastRead;
    if (!toast) {
        return null;
    }
    // TODO add a way to update redux state for the user to dismiss the newsletter popup
    var isCookieConsentPopupVisible = Boolean(!clientStore/* cookieClientStore.get */.u.get("CookieConsent"));
    var isNewsletterPopupVisible = !userDismissedNewsletter;
    var positionClasses = classnames_default()("fixed z-10 right-0 sm:right-[15px] max-w-[420px] min-w-[320px] space-y-2", {
        // all are visible
        "bottom-0 sm:bottom-[100px] xl:bottom-[290px]": isNewsletterPopupVisible && isCookieConsentPopupVisible,
        // only cookies are visible
        "bottom-2 xl:bottom-[200px]": !isNewsletterPopupVisible && isCookieConsentPopupVisible,
        // only newsletter is visible
        "bottom-0 sm:bottom-[100px] xl:bottom-[100px]": isNewsletterPopupVisible && !isCookieConsentPopupVisible,
        // none are visible
        "bottom-0 sm:bottom-[8px]": !isNewsletterPopupVisible && !isCookieConsentPopupVisible
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: positionClasses,
        children: toast && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
            type: "blank",
            hasShadow: true,
            onClose: function() {
                return setToastRead(toast.id);
            },
            showIcon: !!(toast === null || toast === void 0 ? void 0 : toast.image),
            image: {
                src: "".concat(settings.cdn, "/media/label/image").concat(toast === null || toast === void 0 ? void 0 : toast.image),
                alt: toast.title
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-sm mr-[8px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-red-brand font-medium",
                        children: toast.title
                    }),
                    (toast === null || toast === void 0 ? void 0 : toast.coupon_code) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "Cod:",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                className: "font-medium",
                                children: toast.coupon_code
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: toast.description
                    }),
                    (toast === null || toast === void 0 ? void 0 : toast.url_link) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "text-[#0F62FE] underline",
                            href: toast.url_link,
                            children: toast.url_text || "Detalii"
                        })
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ var components_PromoToasts = ((0,es/* connect */.$j)(function(state) {
    return {
        user: state.user,
        userDismissedNewsletter: state.app.userDismissedNewsletter
    };
}, {
    setPromoToastVisible: actions/* setPromoToastVisible */.CA
})(PromoToasts));


/***/ }),

/***/ 70187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26209);
/* harmony import */ var _components_Modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12280);
/* harmony import */ var _containers_Account_RegisterForm__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84266);
/* harmony import */ var _store_app_actions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27173);





var RegisterModal = function(param) {
    var modalId = param.modalId, addModal1 = param.addModal, loginModalId = param.loginModalId;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Modal__WEBPACK_IMPORTED_MODULE_2__["default"], {
        id: modalId,
        header: "Creeaza cont nou",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_Account_RegisterForm__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                hasGrid: true,
                redirect: false
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    type: "button",
                    onClick: function() {
                        return addModal1(loginModalId);
                    },
                    className: "text-sm text-red-brand hover:text-bleu-hover underline",
                    children: "Intra in cont"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .connect */ .$j)(null, {
    addModal: _store_app_actions__WEBPACK_IMPORTED_MODULE_4__/* .addModal */ .Y_
})(RegisterModal));


/***/ }),

/***/ 16586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_final_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66688);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26209);
/* harmony import */ var _components_Modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12280);
/* harmony import */ var _store_app_actions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27173);
/* harmony import */ var _store_user_actions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49865);
/* harmony import */ var _components_Form_InputText__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(58833);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52077);
/* harmony import */ var _lib_validations__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(38294);











function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var ResetPassModal = /*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(ResetPassModal, Component1);
    var _super = _createSuper(ResetPassModal);
    function ResetPassModal(props) {
        _classCallCheck(this, ResetPassModal);
        var _this;
        _this = _super.call(this, props);
        var _this1 = _assertThisInitialized(_this);
        _defineProperty(_assertThisInitialized(_this), "submitRecover", function() {
            var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(values) {
                var formSubmitResponse;
                return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return _this1.props.recoverUserPassword({
                                email: values.email
                            });
                        case 2:
                            formSubmitResponse = _ctx.sent;
                            if (formSubmitResponse) {
                                _this1.setState({
                                    recoverSuccess: true
                                });
                            }
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }());
        _this.state = {
            recoverSuccess: false
        };
        return _this;
    }
    _createClass(ResetPassModal, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_Modal__WEBPACK_IMPORTED_MODULE_5__["default"], {
                    id: this.props.modalId,
                    header: "Recuperare parola",
                    size: "small",
                    children: [
                        !this.state.recoverSuccess && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                    className: "mb-4 text-sm",
                                    children: "Introdu adresa de e-mail folosita la crearea contului si iti vom trimite indicatii pentru recuperarea parolei"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_3__/* .Form */ .l0, {
                                    onSubmit: this.submitRecover,
                                    initialValues: {
                                        email: this.state.email ? this.state.email : ""
                                    },
                                    render: function(param) {
                                        var handleSubmit = param.handleSubmit, submitting = param.submitting;
                                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
                                            onSubmit: handleSubmit,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_3__/* .Field */ .gN, {
                                                    name: "email",
                                                    type: "email",
                                                    label: "Introdu adresa de email",
                                                    autoComplete: "username",
                                                    component: _components_Form_InputText__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
                                                    required: true,
                                                    validate: (0,_lib_validations__WEBPACK_IMPORTED_MODULE_10__/* .composeFormValidators */ .JT)((0,_lib_validations__WEBPACK_IMPORTED_MODULE_10__/* .isRequired */ .q9)(), (0,_lib_validations__WEBPACK_IMPORTED_MODULE_10__/* .isEmail */ .Jh)(), (0,_lib_validations__WEBPACK_IMPORTED_MODULE_10__/* .hasMaxLength */ .aG)(80))
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: "mt-6 mb-2",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                        title: "Recupereaza parola",
                                                        display: "block",
                                                        variant: "primary",
                                                        type: "submit",
                                                        disabled: submitting
                                                    })
                                                })
                                            ]
                                        });
                                    }
                                })
                            ]
                        }),
                        this.state.recoverSuccess && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                    className: "m-0 mb-4",
                                    children: "Instructiunile pentru recuperarea parolei au fost trimise catre adresa ta de e-mail. Daca nu primesti mesajul in cateva minute, te rugam verifica si in folderele Spam/Junk."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "text-center pt-3 text-sm",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                        className: "text-red-brand hover:text-bleu-hover underline",
                                        onClick: function() {
                                            _this.props.removeModal();
                                            _this.setState({
                                                recoverSuccess: false
                                            });
                                        },
                                        children: "Inapoi"
                                    })
                                })
                            ]
                        })
                    ]
                }));
            }
        }
    ]);
    return ResetPassModal;
}(react__WEBPACK_IMPORTED_MODULE_2__.Component);
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .connect */ .$j)(null, {
    removeModal: _store_app_actions__WEBPACK_IMPORTED_MODULE_6__/* .removeModal */ .a_,
    addModal: _store_app_actions__WEBPACK_IMPORTED_MODULE_6__/* .addModal */ .Y_,
    recoverUserPassword: _store_user_actions__WEBPACK_IMPORTED_MODULE_7__/* .recoverUserPassword */ .oz
})(ResetPassModal));


/***/ }),

/***/ 56055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useElementSize = function(setElementSize) {
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), height = ref3[0], setHeight = ref3[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), width = ref1[0], setWidth = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var setElementRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(element) {
        return ref2.current = element;
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (ref2.current) {
            var callback = function(entries) {
                entries.forEach(function(entry) {
                    var ref;
                    if ((ref = entry.borderBoxSize) === null || ref === void 0 ? void 0 : ref[0]) {
                        var newHeight = entry.borderBoxSize[0].blockSize;
                        var newWidth = entry.borderBoxSize[0].inlineSize;
                        if (height !== newHeight || width !== newWidth) {
                            setElementSize({
                                height: newHeight,
                                width: newWidth
                            });
                            setHeight(newHeight);
                            setWidth(newWidth);
                        }
                    }
                });
            };
            try {
                var observer = new ResizeObserver(callback);
                observer.observe(ref2.current);
                return function() {
                    return observer.disconnect();
                };
            } catch (error) {
            // No Resize Observer
            }
        }
    }, [
        ref2,
        setElementSize
    ]);
    return setElementRef;
};
/* harmony default export */ __webpack_exports__["Z"] = (useElementSize);


/***/ }),

/***/ 44956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _productSku_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./components/withRouterPageLayout.js
var withRouterPageLayout = __webpack_require__(61167);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./lib/helpers.js
var helpers = __webpack_require__(15722);
// EXTERNAL MODULE: ./store/tracker/actions.js + 1 modules
var actions = __webpack_require__(48712);
// EXTERNAL MODULE: ./store/catalog/actions.js
var catalog_actions = __webpack_require__(35493);
// EXTERNAL MODULE: ./store/app/actions.js
var app_actions = __webpack_require__(27173);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./lib/useOnScreen.js

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var useOnScreen = function(param1) {
    var ref = param1.ref, _scrollDirection = param1.scrollDirection, scrollDirection = _scrollDirection === void 0 ? undefined : _scrollDirection, _bounds = param1.bounds, bounds = _bounds === void 0 ? false : _bounds, _root = param1.root, root = _root === void 0 ? null : _root, _rootMargin = param1.rootMargin, rootMargin = _rootMargin === void 0 ? "0px" : _rootMargin, _threshold = param1.threshold, threshold = _threshold === void 0 ? [
        0
    ] : _threshold;
    var ref1 = (0,react.useState)(!Array.isArray(ref) || []), isIntersecting = ref1[0], setIntersecting = ref1[1];
    var observerCallback = function(param) {
        var _param = _slicedToArray(param, 1), entry = _param[0];
        if (!Array.isArray(ref)) setIntersecting(entry.isIntersecting);
        else {
            setTimeout(function() {
                setIntersecting(function(previous) {
                    if (entry.isIntersecting) {
                        switch(scrollDirection){
                            case "down":
                                return !previous.includes(entry.target.id) ? [
                                    entry.target.id
                                ].concat(_toConsumableArray(previous)) : previous;
                            case "up":
                                return !previous.includes(entry.target.id) ? _toConsumableArray(previous).concat([
                                    entry.target.id
                                ]) : previous;
                            default:
                                return previous;
                        }
                    } else return previous.filter(function(element) {
                        return element !== entry.target.id;
                    });
                });
            }, 0);
        }
    };
    (0,react.useEffect)(function() {
        if (bounds) setIntersecting([]);
    }, [
        bounds
    ]);
    (0,react.useEffect)(function() {
        var observer = new IntersectionObserver(observerCallback, {
            root: document.querySelector(root),
            rootMargin: rootMargin,
            threshold: threshold
        });
        if (!Array.isArray(ref)) {
            if (ref.current) {
                observer.observe(ref.current);
            }
        } else {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = ref[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var element = _step.value;
                    if (element.current) {
                        observer.observe(element.current);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        return function() {
            observer.disconnect();
        };
    }, []);
    return isIntersecting;
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./components/Ratings/Stars.js + 1 modules
var Stars = __webpack_require__(86182);
;// CONCATENATED MODULE: ./components/ProductPage/ProductPageHeaderRatings.js




var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteName = _publicRuntimeConfig.settings.websiteName;
var isBricoStore = websiteName === "bricostore";
var ProductPageHeaderRatings = function(param) {
    var onClick = param.onClick, reviewsCount = param.reviewsCount, ratingSummary = param.ratingSummary, productUrl = param.productUrl;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center sm:w-auto truncate",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: isBricoStore ? "" : "mr-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stars/* default */.Z, {
                    percentage: ratingSummary && reviewsCount && parseFloat((ratingSummary / reviewsCount * 100 / 5).toFixed(0)),
                    width: "86px"
                })
            }),
            Boolean(ratingSummary) && Boolean(reviewsCount) && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                href: "".concat(productUrl, "#reviews"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: "ml-[4px] leading-none text-sm truncate cursor-pointer inline-flex gap-[2px]",
                    onClick: onClick,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                parseFloat(ratingSummary / reviewsCount).toFixed(isBricoStore ? 1 : 2),
                                isBricoStore && "/5"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "text-[#737373]",
                            children: [
                                "(",
                                reviewsCount,
                                " ",
                                reviewsCount === 1 ? "recenzie" : "recenzii",
                                ")"
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ProductPage_ProductPageHeaderRatings = (ProductPageHeaderRatings);

// EXTERNAL MODULE: ./components/Ratings/index.js + 1 modules
var Ratings = __webpack_require__(57983);
;// CONCATENATED MODULE: ./components/Ratings/NoRatingsDataPlaceholder.js




var NoRatingsDataPlaceholder_ref = (0,config["default"])(), NoRatingsDataPlaceholder_publicRuntimeConfig = NoRatingsDataPlaceholder_ref.publicRuntimeConfig, NoRatingsDataPlaceholder_websiteName = NoRatingsDataPlaceholder_publicRuntimeConfig.settings.websiteName;
var NoRatingsDataPlaceholder = function(param) {
    var productUrl = param.productUrl, onClick = param.onClick;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("span", {
        className: "flex items-center sm:w-auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
            href: "".concat(productUrl, "#reviews"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                onClick: onClick,
                href: "#reviews",
                className: classnames_default()("leading-none text-red-brand md:text-base text-sm", {
                    "text-[#1D4ED8]": NoRatingsDataPlaceholder_websiteName !== "bricostore",
                    "text-orange": NoRatingsDataPlaceholder_websiteName === "bricostore"
                }),
                children: "Fii primul care evalueaza acest produs"
            })
        })
    });
};
/* harmony default export */ var Ratings_NoRatingsDataPlaceholder = (NoRatingsDataPlaceholder);

;// CONCATENATED MODULE: ./components/ProductPage/ProductLabels.js



var ProductLabels_ref = (0,config["default"])(), settings = ProductLabels_ref.publicRuntimeConfig.settings;
var ProductLabels = function(param) {
    var labels = param.labels;
    var mesajeTextLabels = [];
    if (labels.text && labels.text["altex_packageproduct/label"]) {
        mesajeTextLabels.push({
            text: labels.text["altex_packageproduct/label"].values
        });
    }
    if (labels.text && labels.text["altex_vouchercampaigns/label"]) {
        mesajeTextLabels.push(labels.text["altex_vouchercampaigns/label"].values);
    }
    if (labels.link && labels.link["altex_label/rule_action_type_cmsPage"] && labels.text && labels.text["altex_label/rule_action_type_text"]) {
        mesajeTextLabels.push({
            text: labels.text["altex_label/rule_action_type_text"].values,
            link: labels.link["altex_label/rule_action_type_cmsPage"].values
        });
    }
    if (!labels.link && labels.text && labels.text["altex_label/rule_action_type_text"]) {
        mesajeTextLabels.push({
            text: labels.text["altex_label/rule_action_type_text"].values
        });
    }
    var mesajeLabels = mesajeTextLabels.length > 0 ? true : false;
    var labelText = function() {
        if (mesajeTextLabels.length > 0) {
            return mesajeTextLabels.map(function(thisText, pos) {
                if (thisText.link) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "".concat(settings.baseUrl, "/").concat(thisText.link, "/pag/"),
                            children: thisText.text
                        })
                    }, pos));
                } else {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: thisText.text
                    }, pos));
                }
            });
        }
        return null;
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: mesajeLabels && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "absolute top-0 right-0 px-2 text-center rounded-bl font-semibold text-xs bg-primary text-black",
            style: {
                borderTopRightRadius: "3px"
            },
            children: labelText()
        })
    }));
};
/* harmony default export */ var ProductPage_ProductLabels = (ProductLabels);

// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(89734);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./components/ProductMedia/GalleryLightbox.js



var GalleryLightbox = function(param) {
    var active = param.active, children = param.children, onCloseRequest = param.onCloseRequest, drop = param.drop, setDrop = param.setDrop;
    var handleContentAreaClick = function(event) {
        event.preventDefault();
        // Request lightbox close when
        // clicking lightbox content but not on content
        if (event.target === event.currentTarget) {
            onCloseRequest();
        }
    };
    var renderChildren = function() {
        // Clone each child and pass onCloseRequest props
        return react.Children.map(children, function(child) {
            return(/*#__PURE__*/ (0,react.cloneElement)(child, {
                onCloseRequest: onCloseRequest
            }));
        });
    };
    (0,react.useEffect)(function() {
        if (drop) {
            var handleKeyDown = function(event) {
                if (event.key === "Escape" && drop) {
                    onCloseRequest();
                }
            };
            document.addEventListener("keydown", handleKeyDown);
            return function() {
                return document.removeEventListener("keydown", handleKeyDown);
            };
        }
    }, [
        drop
    ]);
    (0,react.useEffect)(function() {
        if (active) setDrop(true);
        // ? Setting overflow hidden this way prevents the undelying page to scroll to the top when activated
        if (active) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "unset";
        return function() {
            document.body.style.overflow = "unset";
        };
    }, [
        active
    ]);
    return active && /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fixed top-0 left-0 flex flex-col items-center justify-center transform transition-all duration-150 w-full h-full z-[2100] ".concat(drop ? "bg-black/80 backdrop-blur-sm" : "bg-transparent delay-300"),
        onClick: handleContentAreaClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "fixed top-0 left-0 w-full h-full flex flex-col transform transition-all duration-300 ease-in-out space-y-4 bg-white py-2 rounded-b-lg ".concat(drop ? "translate-y-0 delay-150" : "-translate-y-[100%]"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cursor-pointer absolute right-4 z-[2]",
                    onClick: onCloseRequest,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        width: "30",
                        height: "30",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            stroke: "rgb(0, 0, 0)",
                            strokeWidth: "3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                                    x1: "5",
                                    y1: "5",
                                    x2: "25",
                                    y2: "25"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                                    x1: "5",
                                    y1: "25",
                                    x2: "25",
                                    y2: "5"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-grow justify-center w-full h-full overflow-y-auto",
                    children: renderChildren()
                })
            ]
        })
    }), document.body);
};
// TODO: Find a way to replace the body style from jsx to tailwind
/* harmony default export */ var ProductMedia_GalleryLightbox = (GalleryLightbox);

// EXTERNAL MODULE: ./node_modules/swiper/swiper-react.mjs + 3 modules
var swiper_react = __webpack_require__(2261);
// EXTERNAL MODULE: ./node_modules/swiper/modules/index.mjs + 27 modules
var modules = __webpack_require__(66832);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.css
var swiper = __webpack_require__(25194);
// EXTERNAL MODULE: ./node_modules/swiper/modules/zoom.css
var zoom = __webpack_require__(80615);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination.css
var pagination = __webpack_require__(18700);
// EXTERNAL MODULE: ./components/Icons/CarouselNavArrow.js
var CarouselNavArrow = __webpack_require__(57153);
// EXTERNAL MODULE: ./components/Icons/DotIcon.js
var DotIcon = __webpack_require__(60335);
;// CONCATENATED MODULE: ./components/ProductMedia/ProductGallery.js












var ProductGallery_ref = (0,config["default"])(), ProductGallery_settings = ProductGallery_ref.publicRuntimeConfig.settings;
var ProductGallery = function(param1) {
    var images = param1.images, title = param1.title, onSlideClick = param1.onSlideClick, onSlideChange = param1.onSlideChange, currentSlide = param1.currentSlide, setMasterSwiper = param1.setMasterSwiper;
    var singleSlide = images.length <= 1;
    var mainSwiper = (0,react.useRef)(null);
    var thumbSwiperRef = (0,react.useRef)(null);
    var firstMount = (0,react.useRef)(true);
    var ref4 = (0,react.useState)(true), isBeginning1 = ref4[0], setIsBeginning = ref4[1];
    var ref1 = (0,react.useState)(false), isEnd1 = ref1[0], setIsEnd = ref1[1];
    var ref2 = (0,react.useState)(null), prevEl = ref2[0], setPrevEl = ref2[1];
    var ref3 = (0,react.useState)(null), nextEl = ref3[0], setNextEl = ref3[1];
    (0,react.useEffect)(function() {
        if (mainSwiper.current) {
            setMasterSwiper(mainSwiper.current);
        }
    }, [
        mainSwiper.current
    ]);
    (0,react.useEffect)(function() {
        if ((mainSwiper === null || mainSwiper === void 0 ? void 0 : mainSwiper.current) && mainSwiper.current.activeIndex !== currentSlide) {
            mainSwiper.current.slideTo(currentSlide);
        }
        if ((thumbSwiperRef === null || thumbSwiperRef === void 0 ? void 0 : thumbSwiperRef.current) && thumbSwiperRef.current.activeIndex !== currentSlide) {
            thumbSwiperRef.current.slideTo(currentSlide);
        }
    }, [
        currentSlide
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col-reverse sm:flex-row gap-[24px] justify-around w-full relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "my-auto relative max-h-[440px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        className: "sm:h-[300px] my-auto max-w-[80px] sm:max-w-full sm:overflow-scroll sm:scrollbar-none",
                        direction: "vertical",
                        onSwiper: function(swiper) {
                            thumbSwiperRef.current = swiper;
                        },
                        loop: false,
                        initialSlide: currentSlide,
                        modules: [
                            modules/* Navigation */.W_,
                            modules/* Thumbs */.o3
                        ],
                        onSlideChange: function(param) {
                            var isBeginning = param.isBeginning, isEnd = param.isEnd, activeIndex = param.activeIndex;
                            setIsBeginning(isBeginning);
                            setIsEnd(isEnd);
                            if (firstMount.current) {
                                firstMount.current = false;
                            } else {
                                onSlideChange(activeIndex);
                            }
                        },
                        // loopAddBlankSlides={false}
                        breakpoints: {
                            0: {
                                direction: "horizontal",
                                slidesPerView: 5,
                                centeredSlides: true,
                                centeredSlidesBounds: false,
                                slidesPerGroup: 1,
                                spaceBetween: 0,
                                slideToClickedSlide: true
                            },
                            640: {
                                direction: "vertical",
                                slidesPerView: 5,
                                slidesPerGroup: 1,
                                centeredSlides: true,
                                centeredSlidesBounds: true,
                                resistanceRatio: 0,
                                spaceBetween: 0
                            }
                        },
                        children: images.map(function(image, index) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(swiper_react/* SwiperSlide */.o5, {
                                className: "h-full sm:!h-[60px] sm:w-[60px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()("sm:hidden flex items-center justify-center w-[20px] h-[20px]", {
                                            "text-[#C7C7C7]": currentSlide !== index,
                                            "text-black": currentSlide === index
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DotIcon/* default */.Z, {
                                            width: currentSlide === index ? "12px" : "6px",
                                            height: currentSlide === index ? "12px" : "6px",
                                            className: "transition-all duration-200"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "hidden sm:block p-[6px] rounded-bl-lg rounded-tr-lg cursor-pointer select-none ".concat(currentSlide === index ? "border border-yellow" : ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: (0,helpers/* resizeImage */.tg)(image.file, "50x50"),
                                            className: "block aspect-square object-contain select-none",
                                            alt: ""
                                        })
                                    })
                                ]
                            }, index);
                        })
                    }),
                    !singleSlide && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hidden sm:block absolute left-[50%] translate-x-[-50%] z-10 -top-[40px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviousButton, {
                                    setPrevEl: setPrevEl,
                                    isBeginning: isBeginning1
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hidden sm:block absolute left-[50%] translate-x-[-50%] z-10 -bottom-[40px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextButton, {
                                    setNextEl: setNextEl,
                                    isEnd: isEnd1
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                className: "w-full sm:w-[calc(100%-80px)] sm:min-h-[440px]",
                onSwiper: function(swiper) {
                    return mainSwiper.current = swiper;
                },
                initialSlide: currentSlide,
                slidesPerView: 1,
                spaceBetween: 10,
                loop: false,
                // lazy={true}
                keyboard: true,
                thumbs: {
                    swiper: thumbSwiperRef.current
                },
                modules: [
                    modules/* Thumbs */.o3,
                    modules/* Navigation */.W_,
                    modules/* Keyboard */.N1
                ],
                onSlideChange: function(param) {
                    var activeIndex = param.activeIndex, isBeginning = param.isBeginning, isEnd = param.isEnd;
                    onSlideChange(activeIndex);
                    setIsBeginning(isBeginning);
                    setIsEnd(isEnd);
                },
                navigation: {
                    nextEl: nextEl,
                    prevEl: prevEl
                },
                children: images.map(function(image, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        className: "cursor-pointer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "swiper-zoom-container mx-auto aspect-square w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                onClick: onSlideClick,
                                src: "".concat(ProductGallery_settings.cdn).concat(image.file),
                                alt: title
                            })
                        })
                    }, index);
                })
            })
        ]
    }));
};
var PreviousButton = function(param) {
    var setPrevEl = param.setPrevEl, isBeginning = param.isBeginning;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        ref: function(node) {
            return setPrevEl(node);
        },
        className: "w-8 h-8 rounded-full bg-[#EFF6FF] ".concat(isBeginning ? "opacity-50 cursor-default" : "opacity-90 cursor-pointer"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselNavArrow/* default */.Z, {
            direction: "up"
        })
    });
};
var NextButton = function(param) {
    var setNextEl = param.setNextEl, isEnd = param.isEnd;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        ref: function(node) {
            return setNextEl(node);
        },
        className: "w-8 h-8 rounded-full bg-[#EFF6FF] ".concat(isEnd ? "opacity-50 cursor-default" : "opacity-90 cursor-pointer"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselNavArrow/* default */.Z, {
            direction: "down"
        })
    });
};
/* harmony default export */ var ProductMedia_ProductGallery = (ProductGallery);

// EXTERNAL MODULE: ./components/ProductMedia/InLightboxGallery.js
var InLightboxGallery = __webpack_require__(51425);
;// CONCATENATED MODULE: ./components/ProductMedia/index.js







function ProductMedia_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ProductMedia_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return ProductMedia_arrayLikeToArray(arr);
}
function ProductMedia_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function ProductMedia_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ProductMedia_toConsumableArray(arr) {
    return ProductMedia_arrayWithoutHoles(arr) || ProductMedia_iterableToArray(arr) || ProductMedia_unsupportedIterableToArray(arr) || ProductMedia_nonIterableSpread();
}
function ProductMedia_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ProductMedia_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ProductMedia_arrayLikeToArray(o, minLen);
}
var ProductMedia_ref = (0,config["default"])(), ProductMedia_settings = ProductMedia_ref.publicRuntimeConfig.settings;
var ProductMedia = function(param) {
    var product = param.product;
    var name = product.name, altText = product.seo_alt_text, image = product.image, gallery = product.gallery;
    var ref4 = (0,react.useState)(0), currentGallerySlide = ref4[0], setCurrentGallerySlide = ref4[1];
    var ref1 = (0,react.useState)(false), isLightboxOpen = ref1[0], setIsLightboxOpen = ref1[1];
    var ref2 = (0,react.useState)(false), drop = ref2[0], setDrop = ref2[1];
    var ref3 = (0,react.useState)(), masterSwiper = ref3[0], setMasterSwiper = ref3[1];
    var toggleLightbox = function() {
        if (drop) {
            setDrop(false);
            setTimeout(function() {
                return setIsLightboxOpen(!isLightboxOpen);
            }, 450);
        } else {
            setIsLightboxOpen(!isLightboxOpen);
        }
    };
    var parseImageGallery = function() {
        var imageGallery = [];
        // Check if product image is available
        if (image) {
            var isImageinGallery = undefined;
            // Check if product image gallery is empty
            if (gallery && gallery.length > 0) {
                // Gallery not empty
                // Add gallery in imageGallery
                imageGallery = ProductMedia_toConsumableArray(gallery);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Find if image is in gallery
                    for(var _iterator = imageGallery[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var galleryImage = _step.value;
                        if (galleryImage.file === image) {
                            isImageinGallery = true;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            // If image is not in gallery add it at position 0
            if (!isImageinGallery) {
                imageGallery.push({
                    file: image,
                    position: 0
                });
            }
        } else {
            imageGallery.push({
                file: "".concat(ProductMedia_settings.websiteStatics, "/images/catalog/product/image.jpg"),
                position: 0
            });
        }
        // Sort image gallery by position
        var sortedGallery = sortBy_default()(imageGallery, "position");
        return sortedGallery;
    };
    // Forcing update on the slider outside the lightbox to keep them both
    // in sync while sliding from the lightbox modal
    (0,react.useEffect)(function() {
        if (masterSwiper === null || masterSwiper === void 0 ? void 0 : masterSwiper.current) {
            var currentIndex = masterSwiper.current.swiper.activeIndex;
            if (currentIndex !== currentGallerySlide) masterSwiper.current.swiper.slideTo(currentGallerySlide);
        }
    }, [
        currentGallerySlide
    ]);
    var imgGallery = parseImageGallery();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductMedia_ProductGallery, {
                title: altText || name,
                images: imgGallery,
                onSlideClick: toggleLightbox,
                onSlideChange: setCurrentGallerySlide,
                currentSlide: currentGallerySlide,
                setMasterSwiper: setMasterSwiper
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductMedia_GalleryLightbox, {
                active: isLightboxOpen,
                onCloseRequest: toggleLightbox,
                drop: drop,
                setDrop: setDrop,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InLightboxGallery/* default */.Z, {
                    title: altText || name,
                    images: imgGallery,
                    onSlideChange: setCurrentGallerySlide,
                    currentSlide: currentGallerySlide,
                    setDrop: setDrop
                })
            })
        ]
    }));
};
/* harmony default export */ var components_ProductMedia = (ProductMedia);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./components/ContentEditorView/index.js + 24 modules
var ContentEditorView = __webpack_require__(51961);
;// CONCATENATED MODULE: ./components/ScriptTag.js


function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
// TODO: Remove/simplify this
// This script is taken from react-script-tag
// https://github.com/adam-26/react-script-tag/tree/aaacd3180671a87404002afa874dbb86c36c0e7a
var noop = function() {};
var ScriptTag = /*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(ScriptTag, Component1);
    var _super = _createSuper(ScriptTag);
    function ScriptTag(props, context) {
        _classCallCheck(this, ScriptTag);
        var _this;
        _this = _super.call(this, props, context);
        _this.domRef = null;
        _this.state = {
            isHydrated: props.isHydrating,
            additionalNode: null,
            removeAdditionalNode: null
        };
        return _this;
    }
    _createClass(ScriptTag, [
        {
            key: "appendAdditionalElement",
            value: function appendAdditionalElement() {
                var _props = this.props, onError = _props.onError, onLoad = _props.onLoad, nonce = _props.nonce;
                // Create a new HTML script element
                var newElement = document.createElement("script");
                // Copy all attribute values
                for(var i = 0, len = this.domRef.attributes.length; i < len; i++){
                    var attr = this.domRef.attributes[i];
                    if (attr.nodeName === "nonce") {
                        // The browser clears the nonce value - grab from props
                        newElement.setAttribute(attr.nodeName, nonce);
                    } else {
                        newElement.setAttribute(attr.nodeName, attr.nodeValue);
                    }
                }
                // Copy the inner script
                if (this.domRef.src === "" && this.domRef.innerHTML && this.domRef.innerHTML !== "") {
                    newElement.innerHTML = this.domRef.innerHTML;
                }
                // Bind event listeners
                newElement.addEventListener("load", onLoad);
                newElement.addEventListener("error", onError);
                // Append the new script tag
                this.domRef.parentNode.appendChild(newElement);
                return newElement;
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var isHydrated = this.state.isHydrated;
                if (isHydrated) {
                    // was rendered on server, don't replace elements when hydrating
                    return;
                }
                this.setState({
                    additionalNode: this.appendAdditionalElement(),
                    removeAdditionalNode: null
                });
            }
        },
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                // This logic assumes that the <script> only need to be updated if the 'src' or 'innerHTML' has changed
                //  - this prevents the <script> from updating unnecessarily, which prevents additional 'onload' events
                // This isn't perfect - but it keeps the component very simple, and should cover most use-cases
                // Other props SHOULD be assigned at the same time as either the 'src' or 'innerHTML' property
                // -> If this is to change and support updating on ANY prop change, the 'appendAdditionalElement()' method
                //    and state management will need to be modified to manipulate the DOM script tag based on each prop change.
                //    This really complicates the component - for now we'll leave it as is.
                var _props = this.props, src = _props.src, dangerouslySetInnerHTML = _props.dangerouslySetInnerHTML;
                if (src && src === nextProps.src) {
                    // The 'src' attribute has not changed
                    return;
                }
                if (dangerouslySetInnerHTML && dangerouslySetInnerHTML.__html === nextProps.dangerouslySetInnerHTML.__html) {
                    // The 'dangerouslySetInnerHTML' attribute has not changed
                    return;
                }
                this.setState({
                    removeAdditionalNode: this.state.additionalNode,
                    additionalNode: null
                });
            }
        },
        {
            key: "UNSAFE_componentWillUpdate",
            value: function UNSAFE_componentWillUpdate(nextProps, nextState) {
                ScriptTag.removeNode(nextState.removeAdditionalNode);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _state = this.state, additionalNode = _state.additionalNode, removeAdditionalNode = _state.removeAdditionalNode;
                if (additionalNode === null) {
                    this.setState({
                        additionalNode: this.appendAdditionalElement()
                    });
                }
                if (removeAdditionalNode !== null) {
                    // Was removed in 'componentWillUpdate', but can not update state there
                    this.setState({
                        removeAdditionalNode: null
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                ScriptTag.removeNode(this.state.removeAdditionalNode);
                ScriptTag.removeNode(this.state.additionalNode);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var additionalNode = this.state.additionalNode;
                if (additionalNode !== null) {
                    return null;
                }
                // The 'isHydrating' prop must NOT be passed to the script tag
                // eslint-disable-next-line no-unused-vars
                var _props = this.props, isHydrating = _props.isHydrating, tagProps = _objectWithoutProperties(_props, [
                    "isHydrating"
                ]);
                return(/*#__PURE__*/ react.createElement("script", _objectSpread({}, tagProps, {
                    ref: function(tag) {
                        return _this.domRef = tag;
                    }
                })));
            }
        }
    ], [
        {
            key: "removeNode",
            value: function removeNode(node) {
                if (node) {
                    node.parentNode.removeChild(node);
                }
            }
        }
    ]);
    return ScriptTag;
}(react.Component);
_defineProperty(ScriptTag, "propTypes", {
    /**
     * True if the <ScriptTag> is being hydrated on the client, otherwise false.
     */ isHydrating: (prop_types_default()).bool,
    // Standard <script> tag props
    async: prop_types_default().oneOfType([
        (prop_types_default()).bool,
        (prop_types_default()).number
    ]),
    crossOrigin: (prop_types_default()).string,
    defer: (prop_types_default()).bool,
    integrity: (prop_types_default()).string,
    nonce: (prop_types_default()).string,
    src: (prop_types_default()).string,
    text: (prop_types_default()).string,
    type: (prop_types_default()).string,
    dangerouslySetInnerHTML: (prop_types_default()).object,
    // globals
    onError: (prop_types_default()).func,
    onLoad: (prop_types_default()).func
});
_defineProperty(ScriptTag, "defaultProps", {
    isHydrating: false,
    onError: noop,
    onLoad: noop
});
/* harmony default export */ var components_ScriptTag = (ScriptTag);

;// CONCATENATED MODULE: ./components/ProductPage/ProductDescription/FlixMediaProductDescription.js









function FlixMediaProductDescription_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function FlixMediaProductDescription_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function FlixMediaProductDescription_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function FlixMediaProductDescription_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) FlixMediaProductDescription_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) FlixMediaProductDescription_defineProperties(Constructor, staticProps);
    return Constructor;
}
function FlixMediaProductDescription_getPrototypeOf(o) {
    FlixMediaProductDescription_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return FlixMediaProductDescription_getPrototypeOf(o);
}
function FlixMediaProductDescription_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) FlixMediaProductDescription_setPrototypeOf(subClass, superClass);
}
function FlixMediaProductDescription_possibleConstructorReturn(self, call) {
    if (call && (FlixMediaProductDescription_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return FlixMediaProductDescription_assertThisInitialized(self);
}
function FlixMediaProductDescription_setPrototypeOf(o, p) {
    FlixMediaProductDescription_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return FlixMediaProductDescription_setPrototypeOf(o, p);
}
var FlixMediaProductDescription_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function FlixMediaProductDescription_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function FlixMediaProductDescription_createSuper(Derived) {
    var hasNativeReflectConstruct = FlixMediaProductDescription_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = FlixMediaProductDescription_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = FlixMediaProductDescription_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return FlixMediaProductDescription_possibleConstructorReturn(this, result);
    };
}
var FlixMediaProductDescription_ref = (0,config["default"])(), contentProviders = FlixMediaProductDescription_ref.publicRuntimeConfig.contentProviders;
var FlixMediaProductDescription = /*#__PURE__*/ function(Component1) {
    "use strict";
    FlixMediaProductDescription_inherits(FlixMediaProductDescription, Component1);
    var _super = FlixMediaProductDescription_createSuper(FlixMediaProductDescription);
    function FlixMediaProductDescription() {
        FlixMediaProductDescription_classCallCheck(this, FlixMediaProductDescription);
        return _super.apply(this, arguments);
    }
    FlixMediaProductDescription_createClass(FlixMediaProductDescription, [
        {
            // handleOnLoad = () => {
            //   if (typeof flixJsCallbacks === "object") {
            //     window.flixJsCallbacks.setLoadCallback(function() {
            //       try {
            //         document.getElementById("small-description").remove();
            //       } catch (e) {
            //         return;
            //       }
            //     });
            //   }
            // };
            key: "render",
            value: function render() {
                var _props = this.props, brand = _props.brand, ean = _props.ean, contentEditorBlock = _props.contentEditorBlock, staticHTML = _props.staticHTML;
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "flix-minisite"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "flix-inpage"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flixMediaContentFallback",
                            children: contentEditorBlock.length !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDescription_ContentEditorProductDescription, {
                                contentEditorBlock: contentEditorBlock,
                                staticHTML: staticHTML,
                                ean: ean,
                                brand: brand
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDescription_StaticHTMLProductDescription, {
                                staticHTML: staticHTML,
                                ean: ean,
                                brand: brand
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                            children: "\n          .flixMediaContentFallback {\n            display: none\n          }\n\n          .ek-aricon, #flix_hotspots, .flix_hotspotV2, .flix_hotspot_ro {\n            display: none !important;\n            top: -99999px;\n            left: -99999px;\n          }\n\n          #flix-inpage:empty + .flixMediaContentFallback {\n            display:block\n          }\n        "
                        }),
                        !helpers/* isServer */.sk && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ScriptTag, {
                            type: "text/javascript",
                            src: "//media.flixfacts.com/js/loader.js",
                            "data-flix-distributor": get_default()(contentProviders, "providers.flixMedia.distributorCode", ""),
                            "data-flix-language": "ro",
                            "data-flix-brand": brand,
                            "data-flix-ean": ean,
                            "data-flix-button": "flix-minisite",
                            "data-flix-inpage": "flix-inpage",
                            async: true
                        })
                    ]
                }));
            }
        }
    ]);
    return FlixMediaProductDescription;
}(react.Component);
FlixMediaProductDescription.propTypes = {
    staticHTML: (prop_types_default()).string.isRequired,
    contentEditorBlock: (prop_types_default()).string.isRequired,
    ean: (prop_types_default()).string.isRequired,
    brand: (prop_types_default()).string.isRequired
};
/* harmony default export */ var ProductDescription_FlixMediaProductDescription = (FlixMediaProductDescription);

;// CONCATENATED MODULE: ./components/ProductPage/ProductDescription/StaticHTMLProductDescription.js





var StaticHTMLProductDescription = function(param) {
    var staticHTML = param.staticHTML, ean = param.ean, brand = param.brand;
    // Check if the description contains a FlixMedia description
    if (staticHTML.includes("data-flix") && ean && brand) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDescription_FlixMediaProductDescription, {
            staticHTML: "",
            contentEditorBlock: "",
            content: true,
            ean: ean,
            brand: brand
        }));
    }
    return helpers/* isServer */.sk ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        dangerouslySetInnerHTML: {
            __html: staticHTML
        }
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: helpers/* setDangerousHtml.bind */.RR.bind(null, staticHTML)
    });
};
StaticHTMLProductDescription.propTypes = {
    staticHTML: (prop_types_default()).string.isRequired,
    ean: (prop_types_default()).string.isRequired,
    brand: (prop_types_default()).string.isRequired
};
/* harmony default export */ var ProductDescription_StaticHTMLProductDescription = (StaticHTMLProductDescription);

;// CONCATENATED MODULE: ./components/ProductPage/ProductDescription/ContentEditorProductDescription.js





var ContentEditorProductDescription = function(param) {
    var staticHTML = param.staticHTML, contentEditorBlock = param.contentEditorBlock, ean = param.ean, brand = param.brand;
    var contentEditorObject = null;
    try {
        contentEditorObject = JSON.parse(contentEditorBlock);
    } catch (error) {
        ;
    }
    return contentEditorObject ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentEditorView/* default */.Z, {
        content: contentEditorObject
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDescription_StaticHTMLProductDescription, {
        staticHTML: staticHTML,
        ean: ean,
        brand: brand
    });
};
ContentEditorProductDescription.propTypes = {
    staticHTML: (prop_types_default()).string.isRequired,
    contentEditorBlock: (prop_types_default()).string.isRequired,
    ean: (prop_types_default()).string.isRequired,
    brand: (prop_types_default()).string.isRequired
};
/* harmony default export */ var ProductDescription_ContentEditorProductDescription = (ContentEditorProductDescription);

;// CONCATENATED MODULE: ./components/ProductPage/ProductDescription/EStoreMediaProductDescription.js









var EStoreMediaProductDescription_ref = (0,config["default"])(), EStoreMediaProductDescription_contentProviders = EStoreMediaProductDescription_ref.publicRuntimeConfig.contentProviders;
var EStoreMediaProductDescription = function(param) {
    var ean = param.ean, contentEditorBlock = param.contentEditorBlock, staticHTML = param.staticHTML, brand = param.brand;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "esc-rich-content",
                children: contentEditorBlock.length !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDescription_ContentEditorProductDescription, {
                    contentEditorBlock: contentEditorBlock,
                    staticHTML: staticHTML,
                    ean: ean,
                    brand: brand
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDescription_StaticHTMLProductDescription, {
                    staticHTML: staticHTML,
                    ean: ean,
                    brand: brand
                })
            }),
            !helpers/* isServer */.sk && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ScriptTag, {
                type: "text/javascript",
                src: "https://delivery.estorecontent.com/static/rich_content.js",
                "data-shop-id": get_default()(EStoreMediaProductDescription_contentProviders, "providers.eStoreMedia.shopId", ""),
                "data-content-language": "ro",
                "data-product-code": ean,
                "data-page-embed-id": "esc-rich-content",
                async: true
            })
        ]
    });
};
EStoreMediaProductDescription.propTypes = {
    staticHTML: (prop_types_default()).string.isRequired,
    contentEditorBlock: (prop_types_default()).string.isRequired,
    ean: (prop_types_default()).string.isRequired,
    brand: (prop_types_default()).string.isRequired
};
/* harmony default export */ var ProductDescription_EStoreMediaProductDescription = (EStoreMediaProductDescription);

;// CONCATENATED MODULE: ./components/ProductPage/ProductDescription/LoadBeeProductDescription.js









function LoadBeeProductDescription_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function LoadBeeProductDescription_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function LoadBeeProductDescription_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function LoadBeeProductDescription_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) LoadBeeProductDescription_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) LoadBeeProductDescription_defineProperties(Constructor, staticProps);
    return Constructor;
}
function LoadBeeProductDescription_getPrototypeOf(o) {
    LoadBeeProductDescription_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return LoadBeeProductDescription_getPrototypeOf(o);
}
function LoadBeeProductDescription_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) LoadBeeProductDescription_setPrototypeOf(subClass, superClass);
}
function LoadBeeProductDescription_possibleConstructorReturn(self, call) {
    if (call && (LoadBeeProductDescription_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return LoadBeeProductDescription_assertThisInitialized(self);
}
function LoadBeeProductDescription_setPrototypeOf(o, p) {
    LoadBeeProductDescription_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return LoadBeeProductDescription_setPrototypeOf(o, p);
}
var LoadBeeProductDescription_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function LoadBeeProductDescription_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function LoadBeeProductDescription_createSuper(Derived) {
    var hasNativeReflectConstruct = LoadBeeProductDescription_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = LoadBeeProductDescription_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = LoadBeeProductDescription_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return LoadBeeProductDescription_possibleConstructorReturn(this, result);
    };
}
var LoadBeeProductDescription_ref = (0,config["default"])(), LoadBeeProductDescription_contentProviders = LoadBeeProductDescription_ref.publicRuntimeConfig.contentProviders;
var LoadBeeProductDescription = /*#__PURE__*/ function(Component1) {
    "use strict";
    LoadBeeProductDescription_inherits(LoadBeeProductDescription, Component1);
    var _super = LoadBeeProductDescription_createSuper(LoadBeeProductDescription);
    function LoadBeeProductDescription() {
        LoadBeeProductDescription_classCallCheck(this, LoadBeeProductDescription);
        return _super.apply(this, arguments);
    }
    LoadBeeProductDescription_createClass(LoadBeeProductDescription, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (window && window.loadbeeIntegration) {
                    window.loadbeeIntegration.loadbeeInitIframeResizer();
                    window.loadbeeIntegration.checkAvailability(this.props.ean);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, ean = _props.ean, staticHTML = _props.staticHTML, contentEditorBlock = _props.contentEditorBlock, brand = _props.brand;
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "loadbeeTabContent",
                            "data-loadbee-apikey": get_default()(LoadBeeProductDescription_contentProviders, "providers.loadBee.apiKey", ""),
                            "data-loadbee-gtin": ean,
                            "data-loadbee-locale": "ro_RO"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "loadBeeTabContentFallback",
                            children: contentEditorBlock.length !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDescription_ContentEditorProductDescription, {
                                contentEditorBlock: contentEditorBlock,
                                staticHTML: staticHTML,
                                ean: ean,
                                brand: brand
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDescription_StaticHTMLProductDescription, {
                                staticHTML: staticHTML,
                                ean: ean,
                                brand: brand
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                            children: "\n          .loadBeeTabContentFallback {\n            display: none\n          }\n\n          .loadbeeTabContent:empty + .loadBeeTabContentFallback {\n            display:block\n          }\n        "
                        }),
                        !helpers/* isServer */.sk && !window.loadbeeIntegration && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ScriptTag, {
                            type: "text/javascript",
                            src: "https://cdn.loadbee.com/js/loadbee_integration.js",
                            async: true
                        })
                    ]
                }));
            }
        }
    ]);
    return LoadBeeProductDescription;
}(react.Component);
LoadBeeProductDescription.propTypes = {
    staticHTML: (prop_types_default()).string.isRequired,
    contentEditorBlock: (prop_types_default()).string.isRequired,
    ean: (prop_types_default()).string.isRequired,
    brand: (prop_types_default()).string.isRequired
};
/* harmony default export */ var ProductDescription_LoadBeeProductDescription = (LoadBeeProductDescription);

;// CONCATENATED MODULE: ./components/ProductPage/ProductDescription/_1WorldSyncProductDescription.js







var _1WorldSyncProductDescription = function(param) {
    var ean = param.ean, contentEditorBlock = param.contentEditorBlock, staticHTML = param.staticHTML, brand = param.brand, productNumber = param.productNumber;
    if (!helpers/* isServer */.sk) {
        window.ccs_cc_args = [
            // Customer part number will be your internal part number
            // for the SKU as defined in your catalog.
            // - optional
            // ["cpn", "CPN"],
            // The manufacturer name. Example: Lenovo, Cisco, Microsoft Corp.
            // - required
            [
                "mf",
                brand
            ],
            // The manufacturer part number. Example: VM617A8#ABA.
            // - required
            [
                "pn",
                productNumber
            ],
            // UPC or EAN code of the product being requested
            // - optional
            [
                "upcean",
                ean
            ],
            // The unique identifier of the catalog found in My Catalogs.
            // - optional
            // ["ccid", "CATALOG_CODE"],
            // Two-letter ISO 639-1 language code that should be used.
            // Examples: en, fr, de.
            // - required
            [
                "lang",
                "ro"
            ],
            // Two-letter ISO 3166-1 country code to use, or WW for world-wide.
            // Examples: US, DE, GB.
            // - required
            [
                "market",
                "RO"
            ],
            [
                "_SKey",
                "9b101c81"
            ],
            [
                "_ZoneId",
                "bad07d0c18"
            ], 
        ];
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "ccs-inline-content",
                children: contentEditorBlock.length !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDescription_ContentEditorProductDescription, {
                    contentEditorBlock: contentEditorBlock,
                    staticHTML: staticHTML,
                    ean: ean,
                    brand: brand
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDescription_StaticHTMLProductDescription, {
                    staticHTML: staticHTML,
                    ean: ean,
                    brand: brand
                })
            }),
            !helpers/* isServer */.sk && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ScriptTag, {
                type: "text/javascript",
                src: "https://cdn.cs.1worldsync.com/jsc/h1ws.js",
                async: true
            })
        ]
    }));
};
_1WorldSyncProductDescription.propTypes = {
    staticHTML: (prop_types_default()).string.isRequired,
    contentEditorBlock: (prop_types_default()).string.isRequired,
    ean: (prop_types_default()).string.isRequired,
    brand: (prop_types_default()).string.isRequired
};
/* harmony default export */ var ProductDescription_1WorldSyncProductDescription = (_1WorldSyncProductDescription);

;// CONCATENATED MODULE: ./components/ProductPage/ProductDescription/index.js











function ProductDescription_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function ProductDescription_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function ProductDescription_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function ProductDescription_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) ProductDescription_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) ProductDescription_defineProperties(Constructor, staticProps);
    return Constructor;
}
function ProductDescription_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ProductDescription_getPrototypeOf(o) {
    ProductDescription_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return ProductDescription_getPrototypeOf(o);
}
function ProductDescription_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) ProductDescription_setPrototypeOf(subClass, superClass);
}
function ProductDescription_possibleConstructorReturn(self, call) {
    if (call && (ProductDescription_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return ProductDescription_assertThisInitialized(self);
}
function ProductDescription_setPrototypeOf(o, p) {
    ProductDescription_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return ProductDescription_setPrototypeOf(o, p);
}
var ProductDescription_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function ProductDescription_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function ProductDescription_createSuper(Derived) {
    var hasNativeReflectConstruct = ProductDescription_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = ProductDescription_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = ProductDescription_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return ProductDescription_possibleConstructorReturn(this, result);
    };
}
var contentProviderComponentMapping = {
    loadBee: ProductDescription_LoadBeeProductDescription,
    eStoreMedia: ProductDescription_EStoreMediaProductDescription,
    flixMedia: ProductDescription_FlixMediaProductDescription,
    contentEditor: ProductDescription_ContentEditorProductDescription,
    staticHTML: ProductDescription_StaticHTMLProductDescription,
    "1WorldSync": ProductDescription_1WorldSyncProductDescription
};
var ProductDescription_ref = (0,config["default"])(), ProductDescription_publicRuntimeConfig = ProductDescription_ref.publicRuntimeConfig, ProductDescription_contentProviders = ProductDescription_publicRuntimeConfig.contentProviders, productDescriptionFallbackMinLengthCheck = ProductDescription_publicRuntimeConfig.settings.productDescriptionFallbackMinLengthCheck;
var ProductDescription = /*#__PURE__*/ function(Component1) {
    "use strict";
    ProductDescription_inherits(ProductDescription, Component1);
    var _super = ProductDescription_createSuper(ProductDescription);
    function ProductDescription() {
        ProductDescription_classCallCheck(this, ProductDescription);
        var _this;
        _this = _super.apply(this, arguments);
        ProductDescription_defineProperty(ProductDescription_assertThisInitialized(_this), "getBrandContentProviderName", function() {
            var brand = _this.props.brand;
            if (brand) {
                var brandProviderName = get_default()(ProductDescription_contentProviders, "brandContentProvider.".concat(brand.toUpperCase()), "");
                if (brandProviderName && get_default()(ProductDescription_contentProviders, "providers.".concat(brandProviderName, ".isEnabled"), false)) {
                    return brandProviderName;
                }
            }
            return "";
        });
        ProductDescription_defineProperty(ProductDescription_assertThisInitialized(_this), "getContentProviderName", function() {
            var _props = _this.props, useExternalContentProvider = _props.useExternalContentProvider, contentEditorBlock = _props.contentEditorBlock, staticHTML = _props.staticHTML, ean = _props.ean, brand = _props.brand;
            var hasContentEditorContent = false;
            if (contentEditorBlock && contentEditorBlock.length > 0) {
                try {
                    hasContentEditorContent = JSON.parse(contentEditorBlock);
                } catch (error) {
                    ;
                }
            }
            if (!useExternalContentProvider && (staticHTML.length > productDescriptionFallbackMinLengthCheck || contentEditorBlock && contentEditorBlock.length > productDescriptionFallbackMinLengthCheck)) {
                if (staticHTML.includes("data-flix") && ean && brand) {
                    return "flixMedia";
                } else {
                    return hasContentEditorContent ? "contentEditor" : "staticHTML";
                }
            }
            return _this.getBrandContentProviderName() || (hasContentEditorContent ? "contentEditor" : staticHTML.includes("data-flix") && ean && brand ? "flixMedia" : "staticHTML");
        });
        return _this;
    }
    ProductDescription_createClass(ProductDescription, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate() {
                // TODO: Test if this is necessary
                return false;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, staticHTML = _props.staticHTML, contentEditorBlock = _props.contentEditorBlock, ean = _props.ean, cmsBlocks = _props.cmsBlocks, brand = _props.brand, productNumber = _props.productNumber;
                var contentProviderName = this.getContentProviderName();
                // console.warn("Product description content provider:", contentProviderName);
                var ContentProviderComponent = contentProviderComponentMapping[contentProviderName];
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "Tabs-content p-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "Description",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "Cms",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "Cms-container relative",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mb-3 lg:mb-5 ".concat(contentProviderName === "staticHTML" ? "Cms-inner" : ""),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentProviderComponent, {
                                            contentEditorBlock: contentEditorBlock,
                                            staticHTML: staticHTML,
                                            ean: ean,
                                            brand: brand,
                                            productNumber: productNumber
                                        }),
                                        get_default()(cmsBlocks, "altex_label/rule_action_type_cmsBlockBottom.content", "") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            dangerouslySetInnerHTML: {
                                                __html: cmsBlocks["altex_label/rule_action_type_cmsBlockBottom"].content
                                            }
                                        })
                                    ]
                                })
                            })
                        })
                    })
                }));
            }
        }
    ]);
    return ProductDescription;
}(react.Component);
ProductDescription.defaultProps = {
    useExternalContentProvider: false,
    staticHTML: "",
    contentEditorBlock: "",
    cmsBlocks: null,
    ean: "",
    brand: ""
};
ProductDescription.propTypes = {
    staticHTML: (prop_types_default()).string.isRequired,
    contentEditorBlock: (prop_types_default()).string,
    cmsBlocks: (prop_types_default()).object,
    ean: (prop_types_default()).string,
    brand: (prop_types_default()).string
};
/* harmony default export */ var ProductPage_ProductDescription = (ProductDescription);

// EXTERNAL MODULE: ./components/Heading.js
var Heading = __webpack_require__(73510);
;// CONCATENATED MODULE: ./components/Specifications.js





var Specifications = function(param) {
    var groups = param.groups;
    var rendAttr = function(attr, i, j) {
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("tr", {
            className: "Specs-row text-sm ".concat(j != 0 ? "border-gray-light border-t" : ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                    className: "Specs-cell text-gray-1200 font-medium py-3 leading-18.2",
                    children: attr.label
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    className: "Specs-cell py-3 leading-18.2",
                    children: attr.value
                })
            ]
        }, attr.order + attr.label + i + j);
    };
    var rendGroup = function(group, renderedAttrs, i) {
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
            className: "mb-3 lg:mb-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                    as: "h3",
                    display: "h3",
                    title: group.name,
                    classesProp: "text-red-brand mb-2 leading-20 text-xl lg:text-22px lg:leading-28.6"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                    className: "Specs-table w-full table-fixed",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                        children: renderedAttrs
                    })
                })
            ]
        }, group.order + group.name + i);
    };
    var sortedGroups = sortBy_default()(groups, "order");
    var secondColumn = sortedGroups.map(function(group, i) {
        if (i >= sortedGroups.length / 2) {
            var sortedAttrs = sortBy_default()(group.attributes, "order");
            var renderedAttrs = sortedAttrs.map(function(attr, j) {
                return rendAttr(attr, i, j);
            });
            return rendGroup(group, renderedAttrs, i);
        }
        return null;
    });
    var firstColumn = sortedGroups.map(function(group, i) {
        if (i < sortedGroups.length / 2) {
            var sortedAttrs = sortBy_default()(group.attributes, "order");
            var renderedAttrs = sortedAttrs.map(function(attr, j) {
                return rendAttr(attr, i, j);
            });
            return rendGroup(group, renderedAttrs, i);
        }
        return null;
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "Tabs-content md:grid md:grid-cols-2 md:gap-x-20 text-left",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "Specs-column",
                children: firstColumn
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "Specs-column",
                children: secondColumn
            })
        ]
    }));
};
Specifications.propTypes = {
    groups: (prop_types_default()).array.isRequired
};
/* harmony default export */ var components_Specifications = (Specifications);

// EXTERNAL MODULE: ./components/Breadcrumbs.js + 1 modules
var Breadcrumbs = __webpack_require__(94512);
;// CONCATENATED MODULE: ./components/ProductPage/ProductBreadcrumbs.js


var ProductBreadcrumbs = function(param) {
    var breadcrumbs = param.breadcrumbs, sku = param.sku;
    var parsedBreadcrumbs = breadcrumbs && breadcrumbs.slice(0, -1);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-row items-center pt-[4px]",
        children: [
            parsedBreadcrumbs && /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                breadcrumbs: parsedBreadcrumbs,
                isPDP: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "text-sm lg:pt-3 pb-3 lg:mb-6 flex-none",
                children: [
                    "Cod produs: ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: sku
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var ProductPage_ProductBreadcrumbs = (ProductBreadcrumbs);

// EXTERNAL MODULE: ./components/Price/index.js + 1 modules
var Price = __webpack_require__(40641);
// EXTERNAL MODULE: ./components/Status.js
var Status = __webpack_require__(66552);
// EXTERNAL MODULE: ./components/Tooltip/index.js + 4 modules
var Tooltip = __webpack_require__(16729);
;// CONCATENATED MODULE: ./components/ProductPage/ProductLabel.js


var ProductLabel = function(param) {
    var label = param.label;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "inline-flex items-center w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "inline-block text-14px border border-[#BC003B] rounded",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "leading-5 px-2 pb-0.5 text-[#BC003B] font-semibold",
                    children: label
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ml-1.5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                    content: "Acest produs are un pret competitiv in baza monitorizarilor interne zilnice"
                })
            })
        ]
    });
};
/* harmony default export */ var ProductPage_ProductLabel = (ProductLabel);

;// CONCATENATED MODULE: ./components/Icons/CheckMark.js

var CheckMark = function(param) {
    var _width = param.width, width = _width === void 0 ? 16 : _width, _height = param.height, height = _height === void 0 ? 16 : _height;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "#000",
            d: "M6.5 12 2 7.5l.7-.7 3.8 3.8 6.8-6.8.7.7L6.5 12Z"
        })
    });
};
/* harmony default export */ var Icons_CheckMark = (CheckMark);

;// CONCATENATED MODULE: ./components/ProductPage/ProductVariations/ProductVariationOptionTextBox.js




var ProductVariationOptionTextBox = function(param) {
    var label = param.label, image = param.image, isSelected = param.isSelected;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("flex flex-col gap-[4px] justify-center items-center px-[8px] py-[4px] rounded", {
            "border-2 border-[#FFC348]": isSelected,
            "bg-[#FFF9EB] border-2 border-transparent hover:border-[#FFC348]": !isSelected
        }),
        draggable: false,
        children: [
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: (0,helpers/* resizeImage */.tg)(image, "40x40"),
                alt: label,
                className: "min-w-[40px] min-h-[40px] object-contain"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "flex items-center justify-center gap-[4px] text-[14px]",
                children: [
                    isSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_CheckMark, {}),
                    label
                ]
            })
        ]
    });
};
/* harmony default export */ var ProductVariations_ProductVariationOptionTextBox = (ProductVariationOptionTextBox);

;// CONCATENATED MODULE: ./components/ProductPage/ProductVariations/ProductVariationOption.js




var ProductVariationOption = function(param) {
    var item = param.item;
    if (item.isSelected) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductVariations_ProductVariationOptionTextBox, {
            label: item.label,
            image: item.image,
            isSelected: true
        }));
    }
    if (!item.isSelected) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
            href: "/".concat(item.url, "/cpd/").concat(item.sku, "/"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                title: "",
                draggable: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductVariations_ProductVariationOptionTextBox, {
                    label: item.label,
                    image: item.image,
                    isSelected: false
                })
            })
        }));
    }
    return null;
};
/* harmony default export */ var ProductVariations_ProductVariationOption = (ProductVariationOption);

;// CONCATENATED MODULE: ./components/ProductPage/ProductVariations/index.js


function ProductVariations_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ProductVariations_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProductVariations_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ProductVariations = function(param1) {
    var product = param1.product;
    return product.configurable_options.map(function(variation) {
        return ProductVariations_objectSpread({}, variation, {
            // THIS IS A TEMPORARY HOTFIX IN ORDER TO IDENTIFY
            // THE CURRENTLY SELECTED PRODUCT
            // Current product only has label, other variations
            // have full data
            values: variation.values.map(function(value) {
                return product.sku === value.sku ? ProductVariations_objectSpread({}, value, {
                    isSelected: true
                }) : value;
            })
        });
    }).map(function(variation) {
        var ref, ref1;
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
            className: "mb-[30px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "leading-[20px] mb-[8px] text-[#737373]",
                    children: [
                        variation.label,
                        ": ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            className: "font-medium leading-[20px] text-black",
                            children: (ref = variation.values.filter(function(param) {
                                var url = param.url;
                                return !url;
                            })[0]) === null || ref === void 0 ? void 0 : ref.label
                        })
                    ]
                }),
                ((ref1 = variation.values) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "flex flex-row items-center gap-x-2 gap-y-2 overflow-x-scroll scrollbar-hide md:overflow-x-auto md:flex-wrap",
                    children: variation.values.map(function(value) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                            className: "select-none",
                            draggable: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductVariations_ProductVariationOption, {
                                item: value
                            })
                        }, value.id);
                    })
                })
            ]
        }, variation.attribute_code);
    });
};
/* harmony default export */ var ProductPage_ProductVariations = (ProductVariations);

// EXTERNAL MODULE: ./containers/Catalog/Actions/AddToCart.js + 6 modules
var AddToCart = __webpack_require__(38973);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
;// CONCATENATED MODULE: ./components/ProductPage/ProductEnergyClass.js




// TODO: Create generic Icon component that imports icons on demand
var labelA = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 6722).then(__webpack_require__.bind(__webpack_require__, 82861));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(82861)
            ];
        }
    }
});
var labelB = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 4515).then(__webpack_require__.bind(__webpack_require__, 24515));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24515)
            ];
        }
    }
});
var labelC = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 3480).then(__webpack_require__.bind(__webpack_require__, 23480));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(23480)
            ];
        }
    }
});
var labelD = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 4957).then(__webpack_require__.bind(__webpack_require__, 14957));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14957)
            ];
        }
    }
});
var labelE = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 1320).then(__webpack_require__.bind(__webpack_require__, 41320));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(41320)
            ];
        }
    }
});
var labelF = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 685).then(__webpack_require__.bind(__webpack_require__, 30685));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(30685)
            ];
        }
    }
});
var labelG = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 4469).then(__webpack_require__.bind(__webpack_require__, 34469));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34469)
            ];
        }
    }
});
var classComponentMap = {
    A: labelA,
    B: labelB,
    C: labelC,
    D: labelD,
    E: labelE,
    F: labelF,
    G: labelG
};
var ProductEnergyClass = function(param) {
    var energyClass = param.energyClass, _width = param.width, width = _width === void 0 ? "70px" : _width, _isClickable = param.isClickable, isClickable = _isClickable === void 0 ? false : _isClickable, onClick = param.onClick;
    if (classComponentMap[energyClass]) {
        var Class = classComponentMap[energyClass];
        return isClickable ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            role: "button",
            href: "#",
            title: "Vezi eticheta energetica",
            onClick: onClick,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Class, {
                width: width
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Class, {
            width: width
        });
    }
    return null;
};
ProductEnergyClass.propTypes = {
    energyClass: (prop_types_default()).string.isRequired,
    width: (prop_types_default()).string,
    isClickable: (prop_types_default()).bool,
    onClick: (prop_types_default()).func
};
/* harmony default export */ var ProductPage_ProductEnergyClass = (ProductEnergyClass);

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(65988);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./components/Modal.js
var Modal = __webpack_require__(12280);
;// CONCATENATED MODULE: ./components/ProductPage/ProductEnergyLabelModal.js






var ProductEnergyLabelModal_ref = (0,config["default"])(), ProductEnergyLabelModal_publicRuntimeConfig = ProductEnergyLabelModal_ref.publicRuntimeConfig, cdn = ProductEnergyLabelModal_publicRuntimeConfig.settings.cdn;
var ProductEnergyLabelModal = function(param) {
    var productName = param.productName, labelPath = param.labelPath;
    if (productName && labelPath) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal["default"], {
            id: "productEnergyLabel",
            header: productName,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    // TODO: Use resizeImage for src and
                    // add 320x0 width/height config in mediaserver
                    // We have only square resizes right now
                    src: "".concat(cdn).concat(labelPath),
                    alt: "Eticheta energetica ".concat(productName),
                    style: {
                        maxWidth: "320px"
                    },
                    className: "jsx-34c89d91fc00aa9b" + " " + "mx-auto"
                }),
                (0,jsx_runtime.jsx)((style_default()), {
                    id: "34c89d91fc00aa9b",
                    children: ".Modal-productEnergyLabel{max-width:575px}"
                })
            ]
        }));
    }
    return null;
};
ProductEnergyLabelModal.propTypes = {
    productName: (prop_types_default()).string.isRequired,
    labelPath: (prop_types_default()).string.isRequired
};
/* harmony default export */ var ProductPage_ProductEnergyLabelModal = (ProductEnergyLabelModal);

;// CONCATENATED MODULE: ./components/Icons/PlusBorderRounded.js


var PlusBorderRounded_ref = (0,config["default"])(), PlusBorderRounded_publicRuntimeConfig = PlusBorderRounded_ref.publicRuntimeConfig, PlusBorderRounded_websiteName = PlusBorderRounded_publicRuntimeConfig.settings.websiteName;
var PlusBorderRounded = function(param) {
    var _width = param.width, width = _width === void 0 ? "16px" : _width, _height = param.height, height = _height === void 0 ? "16px" : _height;
    return PlusBorderRounded_websiteName === "bricostore" ? // Material Design "add_circle_outline" (24x24, Apache-2.0). Color via currentColor.
    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7Zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Z"
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "#000",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M8 2a6 6 0 0 1 6 6 6 6 0 0 1-6 6 6 6 0 0 1-6-6 6 6 0 0 1 6-6Zm0-1a7 7 0 0 0-7 7 7 7 0 0 0 7 7 7 7 0 0 0 7-7 7 7 0 0 0-7-7Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12 7.5H8.5V4h-1v3.5H4v1h3.5V12h1V8.5H12v-1Z"
                })
            ]
        })
    });
};
/* harmony default export */ var Icons_PlusBorderRounded = (PlusBorderRounded);

// EXTERNAL MODULE: ./components/Icons/ArrowRight.js
var ArrowRight = __webpack_require__(7708);
// EXTERNAL MODULE: ./components/ProductPage/ProductServices/ServiceTitle.js
var ServiceTitle = __webpack_require__(91931);
// EXTERNAL MODULE: ./components/Icons/Close.js
var Close = __webpack_require__(30002);
;// CONCATENATED MODULE: ./components/Icons/ProductPage/ExtraWarantyIcon.js

var ExtraWarantyIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? "16px" : _width, _height = param.height, height = _height === void 0 ? "16px" : _height;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "#000",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "m14.85 9.65-1.5-1.5a.5.5 0 0 0-.7 0L8 12.79V15h2.2l4.65-4.65a.5.5 0 0 0 0-.7ZM9.8 14H9v-.8l2.5-2.5.8.8L9.8 14Zm3.2-3.2-.8-.8.8-.8.8.8-.8.8ZM9 8H4v1h5V8Zm1-3H4v1h6V5Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M13 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v6.5a5.5 5.5 0 0 0 2.91 4.85l2.59 1.38V13.6l-2.12-1.13A4.5 4.5 0 0 1 2 8.5V2h10v4.5h1V2Z"
                })
            ]
        })
    });
};
/* harmony default export */ var ProductPage_ExtraWarantyIcon = (ExtraWarantyIcon);

;// CONCATENATED MODULE: ./components/Icons/ProductPage/MobileProtectIcon.js

var MobileProtectIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? "16px" : _width, _height = param.height, height = _height === void 0 ? "16px" : _height;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "#000",
            d: "M11 11 8.5 8.52l.8-.78L11 9.43l3.7-3.68.8.79L11 11Zm1-10H3a1 1 0 0 0-1 1v7.15a5.52 5.52 0 0 0 2.75 4.75l2.75 1.6 2.7-1.6c.46-.26.87-.6 1.23-.97l-.68-.68c-.3.3-.63.57-1 .8L7.5 14.4l-2.25-1.35A4.5 4.5 0 0 1 3 9.15V2h9v2.5h1V2a1 1 0 0 0-1-1Z"
        })
    });
};
/* harmony default export */ var ProductPage_MobileProtectIcon = (MobileProtectIcon);

;// CONCATENATED MODULE: ./components/Icons/ProductPage/InstallIcon.js

var InstallIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? "16px" : _width, _height = param.height, height = _height === void 0 ? "16px" : _height;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 32 32",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "#000",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M26 30H6a2 2 0 0 1-2-2V16c0-1.1.9-2 2-2h3v2H6v12h20V16h-3v-2h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M19 20h-6v2h6v-2Zm1.6-11.4L17 12.2V2h-2v10.2l-3.6-3.6L10 10l6 6 6-6-1.4-1.4Z"
                })
            ]
        })
    });
};
/* harmony default export */ var ProductPage_InstallIcon = (InstallIcon);

;// CONCATENATED MODULE: ./components/Icons/ProductPage/BYBIcon.js

var BYBIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? "16px" : _width, _height = param.height, height = _height === void 0 ? "16px" : _height;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 32 32",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "#000",
            d: "m29.51 22.25-2.08-3.74-1.75.97 2.08 3.74c.32.58.32 1.28-.02 1.85-.34.58-.94.92-1.61.92h-7.3l2.58-2.59L20 21.99l-5 5 5 5 1.41-1.41-2.58-2.59h7.3c1.38 0 2.63-.71 3.33-1.91.7-1.19.72-2.63.05-3.84v.01ZM5.87 26c-.67 0-1.27-.34-1.61-.92a1.83 1.83 0 0 1-.02-1.85l4.11-7.4 1.05 3.52 1.91-.57L9.3 12l-6.78 2.01.57 1.91 3.49-1.03-4.09 7.36a3.84 3.84 0 0 0 .05 3.84A3.84 3.84 0 0 0 5.87 28H12v-2H5.87ZM25.51 9.65l-1.05 3.52-5.11-9.2A3.8 3.8 0 0 0 16 2a3.8 3.8 0 0 0-3.35 1.97L9.57 9.51l1.75.97 3.08-5.54c.33-.59.93-.94 1.6-.94s1.27.35 1.6.94l5.09 9.17-3.49-1.03-.57 1.91L25.41 17l2.01-6.78-1.91-.57Z"
        })
    });
};
/* harmony default export */ var ProductPage_BYBIcon = (BYBIcon);

;// CONCATENATED MODULE: ./components/ProductPage/ProductServices/index.js












function ProductServices_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ProductServices_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ProductServices_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ProductServices_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ProductServices_slicedToArray(arr, i) {
    return ProductServices_arrayWithHoles(arr) || ProductServices_iterableToArrayLimit(arr, i) || ProductServices_unsupportedIterableToArray(arr, i) || ProductServices_nonIterableRest();
}
function ProductServices_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ProductServices_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ProductServices_arrayLikeToArray(o, minLen);
}
var servicesIconsMap = {
    extra_warranty: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_ExtraWarantyIcon, {}),
    mobile_protect: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_MobileProtectIcon, {}),
    install: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_InstallIcon, {}),
    buyback: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_BYBIcon, {})
};
var ProductServices = function(param1) {
    var services = param1.services, activeServices = param1.activeServices, addModal1 = param1.addModal, removeService = param1.removeService;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "border rounded p-[8px] flex space-x-[8px] cursor-pointer",
                onClick: function() {
                    return addModal1("productServicesModal");
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-[4px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_PlusBorderRounded, {
                                width: "16px",
                                height: "16px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "hidden sm:inline md:hidden lg:inline text-[14px]",
                                children: "Adauga"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-wrap gap-[8px] w-full",
                        children: Object.keys(services).map(function(serviceKey) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                className: "px-[8px] py-[4px] rounded bg-[#FFEFC6] text-[14px] font-medium min-w-fit",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceTitle/* default */.Z, {
                                    serviceKey: serviceKey
                                })
                            }, serviceKey);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "self-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight/* default */.Z, {})
                    })
                ]
            }),
            activeServices && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-[8px] space-y-[8px]",
                children: Object.entries(activeServices).map(function(param) {
                    var _param = ProductServices_slicedToArray(param, 2), key = _param[0], ref = _param[1], sku = ref.sku, additional_data = ref.additional_data;
                    var activeServiceDetails = services[key].find(function(serviceOption) {
                        return serviceOption.sku === sku;
                    });
                    var short_description = activeServiceDetails.short_description, name = activeServiceDetails.name, price = activeServiceDetails.price;
                    var hasActiveChildService = additional_data && additional_data.childSku;
                    var childServiceDetails = hasActiveChildService && activeServiceDetails.product_links[key].find(function(serviceOption) {
                        return serviceOption.sku === additional_data.childSku;
                    });
                    var _short_description;
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "p-[8px] bg-[#FFF9EB] rounded",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-between",
                                children: [
                                    servicesIconsMap[key] && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "inline-block mr-[4px] self-start mt-[2px]",
                                        children: servicesIconsMap[key]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-[14px] font-medium w-full",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceTitle/* default */.Z, {
                                                serviceKey: key
                                            }),
                                            ":",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "font-normal",
                                                children: [
                                                    " ",
                                                    short_description !== null && short_description !== void 0 ? short_description : name,
                                                    " ",
                                                    key !== "buyback" && "- ".concat((0,helpers/* formatPrice */.T4)(price), " lei")
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[#DC2626] p-[5px] cursor-pointer",
                                        onClick: function() {
                                            return removeService({
                                                key: key
                                            });
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                            width: 10,
                                            height: 10
                                        })
                                    })
                                ]
                            }),
                            hasActiveChildService && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-between ml-[20px] mt-[6px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-[14px] font-medium border-t mr-[16px] pt-[6px] flex items-center flex-wrap gap-[4px]",
                                        children: [
                                            childServiceDetails.name,
                                            ":",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "font-normal inline",
                                                children: [
                                                    (_short_description = childServiceDetails.short_description) !== null && _short_description !== void 0 ? _short_description : childServiceDetails.name,
                                                    " ",
                                                    "- ",
                                                    (0,helpers/* formatPrice */.T4)(childServiceDetails.price),
                                                    " lei"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[#DC2626] p-[5px] cursor-pointer",
                                        onClick: function() {
                                            return removeService({
                                                key: key,
                                                child: true
                                            });
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                            width: 10,
                                            height: 10
                                        })
                                    })
                                ]
                            })
                        ]
                    }, sku));
                })
            })
        ]
    });
};
/* harmony default export */ var ProductPage_ProductServices = ((0,es/* connect */.$j)(null, {
    addModal: app_actions/* addModal */.Y_
})(ProductServices));

// EXTERNAL MODULE: ./components/Icons/Info.js
var Info = __webpack_require__(5060);
// EXTERNAL MODULE: ./components/ImageWithFallback.js
var ImageWithFallback = __webpack_require__(10177);
;// CONCATENATED MODULE: ./components/ProductPage/ProductBenefits.js









var ProductBenefits_ref = (0,config["default"])(), ProductBenefits_publicRuntimeConfig = ProductBenefits_ref.publicRuntimeConfig, _settings = ProductBenefits_publicRuntimeConfig.settings, baseUrl = _settings.baseUrl, ProductBenefits_cdn = _settings.cdn, websiteStatics = _settings.websiteStatics;
var ProductBenefits = function(param) {
    var benefits = param.benefits, addModal1 = param.addModal;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("ul", {
        className: "space-y-[8px]",
        children: benefits.map(function(benefit, index) {
            var hasExternalURL = Boolean(benefit.external_url_key);
            var hasURLKey = Boolean(benefit.url_key);
            var hasModalContent = benefit.content && Object.keys(benefit.content).length !== 0;
            var infoType = hasExternalURL ? "externalURL" : hasURLKey ? "urlKey" : hasModalContent ? "modal" : null;
            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "flex justify-start items-center truncate",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWithFallback/* default */.Z, {
                                src: benefit.image ? "".concat(ProductBenefits_cdn, "/").concat(benefit.image) : null,
                                className: "mr-[6px]",
                                style: {
                                    maxWidth: "20px",
                                    height: "auto"
                                },
                                fallback: "".concat(websiteStatics, "/images/benefits-placeholder.svg")
                            }),
                            benefit.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-12px font-medium truncate",
                                children: benefit.title
                            })
                        ]
                    }),
                    infoType === "externalURL" && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: "".concat(baseUrl, "/").concat(benefit.external_url_key),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "inline-block text-gray sm:hover:text-yellow-hover ml-1 w-5 h-5 rounded-full text-center align-middle",
                            title: "",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {})
                        })
                    }),
                    infoType === "urlKey" && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: "".concat(baseUrl, "/").concat(benefit.url_key, "/pag/"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "inline-block text-gray sm:hover:text-yellow-hover ml-10px w-5 h-5 rounded-full text-center align-middle",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {})
                        })
                    }),
                    infoType === "modal" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: function() {
                                    return addModal1("benefitModal-".concat(index));
                                },
                                className: "inline-block text-gray sm:hover:text-yellow-hover ml-10px w-5 h-5 rounded-full text-center align-middle",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
                                position: "right",
                                header: benefit.title || "",
                                className: "Confirmation-modal-container",
                                id: "benefitModal-".concat(index),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "Confirmation-modal-children mb-6",
                                    children: [
                                        get_default()(benefit, "content.cms_block_top.content", "") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            dangerouslySetInnerHTML: {
                                                __html: benefit.content.cms_block_top.content
                                            }
                                        }),
                                        get_default()(benefit, "content.cms_block_bottom.content", "") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            dangerouslySetInnerHTML: {
                                                __html: benefit.content.cms_block_bottom.content
                                            }
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }, index));
        })
    });
};
/* harmony default export */ var ProductPage_ProductBenefits = ((0,es/* connect */.$j)(null, {
    addModal: app_actions/* addModal */.Y_
})(ProductBenefits));

// EXTERNAL MODULE: ./node_modules/md5/md5.js
var md5 = __webpack_require__(2568);
var md5_default = /*#__PURE__*/__webpack_require__.n(md5);
// EXTERNAL MODULE: ./node_modules/react-image-lightbox/dist/index.es.js
var index_es = __webpack_require__(92879);
;// CONCATENATED MODULE: ./components/Icons/VerifiedBuy.js


var VerifiedBuy = function(param) {
    var _width = param.width, width = _width === void 0 ? "16px" : _width, _height = param.height, height = _height === void 0 ? "16px" : _height;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fillRule: "nonzero",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M15.5709091,6.97454545 L14.08,5.48363636 L14.08,3.36727273 C14.08,2.56394945 13.4287778,1.91272727 12.6254545,1.91272727 L10.5163636,1.91272727 L9.02545455,0.458181818 C8.45812734,-0.105779774 7.54187266,-0.105779774 6.97454545,0.458181818 L5.48363636,1.92 L3.36727273,1.92 C2.56394945,1.92 1.91272727,2.57122218 1.91272727,3.37454545 L1.91272727,5.48363636 L0.458181818,6.97454545 C0.174320423,7.24123323 0.00927347893,7.61062401 -4.6379092e-07,8 C-0.000306517546,8.38410548 0.151330248,8.75273969 0.421818182,9.02545455 L1.92,10.5163636 L1.92,12.6327273 C1.92,13.4360505 2.57122218,14.0872727 3.37454545,14.0872727 L5.48363636,14.0872727 L6.97454545,15.5781818 C7.24726031,15.8486698 7.61589452,16.0003065 7.99999954,16.0000005 C8.38410548,16.0003065 8.75273969,15.8486698 9.02545455,15.5781818 L10.5163636,14.08 L12.6327273,14.08 C13.4360505,14.08 14.0872727,13.4287778 14.0872727,12.6254545 L14.0872727,10.5163636 L15.5781818,9.02545455 C16.1421434,8.45812734 16.1421434,7.54187266 15.5781818,6.97454545 L15.5709091,6.97454545 Z",
                    fill: "#15cad7"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                    fill: "#FFFFFF",
                    points: "7.27272727 8.53090909 5.60727273 6.86545455 4.57454545 7.89090909 7.27272727 10.5890909 11.4254545 6.43636364 10.3927273 5.41090909"
                })
            ]
        })
    });
};
/* harmony default export */ var Icons_VerifiedBuy = (VerifiedBuy);

// EXTERNAL MODULE: ./components/Icons/RatingStar.js
var RatingStar = __webpack_require__(21276);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__(52077);
// EXTERNAL MODULE: ./components/Form/Textarea.js
var Textarea = __webpack_require__(4792);
// EXTERNAL MODULE: ./lib/validations.js + 1 modules
var validations = __webpack_require__(38294);
// EXTERNAL MODULE: ./components/Loading.js
var Loading = __webpack_require__(24461);
// EXTERNAL MODULE: ./components/Alert.js + 10 modules
var Alert = __webpack_require__(16479);
// EXTERNAL MODULE: ./lib/api/index.js
var api = __webpack_require__(2642);
;// CONCATENATED MODULE: ./containers/Reviews/AddCommentForm.js












function AddCommentForm_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function AddCommentForm_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function AddCommentForm_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function AddCommentForm_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) AddCommentForm_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) AddCommentForm_defineProperties(Constructor, staticProps);
    return Constructor;
}
function AddCommentForm_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AddCommentForm_getPrototypeOf(o) {
    AddCommentForm_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return AddCommentForm_getPrototypeOf(o);
}
function AddCommentForm_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) AddCommentForm_setPrototypeOf(subClass, superClass);
}
function AddCommentForm_possibleConstructorReturn(self, call) {
    if (call && (AddCommentForm_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return AddCommentForm_assertThisInitialized(self);
}
function AddCommentForm_setPrototypeOf(o, p) {
    AddCommentForm_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return AddCommentForm_setPrototypeOf(o, p);
}
var AddCommentForm_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function AddCommentForm_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function AddCommentForm_createSuper(Derived) {
    var hasNativeReflectConstruct = AddCommentForm_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = AddCommentForm_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = AddCommentForm_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return AddCommentForm_possibleConstructorReturn(this, result);
    };
}
var AddCommentForm = /*#__PURE__*/ function(Component1) {
    "use strict";
    AddCommentForm_inherits(AddCommentForm, Component1);
    var _super = AddCommentForm_createSuper(AddCommentForm);
    function AddCommentForm(props) {
        AddCommentForm_classCallCheck(this, AddCommentForm);
        var _this;
        _this = _super.call(this, props);
        var _this1 = AddCommentForm_assertThisInitialized(_this);
        AddCommentForm_defineProperty(AddCommentForm_assertThisInitialized(_this), "sendForm", function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee(values) {
                var _props, user, type, productId, parentId, customerName, body, payload, addResponse;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _props = _this1.props, user = _props.user, type = _props.type, productId = _props.productId, parentId = _props.parentId;
                            customerName = user.isLoggedIn ? "".concat(user.customer.first_name, " ").concat(user.customer.last_name) : "";
                            body = values.body;
                            payload = {
                                customerName: customerName,
                                productId: productId,
                                parentId: parentId,
                                body: body
                            };
                            _ctx.next = 6;
                            return _this1.props.apiCall({
                                spinner: true,
                                alert: true,
                                apiCall: type === "reviews" ? api/* postReviewsApi */.aAN : api/* postQuestionsApi */.NNx,
                                apiArgs: [
                                    payload
                                ],
                                returnResponse: true
                            });
                        case 6:
                            addResponse = _ctx.sent;
                            if (addResponse && addResponse.ok) {
                                _this1.setState({
                                    isSent: true
                                });
                            }
                        case 8:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }());
        _this.state = {
            isSent: false
        };
        return _this;
    }
    AddCommentForm_createClass(AddCommentForm, [
        {
            key: "render",
            value: function render() {
                var isSent = this.state.isSent;
                var _props = this.props, closeForm = _props.closeForm, type = _props.type, _user = _props.user, isLoggedIn = _user.isLoggedIn, isInitial = _user.isInitial;
                if (isSent) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                            type: "success",
                            onClose: closeForm,
                            children: type === "reviews" ? "Comentariul tau a fost adaugat. Iti multumim pentru contributie." : "Raspunsul tau a fost adaugat. Iti multumim pentru contributie."
                        })
                    }));
                }
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        isInitial && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {
                            height: 100
                        }),
                        !isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                                type: "warning",
                                children: "Trebuie sa fii autentificat."
                            })
                        }),
                        isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
                            onSubmit: this.sendForm,
                            render: function(param) {
                                var handleSubmit = param.handleSubmit;
                                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                    onSubmit: handleSubmit,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mt-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                htmlFor: "body",
                                                                className: "Form-label is-required inline-block",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: "Adauga comentariul tau"
                                                                })
                                                            }),
                                                            type === "reviews" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "inline-block mb-1 ml-1 text-gray-light",
                                                                children: [
                                                                    " ",
                                                                    "(100 — 2000 de caractere)"
                                                                ]
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "inline-block mb-1 ml-1 text-gray-light",
                                                                children: [
                                                                    " ",
                                                                    "(2 — 2000 de caractere)"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                                        name: "body",
                                                        id: "review_body",
                                                        component: Textarea/* default */.Z,
                                                        rows: "5",
                                                        validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMaxLength */.aG)(2000), (0,validations/* hasMinLength */.vd)(type === "reviews" ? 100 : 2))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "md:flex items-center mt-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "hidden md:block",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                            title: "Trimite comentariul",
                                                            type: "submit"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "md:hidden",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                            title: "Trimite comentariul",
                                                            type: "submit",
                                                            size: "normal",
                                                            display: "block"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "md:ml-4 text-center mt-4 md:mt-0",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: "text-red-brand font-bold focus:outline-none focus:underline hover:underline",
                                                            type: "button",
                                                            onClick: closeForm,
                                                            children: "Renunta"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }));
                            }
                        })
                    ]
                }));
            }
        }
    ]);
    return AddCommentForm;
}(react.Component);
/* harmony default export */ var Reviews_AddCommentForm = ((0,es/* connect */.$j)(function(state) {
    return {
        user: state.user
    };
}, {
    apiCall: app_actions/* apiCall */.k_
})(AddCommentForm));

;// CONCATENATED MODULE: ./containers/Reviews/CommentItem.js








function CommentItem_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function CommentItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function CommentItem_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                CommentItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                CommentItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function CommentItem_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function CommentItem_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function CommentItem_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) CommentItem_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) CommentItem_defineProperties(Constructor, staticProps);
    return Constructor;
}
function CommentItem_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CommentItem_getPrototypeOf(o) {
    CommentItem_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return CommentItem_getPrototypeOf(o);
}
function CommentItem_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) CommentItem_setPrototypeOf(subClass, superClass);
}
function CommentItem_possibleConstructorReturn(self, call) {
    if (call && (CommentItem_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return CommentItem_assertThisInitialized(self);
}
function CommentItem_setPrototypeOf(o, p) {
    CommentItem_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return CommentItem_setPrototypeOf(o, p);
}
var CommentItem_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function CommentItem_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function CommentItem_createSuper(Derived) {
    var hasNativeReflectConstruct = CommentItem_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = CommentItem_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = CommentItem_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return CommentItem_possibleConstructorReturn(this, result);
    };
}
var CommentItem = /*#__PURE__*/ function(Component1) {
    "use strict";
    CommentItem_inherits(CommentItem, Component1);
    var _super = CommentItem_createSuper(CommentItem);
    function CommentItem() {
        CommentItem_classCallCheck(this, CommentItem);
        var _this;
        _this = _super.call(this);
        var _this1 = CommentItem_assertThisInitialized(_this);
        CommentItem_defineProperty(CommentItem_assertThisInitialized(_this), "upvote", function() {
            var _ref = CommentItem_asyncToGenerator(runtime_default().mark(function _callee(id, event) {
                var res;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            event.persist();
                            if (!_this1.props.user.isLoggedIn) {
                                _ctx.next = 11;
                                break;
                            }
                            if (!_this1.props.comment.community.customers_downvoting.includes(_this1.props.user.customer.id)) {
                                _ctx.next = 5;
                                break;
                            }
                            _ctx.next = 5;
                            return _this1.props.apiCall({
                                spinner: true,
                                alert: true,
                                apiCall: _this1.props.type === "reviews" ? api/* downvoteReviewApi */.k1s : api/* downvoteQuestionApi */.aoU,
                                apiArgs: [
                                    {
                                        id: id,
                                        communityCustomerId: _this1.props.user.customer.id,
                                        downVotes: true
                                    }, 
                                ],
                                returnResponse: false
                            });
                        case 5:
                            _ctx.next = 7;
                            return _this1.props.apiCall({
                                spinner: true,
                                alert: true,
                                apiCall: _this1.props.type === "reviews" ? api/* upvoteReviewApi */.zDH : api/* upvoteQuestionApi */.XBk,
                                apiArgs: [
                                    {
                                        id: id,
                                        communityCustomerId: _this1.props.user.customer.id
                                    }
                                ],
                                returnResponse: true,
                                postSuccess: function() {
                                    _this1.setState({
                                        upvoteChecked: true,
                                        downvoteChecked: false
                                    });
                                    _this1.props.addAlert({
                                        message: "Votul tau a fost inregistrat. Iti multumim.",
                                        variant: "success"
                                    });
                                }
                            });
                        case 7:
                            res = _ctx.sent;
                            // set information is state in order to have proper display of data
                            _this1.setState({
                                customers_downvoting: res.data.community.customers_downvoting,
                                customers_upvoting: res.data.community.customers_upvoting
                            });
                            _ctx.next = 12;
                            break;
                        case 11:
                            {
                                _this1.props.addAlert({
                                    message: "Trebuie sa fii autentificat.",
                                    variant: "error"
                                });
                            }
                        case 12:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(id, event) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this2 = CommentItem_assertThisInitialized(_this);
        CommentItem_defineProperty(CommentItem_assertThisInitialized(_this), "downvote", function() {
            var _ref = CommentItem_asyncToGenerator(runtime_default().mark(function _callee(id, event) {
                var res;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            event.persist();
                            if (!_this2.props.user.isLoggedIn) {
                                _ctx.next = 11;
                                break;
                            }
                            if (!_this2.props.comment.community.customers_upvoting.includes(_this2.props.user.customer.id)) {
                                _ctx.next = 5;
                                break;
                            }
                            _ctx.next = 5;
                            return _this2.props.apiCall({
                                spinner: true,
                                alert: true,
                                apiCall: _this2.props.type === "reviews" ? api/* upvoteReviewApi */.zDH : api/* upvoteQuestionApi */.XBk,
                                apiArgs: [
                                    {
                                        id: id,
                                        communityCustomerId: _this2.props.user.customer.id,
                                        downVotes: true
                                    }, 
                                ],
                                returnResponse: false
                            });
                        case 5:
                            _ctx.next = 7;
                            return _this2.props.apiCall({
                                spinner: true,
                                alert: true,
                                apiCall: _this2.props.type === "reviews" ? api/* downvoteReviewApi */.k1s : api/* downvoteQuestionApi */.aoU,
                                apiArgs: [
                                    {
                                        id: id,
                                        communityCustomerId: _this2.props.user.customer.id
                                    }
                                ],
                                returnResponse: true,
                                postSuccess: function() {
                                    _this2.setState({
                                        upvoteChecked: false,
                                        downvoteChecked: true
                                    });
                                    _this2.props.addAlert({
                                        message: "Votul tau a fost inregistrat. Iti multumim.",
                                        variant: "success"
                                    });
                                }
                            });
                        case 7:
                            res = _ctx.sent;
                            // set information is state in order to have proper display of data
                            _this2.setState({
                                customers_downvoting: res.data.community.customers_downvoting,
                                customers_upvoting: res.data.community.customers_upvoting
                            });
                            _ctx.next = 12;
                            break;
                        case 11:
                            {
                                _this2.props.addAlert({
                                    message: "Trebuie sa fii autentificat.",
                                    variant: "error"
                                });
                            }
                        case 12:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(id, event) {
                return _ref.apply(this, arguments);
            };
        }());
        _this.state = {
            upvoteChecked: false,
            downvoteChecked: false
        };
        _this.upvote = _this.upvote.bind(CommentItem_assertThisInitialized(_this));
        _this.downvote = _this.downvote.bind(CommentItem_assertThisInitialized(_this));
        _this.onChangeValue = _this.onChangeValue.bind(CommentItem_assertThisInitialized(_this));
        return _this;
    }
    CommentItem_createClass(CommentItem, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.user.customer !== null) {
                    this.setState({
                        upvoteChecked: this.props.comment.community.customers_upvoting.includes(this.props.user.customer.id),
                        downvoteChecked: this.props.comment.community.customers_downvoting.includes(this.props.user.customer.id)
                    });
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (prevProps.user.customer !== this.props.user.customer) {
                    if (this.props.user.customer !== null) {
                        this.setState({
                            upvoteChecked: this.props.comment.community.customers_upvoting.includes(this.props.user.customer.id),
                            downvoteChecked: this.props.comment.community.customers_downvoting.includes(this.props.user.customer.id)
                        });
                    }
                }
            }
        },
        {
            key: "onChangeValue",
            value: function onChangeValue(event) {
                if (event.target.value === "da") {
                    this.upvote(this.props.comment._id, event);
                } else {
                    this.downvote(this.props.comment._id, event);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _state = this.state, upvoted = _state.upvoted, downvoted = _state.downvoted;
                var _props = this.props, index = _props.index, comment = _props.comment, type = _props.type;
                var name = "helpful-" + comment._id;
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    className: "py-4 ".concat(index === 0 ? "" : "border-t border-gray-lighter"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "md:flex items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-black font-bold",
                                    children: comment.customer.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "hidden md:block h-1 w-1 bg-gray-light rounded-full mx-2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: (0,helpers/* formatDate */.p6)(comment.date)
                                }),
                                comment.fromMerchandiser && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "md:ml-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "inline-block text-white text-xs uppercase leading-none rounded-sm p-1",
                                        style: {
                                            backgroundColor: "#51C1ED"
                                        },
                                        children: "Reprezentant oficial"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "break-words whitespace-pre-wrap",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-gray-dark",
                                children: comment.body
                            })
                        }),
                        type !== "reviews" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center flex-wrap mt-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    htmlFor: name + "da",
                                    className: "Form-label inline-block mr-4 w-full sm:w-auto",
                                    children: "Ti-a fost de ajutor?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    className: "Form-checkbox inline-flex items-center mr-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            name: name + "da",
                                            type: "radio",
                                            value: "da",
                                            className: "checkbox-input opacity-0 w-0 h-0",
                                            onChange: this.onChangeValue,
                                            checked: this.state.upvoteChecked
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "checkbox-control is-radio flex-none inline-flex w-5 h-5 p-1 mr-2 border-gray-light border rounded-full bg-white",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                width: "10",
                                                height: "10",
                                                viewBox: "0 0 10 10",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                    width: "10",
                                                    height: "10",
                                                    rx: "5",
                                                    fill: "#319D10"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "Form-label inline-block",
                                            children: [
                                                "Da (",
                                                get_default()(comment, "community.upvotes", 0) + (upvoted ? 1 : 0),
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    className: "Form-checkbox inline-flex items-center mr-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            name: name + "nu",
                                            type: "radio",
                                            value: "nu",
                                            className: "checkbox-input opacity-0 w-0 h-0",
                                            onChange: this.onChangeValue,
                                            checked: this.state.downvoteChecked
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "checkbox-control is-radio flex-none inline-flex w-5 h-5 p-1 mr-2 border-gray-light border rounded-full bg-white",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                width: "10",
                                                height: "10",
                                                viewBox: "0 0 10 10",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                    width: "10",
                                                    height: "10",
                                                    rx: "5",
                                                    fill: "#319D10"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "Form-label inline-block",
                                            children: [
                                                "Nu (",
                                                get_default()(comment, "community.downvotes", 0) + (downvoted ? 1 : 0),
                                                ")"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }, comment._id));
            }
        }
    ]);
    return CommentItem;
}(react.Component);
/* harmony default export */ var Reviews_CommentItem = ((0,es/* connect */.$j)(function(state) {
    return {
        user: state.user
    };
}, {
    apiCall: app_actions/* apiCall */.k_,
    addAlert: app_actions/* addAlert */.V_
})(CommentItem));

;// CONCATENATED MODULE: ./containers/Reviews/ReviewProductVariation.js

var ReviewProductVariation = function(param) {
    var variation = param.variation;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-sm text-gray-dark",
                children: "Varianta produsului"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-row md:flex-col lg:flex-row gap-1.5 w-full mt-1.5",
                children: variation.map(function(label, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("p", {
                        className: "px-2 py-0.5 md:py-1 rounded bg-[#F2F2F2] text-sm text-gray-dark w-max",
                        children: label
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var Reviews_ReviewProductVariation = (ReviewProductVariation);

// EXTERNAL MODULE: ./components/Form/InputText.js + 2 modules
var InputText = __webpack_require__(58833);
;// CONCATENATED MODULE: ./containers/Reviews/EditReviewModal/EditReviewModalImages.js





function EditReviewModalImages_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function EditReviewModalImages_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return EditReviewModalImages_arrayLikeToArray(arr);
}
function EditReviewModalImages_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function EditReviewModalImages_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function EditReviewModalImages_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function EditReviewModalImages_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            EditReviewModalImages_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function EditReviewModalImages_toConsumableArray(arr) {
    return EditReviewModalImages_arrayWithoutHoles(arr) || EditReviewModalImages_iterableToArray(arr) || EditReviewModalImages_unsupportedIterableToArray(arr) || EditReviewModalImages_nonIterableSpread();
}
function EditReviewModalImages_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return EditReviewModalImages_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return EditReviewModalImages_arrayLikeToArray(o, minLen);
}
var EditReviewModalImages = function(param) {
    var addAlert1 = param.addAlert, removeExistingImages = param.removeExistingImages, parseNewImages = param.parseNewImages, thumbnailImages = param.thumbnailImages;
    var ref = (0,react.useState)(thumbnailImages), thumbnailImagesList = ref[0], setThumbnailImagesList = ref[1];
    var ref1 = (0,react.useState)([]), newImages = ref1[0], setNewImages = ref1[1];
    var handleFileUpload = function(event) {
        event.persist();
        var images = EditReviewModalImages_toConsumableArray(newImages);
        if (event.target.files && event.target.files.length > 0) {
            var file = event.target.files[0];
            var fileType = file["type"];
            var validImageTypes = [
                "image/gif",
                "image/jpeg",
                "image/png"
            ];
            if (!validImageTypes.includes(fileType) || file.name.split(".").find(function(element) {
                return element === "jfif";
            }) || file.name.split(".").find(function(element) {
                return element === "gif";
            })) {
                addAlert1({
                    message: "Sunt permise doar fisiere de tipul JPEG, JPG si PNG",
                    variant: "error"
                });
                return;
            }
            if (file.size > 5242880) {
                event.target.value = "";
                addAlert1({
                    message: "Sunt permise doar fisiere care sunt mai mici de 5 MB",
                    variant: "error"
                });
                return;
            }
            // create img preview object used for display and same file verification
            var imgFile = {
                name: event.target.files[0]["name"],
                objectPreview: URL.createObjectURL(file),
                file: file
            };
            // check for duplicate file
            if (thumbnailImagesList.find(function(item) {
                return item.name === imgFile.name;
            })) {
                // reset event value
                event.target.value = "";
                addAlert1({
                    message: "Fisier duplicat" + " " + imgFile.name,
                    variant: "error"
                });
                return;
            }
            images.push(imgFile);
            setNewImages(images);
            setThumbnailImagesList(function(prevState) {
                return EditReviewModalImages_toConsumableArray(prevState).concat([
                    imgFile
                ]);
            });
            parseNewImages(images);
            event.target.value = "";
        }
    };
    var removeImage = function(key) {
        var imgList = EditReviewModalImages_toConsumableArray(thumbnailImagesList);
        var selectedImage = imgList[key];
        if (typeof selectedImage === "string") {
            removeExistingImages(selectedImage);
        }
        if (typeof selectedImage === "object") {
            var newImagesArray = EditReviewModalImages_toConsumableArray(newImages);
            var selectedImageKey = newImagesArray.indexOf(selectedImage);
            newImagesArray.splice(selectedImageKey, 1);
            setNewImages(newImagesArray);
            parseNewImages(newImagesArray);
        }
        imgList.splice(key, 1);
        setThumbnailImagesList(imgList);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex",
        children: [
            thumbnailImagesList.length > 0 && thumbnailImagesList.map(function(item, index) {
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-center items-center relative border border-gray-1100 rounded-tr-lg rounded-bl-lg w-[64px] h-[64px] md:w-[80px] md:h-[80px] mr-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute ml-16 -mt-2 bg-black text-white rounded-xl cursor-pointer top-0 -right-1",
                            onClick: function() {
                                return removeImage(index);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                className: "h-5 w-5 rotate-45",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: "2",
                                    d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            className: "flex items-center bg-gray-100 tracking-wide hover:bg-gray-101 w-[60px] h-[60px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "rounded-[6px] h-[60px] w-[60px] object-cover",
                                src: item.objectPreview || item,
                                alt: ""
                            })
                        })
                    ]
                }, index);
            }),
            thumbnailImagesList.length < 5 && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                name: "images",
                render: function(props) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("label", {
                        className: "flex items-center justify-center w-[64px] h-[64px] md:w-[80px] md:h-[80px] p-2 border border-gray-1100 rounded-tr-lg rounded-bl-lg cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                className: "w-8 h-8",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: "2",
                                    d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", EditReviewModalImages_objectSpread({}, props.input, {
                                id: "attachment",
                                name: "attachment",
                                type: "file",
                                className: "hidden",
                                // iOS Safari 12 supports only image/* types
                                accept: "image/jpg,image/png,image/jpeg",
                                disabled: thumbnailImagesList.length > 4 ? true : false,
                                onChange: handleFileUpload
                            }))
                        ]
                    });
                }
            })
        ]
    }));
};
/* harmony default export */ var EditReviewModal_EditReviewModalImages = ((0,es/* connect */.$j)(null, {
    addAlert: app_actions/* addAlert */.V_
})(EditReviewModalImages));

;// CONCATENATED MODULE: ./containers/Reviews/EditReviewModal/EditReviewModalRating.js




function EditReviewModalRating_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function EditReviewModalRating_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            EditReviewModalRating_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var EditReviewModalRating = function(param) {
    var values = param.values;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: "mt-6 -mb-4 Form-label is-required",
                children: "Selecteaza o nota"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center mb-2",
                children: [
                    1,
                    2,
                    3,
                    4,
                    5
                ].map(function(starVal) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                        name: "rating",
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingStar/* default */.Z, {
                            width: "23px",
                            height: "21px",
                            className: "mr-3px cursor-pointer ".concat(values && values.rating && values.rating >= starVal ? "text-yellow" : "text-gray-200")
                        }),
                        type: "radio",
                        value: starVal,
                        validate: (0,validations/* isRequired */.q9)(),
                        children: function(props) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("label", {
                                className: "Form-radio",
                                style: {
                                    margin: 0,
                                    padding: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", EditReviewModalRating_objectSpread({}, props.input, {
                                        type: "radio",
                                        disabled: props.disabled,
                                        className: "checkbox-input opacity-0 w-0 h-0"
                                    })),
                                    typeof props.label === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        dangerouslySetInnerHTML: {
                                            __html: props.label
                                        }
                                    }) : props.label
                                ]
                            });
                        }
                    }, "star-item-".concat(starVal));
                })
            })
        ]
    });
};
/* harmony default export */ var EditReviewModal_EditReviewModalRating = (EditReviewModalRating);

// EXTERNAL MODULE: ./components/Form/Checkbox.js
var Checkbox = __webpack_require__(71662);
;// CONCATENATED MODULE: ./containers/Reviews/EditReviewModal/EditReviewModalTerms.js





var EditReviewModalTerms_ref = (0,config["default"])(), EditReviewModalTerms_settings = EditReviewModalTerms_ref.publicRuntimeConfig.settings;
var EditReviewModalTerms = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                name: "termsAndContitions",
                component: Checkbox/* default */.Z,
                type: "checkbox",
                required: true,
                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "inline-block mb-1 ml-1 font-normal text-sm",
                    children: [
                        "Prin adaugarea acestui review sunt de acord cu",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "".concat(EditReviewModalTerms_settings.baseUrl, "/suport-clienti/informatii-generale-termeni-si-conditii/"),
                            title: "Termenii si Conditiile",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: "font-bold text-sm text-red-lightdark",
                            children: "Termenii si Conditiile*"
                        })
                    ]
                }),
                validate: (0,validations/* isRequired */.q9)()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                name: "gdpr",
                component: Checkbox/* default */.Z,
                type: "checkbox",
                required: true,
                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "inline-block mb-1 ml-1 font-normal text-sm",
                    children: [
                        "Sunt de acord cu",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "".concat(EditReviewModalTerms_settings.baseUrl, "/nota-informare-date-caracter-personal/pag/"),
                            title: "Politica GDPR",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: "font-bold text-sm text-red-lightdark",
                            children: "politica GDPR*"
                        })
                    ]
                }),
                validate: (0,validations/* isRequired */.q9)()
            })
        ]
    }));
};
/* harmony default export */ var EditReviewModal_EditReviewModalTerms = (EditReviewModalTerms);

;// CONCATENATED MODULE: ./containers/Reviews/EditReviewModal/index.js

















function EditReviewModal_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function EditReviewModal_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return EditReviewModal_arrayLikeToArray(arr);
}
function EditReviewModal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function EditReviewModal_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                EditReviewModal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                EditReviewModal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function EditReviewModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function EditReviewModal_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function EditReviewModal_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function EditReviewModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            EditReviewModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function EditReviewModal_toConsumableArray(arr) {
    return EditReviewModal_arrayWithoutHoles(arr) || EditReviewModal_iterableToArray(arr) || EditReviewModal_unsupportedIterableToArray(arr) || EditReviewModal_nonIterableSpread();
}
function EditReviewModal_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return EditReviewModal_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return EditReviewModal_arrayLikeToArray(o, minLen);
}
var EditReviewModal_ref = (0,config["default"])(), EditReviewModal_publicRuntimeConfig = EditReviewModal_ref.publicRuntimeConfig, EditReviewModal_cdn = EditReviewModal_publicRuntimeConfig.settings.cdn;
var EditReviewModal = function(param1) {
    var modalId = param1.modalId, review = param1.review, removeModal1 = param1.removeModal, addAlert1 = param1.addAlert, apiCall1 = param1.apiCall, onEditReview = param1.onEditReview;
    var ref3;
    var ref1 = (0,react.useState)([]), newImages = ref1[0], setNewImages = ref1[1];
    var ref2 = (0,react.useState)([]), deleteExistingImages = ref2[0], setDeleteExistingImages = ref2[1];
    var thumbnailImages = review === null || review === void 0 ? void 0 : (ref3 = review.images) === null || ref3 === void 0 ? void 0 : ref3.map(function(image) {
        return "".concat(EditReviewModal_cdn, "/resize/reviews-files/").concat(review._id, "/").concat(md5_default()("60x60"), "/").concat(image);
    });
    var parseNewImages = function(imgArr) {
        setNewImages([]);
        imgArr.map(function(item) {
            var reader = new FileReader();
            reader.readAsDataURL(item.file);
            reader.addEventListener("load", function() {
                return setNewImages(function(prevState) {
                    return EditReviewModal_toConsumableArray(prevState).concat([
                        reader.result
                    ]);
                });
            });
        });
    };
    var removeExistingImages = function(img) {
        var splitUrl = img.split("/");
        var imgUrl = splitUrl[splitUrl.length - 1];
        setDeleteExistingImages(function(prevState) {
            return EditReviewModal_toConsumableArray(prevState).concat([
                imgUrl
            ]);
        });
    };
    var clearModalState = function() {
        setNewImages([]);
        setDeleteExistingImages([]);
        removeModal1();
    };
    var submitForm = function() {
        var _ref = EditReviewModal_asyncToGenerator(runtime_default().mark(function _callee(data) {
            var imagesPayload, apiArgs, response1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        imagesPayload = {
                            images: newImages,
                            deleteImages: deleteExistingImages
                        };
                        delete data.gdpr;
                        delete data.termsAndContitions;
                        apiArgs = [
                            EditReviewModal_objectSpread({}, data, imagesPayload),
                            review._id
                        ];
                        _ctx.next = 6;
                        return apiCall1({
                            apiArgs: apiArgs,
                            apiCall: api/* editCustomerReviewApi */.h8V,
                            formatResponse: function(response) {
                                return response;
                            },
                            spinner: true,
                            returnResponse: true,
                            postSuccess: function() {
                                addAlert1({
                                    variant: "success",
                                    message: "Am trimis recenzia spre aprobare. Multumim!"
                                });
                            },
                            preFail: function(response) {
                                addAlert1({
                                    message: response.status === 409 ? response.data.message : "Ne pare rau, a aparut o eroare. Te rugam sa reincerci salvarea recenziei.",
                                    variant: "error"
                                });
                            }
                        });
                    case 6:
                        response1 = _ctx.sent;
                        if (response1 && response1.status === 200) {
                            onEditReview();
                            removeModal1(modalId);
                            clearModalState();
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitForm(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
        id: modalId,
        header: "Editeaza recenzia",
        onRemoveModal: clearModalState,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
            onSubmit: submitForm,
            initialValues: {
                rating: review.rating || 0,
                title: review.title || "",
                body: review.body || ""
            },
            render: function(param) {
                var handleSubmit = param.handleSubmit, values = param.values;
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: handleSubmit,
                    noValidate: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                            label: "Titlul recenziei",
                            name: "title",
                            id: "review_title",
                            required: true,
                            component: InputText/* default */.Z,
                            validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMinLength */.vd)(5), (0,validations/* hasMaxLength */.aG)(150))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EditReviewModal_EditReviewModalRating, {
                            values: values
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            htmlFor: "body",
                                            className: "Form-label is-required inline-block",
                                            children: "Descriere"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "inline-block mb-1 ml-1 text-gray-light font-normal text-sm leading-4",
                                            children: "(30 — 3000 de caractere)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                    name: "body",
                                    id: "review_body",
                                    component: Textarea/* default */.Z,
                                    inputClassName: "max-w-fulli",
                                    rows: "6",
                                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMinLength */.vd)(30), (0,validations/* hasMaxLength */.aG)(3000))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    className: "mb-3",
                                    children: "Imagini produs"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(EditReviewModal_EditReviewModalImages, {
                                    parseNewImages: parseNewImages,
                                    removeExistingImages: removeExistingImages,
                                    thumbnailImages: thumbnailImages
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditReviewModal_EditReviewModalTerms, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-center md:flex mt-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    type: "submit",
                                    title: "Salveaza",
                                    variant: "primary",
                                    classesProp: "mb-4 md:mb-0 w-full md:w-[240px] my-auto"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    onClick: function() {
                                        return clearModalState();
                                    },
                                    className: "text-red-brand underline my-auto px-8 cursor-pointer",
                                    children: "Renunta"
                                })
                            ]
                        })
                    ]
                }));
            }
        })
    }));
};
/* harmony default export */ var Reviews_EditReviewModal = ((0,es/* connect */.$j)(null, {
    addAlert: app_actions/* addAlert */.V_,
    removeModal: app_actions/* removeModal */.a_,
    apiCall: app_actions/* apiCall */.k_
})(EditReviewModal));

// EXTERNAL MODULE: ./containers/ModalErrorBoundary.js
var ModalErrorBoundary = __webpack_require__(33849);
;// CONCATENATED MODULE: ./containers/Reviews/ReviewItem.js



















function ReviewItem_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function ReviewItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ReviewItem_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ReviewItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ReviewItem_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ReviewItem_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function ReviewItem_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function ReviewItem_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) ReviewItem_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) ReviewItem_defineProperties(Constructor, staticProps);
    return Constructor;
}
function ReviewItem_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ReviewItem_getPrototypeOf(o) {
    ReviewItem_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return ReviewItem_getPrototypeOf(o);
}
function ReviewItem_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) ReviewItem_setPrototypeOf(subClass, superClass);
}
function ReviewItem_possibleConstructorReturn(self, call) {
    if (call && (ReviewItem_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return ReviewItem_assertThisInitialized(self);
}
function ReviewItem_setPrototypeOf(o, p) {
    ReviewItem_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return ReviewItem_setPrototypeOf(o, p);
}
var ReviewItem_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function ReviewItem_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function ReviewItem_createSuper(Derived) {
    var hasNativeReflectConstruct = ReviewItem_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = ReviewItem_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = ReviewItem_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return ReviewItem_possibleConstructorReturn(this, result);
    };
}
var ReviewItem_ref = (0,config["default"])(), ReviewItem_settings = ReviewItem_ref.publicRuntimeConfig.settings;
var ReviewItem = /*#__PURE__*/ function(Component1) {
    "use strict";
    ReviewItem_inherits(ReviewItem, Component1);
    var _super = ReviewItem_createSuper(ReviewItem);
    function ReviewItem() {
        ReviewItem_classCallCheck(this, ReviewItem);
        var _this;
        _this = _super.call(this);
        var _this1 = ReviewItem_assertThisInitialized(_this);
        ReviewItem_defineProperty(ReviewItem_assertThisInitialized(_this), "upvote", function() {
            var _ref = ReviewItem_asyncToGenerator(runtime_default().mark(function _callee(id, event) {
                var res;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            event.persist();
                            if (!_this1.props.user.isLoggedIn) {
                                _ctx.next = 11;
                                break;
                            }
                            if (!_this1.state.customers_downvoting.includes(_this1.props.user.customer.id)) {
                                _ctx.next = 5;
                                break;
                            }
                            _ctx.next = 5;
                            return _this1.props.apiCall({
                                spinner: true,
                                alert: true,
                                apiCall: _this1.props.type === "reviews" ? api/* downvoteReviewApi */.k1s : api/* downvoteQuestionApi */.aoU,
                                apiArgs: [
                                    {
                                        id: id,
                                        communityCustomerId: _this1.props.user.customer.id,
                                        downVotes: true
                                    }, 
                                ],
                                returnResponse: false
                            });
                        case 5:
                            _ctx.next = 7;
                            return _this1.props.apiCall({
                                spinner: true,
                                alert: true,
                                apiCall: _this1.props.type === "reviews" ? api/* upvoteReviewApi */.zDH : api/* upvoteQuestionApi */.XBk,
                                apiArgs: [
                                    {
                                        id: id,
                                        communityCustomerId: _this1.props.user.customer.id
                                    }
                                ],
                                returnResponse: true,
                                postSuccess: function() {
                                    _this1.setState({
                                        upvoted: true,
                                        downvoted: false
                                    });
                                    _this1.props.addAlert({
                                        message: "Votul tau a fost inregistrat. Iti multumim.",
                                        variant: "success"
                                    });
                                }
                            });
                        case 7:
                            res = _ctx.sent;
                            // set information is state in order to have proper display of data
                            _this1.setState({
                                customers_downvoting: res.data.community.customers_downvoting,
                                customers_upvoting: res.data.community.customers_upvoting
                            });
                            _ctx.next = 12;
                            break;
                        case 11:
                            {
                                _this1.props.addAlert({
                                    message: "Trebuie sa fii autentificat.",
                                    variant: "error"
                                });
                            }
                        case 12:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(id, event) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this2 = ReviewItem_assertThisInitialized(_this);
        ReviewItem_defineProperty(ReviewItem_assertThisInitialized(_this), "downvote", function() {
            var _ref = ReviewItem_asyncToGenerator(runtime_default().mark(function _callee(id, event) {
                var res;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            event.persist();
                            if (!_this2.props.user.isLoggedIn) {
                                _ctx.next = 11;
                                break;
                            }
                            if (!_this2.state.customers_upvoting.includes(_this2.props.user.customer.id)) {
                                _ctx.next = 5;
                                break;
                            }
                            _ctx.next = 5;
                            return _this2.props.apiCall({
                                spinner: true,
                                alert: true,
                                apiCall: _this2.props.type === "reviews" ? api/* upvoteReviewApi */.zDH : api/* upvoteQuestionApi */.XBk,
                                apiArgs: [
                                    {
                                        id: id,
                                        communityCustomerId: _this2.props.user.customer.id,
                                        downVotes: true
                                    }, 
                                ],
                                returnResponse: false
                            });
                        case 5:
                            _ctx.next = 7;
                            return _this2.props.apiCall({
                                spinner: true,
                                alert: true,
                                apiCall: _this2.props.type === "reviews" ? api/* downvoteReviewApi */.k1s : api/* downvoteQuestionApi */.aoU,
                                apiArgs: [
                                    {
                                        id: id,
                                        communityCustomerId: _this2.props.user.customer.id
                                    }
                                ],
                                returnResponse: true,
                                postSuccess: function() {
                                    _this2.setState({
                                        upvoted: false,
                                        downvoted: true
                                    });
                                    _this2.props.addAlert({
                                        message: "Votul tau a fost inregistrat. Iti multumim.",
                                        variant: "success"
                                    });
                                }
                            });
                        case 7:
                            res = _ctx.sent;
                            // set information is state in order to have proper display of data
                            _this2.setState({
                                customers_downvoting: res.data.community.customers_downvoting,
                                customers_upvoting: res.data.community.customers_upvoting
                            });
                            _ctx.next = 12;
                            break;
                        case 11:
                            {
                                _this2.props.addAlert({
                                    message: "Trebuie sa fii autentificat.",
                                    variant: "error"
                                });
                            }
                        case 12:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(id, event) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this3 = ReviewItem_assertThisInitialized(_this);
        ReviewItem_defineProperty(ReviewItem_assertThisInitialized(_this), "sameQuestion", function() {
            var _ref = ReviewItem_asyncToGenerator(runtime_default().mark(function _callee(id, event) {
                var same, res;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            event.persist();
                            if (!_this3.props.user.isLoggedIn) {
                                _ctx.next = 9;
                                break;
                            }
                            same = _this3.props.review.customers_sameQuestion.includes(_this3.props.user.customer.id);
                            _ctx.next = 5;
                            return _this3.props.apiCall({
                                spinner: true,
                                alert: true,
                                apiCall: api/* sameQuestionReviewApi */.cti,
                                apiArgs: [
                                    {
                                        id: id,
                                        communityCustomerId: _this3.props.user.customer.id,
                                        sameQuestion: same ? -1 : 1
                                    }, 
                                ],
                                returnResponse: true,
                                postSuccess: function() {
                                    _this3.props.addAlert({
                                        message: "Votul tau a fost inregistrat. Iti multumim.",
                                        variant: "success"
                                    });
                                }
                            });
                        case 5:
                            res = _ctx.sent;
                            // set information is state in order to have proper display of data
                            _this3.setState({
                                sameQuestionedArray: res.data.customers_sameQuestion
                            });
                            _ctx.next = 10;
                            break;
                        case 9:
                            {
                                _this3.props.addAlert({
                                    message: "Trebuie sa fii autentificat.",
                                    variant: "error"
                                });
                            }
                        case 10:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(id, event) {
                return _ref.apply(this, arguments);
            };
        }());
        ReviewItem_defineProperty(ReviewItem_assertThisInitialized(_this), "handleEditReviewModal", function() {
            _this.props.addModal("EditReviewModal-".concat(_this.props.index));
        });
        _this.state = {
            toggleList: false,
            toggleForm: false,
            upvoted: false,
            downvoted: false,
            photoIndex: 0,
            isOpen: false,
            customers_downvoting: [],
            customers_upvoting: [],
            sameQuestionedArray: []
        };
        _this.toggleList = _this.toggleList.bind(ReviewItem_assertThisInitialized(_this));
        _this.toggleForm = _this.toggleForm.bind(ReviewItem_assertThisInitialized(_this));
        return _this;
    }
    ReviewItem_createClass(ReviewItem, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.setState({
                    customers_downvoting: this.props.review.community.customers_downvoting,
                    customers_upvoting: this.props.review.community.customers_upvoting,
                    sameQuestionedArray: this.props.review.customers_sameQuestion
                });
            }
        },
        {
            key: "toggleList",
            value: function toggleList() {
                this.setState({
                    toggleList: !this.state.toggleList
                });
            }
        },
        {
            key: "toggleForm",
            value: function toggleForm() {
                this.setState({
                    toggleForm: !this.state.toggleForm
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var ref1;
                var _state = this.state, toggleList = _state.toggleList, toggleForm = _state.toggleForm, upvoted = _state.upvoted, downvoted = _state.downvoted, photoIndex = _state.photoIndex, isOpen = _state.isOpen;
                var _props = this.props, type = _props.type, review = _props.review, user = _props.user, // productId,
                productVariation = _props.productVariation, index1 = _props.index, onEditReview = _props.onEditReview;
                var isAddedByCurrentUser = Boolean(review.createdByCurrentUser);
                // const isBrandManager = Boolean(
                //   user.isLoggedIn && user.customer?.brand_manager
                // );
                var carouselImages = 0;
                if (type === "reviews" && review.images && review.images.length !== 0) {
                    carouselImages = review.images.map(function(item) {
                        return "".concat(ReviewItem_settings.cdn, "/reviews-files/").concat(review._id, "/").concat(item);
                    });
                }
                var upvoteChecked = false;
                var downvoteChecked = false;
                var sameQuestioned = false;
                if (user.customer != null) {
                    upvoteChecked = this.state.customers_upvoting.includes(user.customer.id);
                    downvoteChecked = this.state.customers_downvoting.includes(user.customer.id);
                    if (type !== "reviews") {
                        sameQuestioned = this.state.sameQuestionedArray.includes(user.customer.id);
                    }
                }
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-wrap",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "md:w-1/6 md:max-w-200pxi",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-black font-bold mb-1 md:mb-0 inline-block",
                                    children: review.customer.alias || review.customer.name || ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "md:hidden text-gray-dark font-bold text-3xl inline-block px-2",
                                    children: "."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-1 text-gray-dark font-normal md:mb-3 inline-block md:block text-sm",
                                    children: (0,helpers/* formatLocaleDate */.x1)(review.date)
                                }),
                                review.verifiedBuyer && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "sm:flex items-center mb-1 hidden",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mr-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_VerifiedBuy, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "leading-none",
                                            children: "Achizitie verificata"
                                        })
                                    ]
                                }),
                                productVariation && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "hidden md:inline-block w-full",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews_ReviewProductVariation, {
                                        variation: productVariation
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full md:w-5/6 pl-0 md:pl-52px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        type === "reviews" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "md:flex items-center mb-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center md:mr-4 mb-3 md:mb-0",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingStar/* default */.Z, {
                                                            className: "mr-3px ".concat(review.rating >= 1 ? "text-yellow" : "text-gray-200")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingStar/* default */.Z, {
                                                            className: "mr-3px ".concat(review.rating >= 2 ? "text-yellow" : "text-gray-200")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingStar/* default */.Z, {
                                                            className: "mr-3px ".concat(review.rating >= 3 ? "text-yellow" : "text-gray-200")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingStar/* default */.Z, {
                                                            className: "mr-3px ".concat(review.rating >= 4 ? "text-yellow" : "text-gray-200")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingStar/* default */.Z, {
                                                            className: "mr-3px ".concat(review.rating >= 5 ? "text-yellow" : "text-gray-200")
                                                        })
                                                    ]
                                                }),
                                                review.verifiedBuyer && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center mb-1 sm:hidden",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "mr-1",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_VerifiedBuy, {})
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "leading-none",
                                                            children: "Achizitie verificata"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        productVariation && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "inline-block md:hidden w-full mb-5",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews_ReviewProductVariation, {
                                                variation: productVariation
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex gap-[6px]",
                                            children: [
                                                !!review.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex items-center gap-[5px]",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        title: review.title,
                                                        as: "h3",
                                                        display: "h3",
                                                        font: "medium"
                                                    })
                                                }),
                                                type === "reviews" && isAddedByCurrentUser && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    onClick: function() {
                                                        return _this.handleEditReviewModal();
                                                    },
                                                    className: "text-red-brand hover:text-bleu-hover cursor-pointer",
                                                    children: "(editeaza recenzia)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "break-words whitespace-pre-wrap mb-3  ".concat(type === "reviews" ? "mt-2" : ""),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-gray-dark ".concat(type === "reviews" ? "" : "text-base leading-normal mt-0"),
                                                children: review.body
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex items-center",
                                            children: ((ref1 = review.images) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && review.images.map(function(item, index) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                    className: "mr-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            className: "object-cover w-[48px] h-[48px] rounded-[6px]",
                                                            src: "".concat(ReviewItem_settings.cdn, "/resize/reviews-files/").concat(review._id, "/").concat(md5_default()("60x60"), "/").concat(item),
                                                            alt: "",
                                                            onClick: function() {
                                                                return _this.setState({
                                                                    isOpen: true,
                                                                    photoIndex: index
                                                                });
                                                            }
                                                        })
                                                    })
                                                }, index);
                                            })
                                        }),
                                        isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                                            mainSrc: carouselImages[photoIndex],
                                            nextSrc: carouselImages[(photoIndex + 1) % carouselImages.length],
                                            prevSrc: carouselImages[(photoIndex + carouselImages.length - 1) % carouselImages.length],
                                            onCloseRequest: function() {
                                                return _this.setState({
                                                    isOpen: false
                                                });
                                            },
                                            onMovePrevRequest: function() {
                                                return _this.setState({
                                                    photoIndex: (photoIndex + carouselImages.length - 1) % carouselImages.length
                                                });
                                            },
                                            onMoveNextRequest: function() {
                                                return _this.setState({
                                                    photoIndex: (photoIndex + 1) % carouselImages.length
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex sm:items-center flex-col sm:flex-row mt-5 ",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    htmlFor: "helpful-".concat(type, "-").concat(review._id),
                                                    className: "Form-label inline-block mr-2 text-gray-text text-sm w-1/2 md:w-auto sm:mr-4",
                                                    children: "Ti-a fost de ajutor?"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "md:w-auto sm:mr-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: "flex",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                name: "helpful-".concat(type, "-").concat(review._id),
                                                                type: "radio",
                                                                value: "da",
                                                                //disabled={!isLoggedIn}
                                                                className: "checkbox-input opacity-0 w-0 h-0",
                                                                onChange: function(event) {
                                                                    if (event.target.checked) {
                                                                        _this.upvote(review._id, event);
                                                                    }
                                                                },
                                                                checked: upvoteChecked
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "checkbox-control is-radio flex-none w-5 h-5 p-1 mr-1 md:mr-2 border-gray-light border rounded-full bg-white",
                                                                style: {
                                                                    marginTop: "2px"
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                    width: "10",
                                                                    height: "10",
                                                                    viewBox: "0 0 10 10",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                                        width: "10",
                                                                        height: "10",
                                                                        rx: "5",
                                                                        fill: "#319D10"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "inline-block",
                                                                children: [
                                                                    "Da:",
                                                                    " ",
                                                                    get_default()(review, "community.upvotes", 0) + (upvoted ? 1 : 0)
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "md:w-auto",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: "flex",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                name: "helpful-".concat(type, "-").concat(review._id),
                                                                type: "checkbox",
                                                                value: "nu",
                                                                //disabled={!isLoggedIn}
                                                                className: "checkbox-input opacity-0 w-0 h-0",
                                                                onChange: function(event) {
                                                                    if (event.target.checked) {
                                                                        _this.downvote(review._id, event);
                                                                    }
                                                                },
                                                                checked: downvoteChecked
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "checkbox-control mt-[2px] is-radio flex-none w-5 h-5 p-1 mr-2 border-gray-light border rounded-full bg-white",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                    width: "10",
                                                                    height: "10",
                                                                    viewBox: "0 0 10 10",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                                        width: "10",
                                                                        height: "10",
                                                                        rx: "5",
                                                                        fill: "#319D10"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "inline-block",
                                                                children: [
                                                                    "Nu:",
                                                                    " ",
                                                                    get_default()(review, "community.downvotes", 0) + (downvoted ? 1 : 0)
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                type !== "reviews" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "sm:ml-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: "Form-checkbox flex items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                id: "same_question",
                                                                name: "same_question",
                                                                type: "checkbox",
                                                                className: "checkbox-input opacity-0 w-0 h-0",
                                                                //disabled={!isLoggedIn}
                                                                onChange: function(event) {
                                                                    if (event.target.checked) {
                                                                        _this.sameQuestion(review._id, event);
                                                                    }
                                                                },
                                                                checked: sameQuestioned
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "checkbox-control is-radio flex-none inline-flex w-5 h-5 p-1 mr-2 border-gray-light border rounded-full bg-white",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                    width: "10",
                                                                    height: "10",
                                                                    viewBox: "0 0 10 10",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                                        width: "10",
                                                                        height: "10",
                                                                        rx: "5",
                                                                        fill: "#319D10"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "Form-label inline-block",
                                                                children: [
                                                                    "Am aceeasi intrebare (",
                                                                    get_default()(review, "sameQuestion", 0) + (sameQuestioned ? 1 : 0),
                                                                    ")"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        review.children.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "md:flex items-center mt-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "my-2 md:my-0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    className: "text-red-brand text-sm focus:outline-none focus:underline hover:underline",
                                                    onClick: function() {
                                                        return _this.toggleList();
                                                    },
                                                    children: [
                                                        toggleList ? "Ascunde comentarii" : "Vezi comentarii",
                                                        " (",
                                                        review.children.length,
                                                        ")"
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                }),
                                (toggleForm || toggleList || type !== "reviews" && review.children.length > 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "border-t border-gray-lighter mt-4 pl-4",
                                    children: (toggleList || type !== "reviews") && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "m-o p-0",
                                        children: review.children.map(function(comment, index) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Reviews_CommentItem, {
                                                index: index,
                                                comment: comment,
                                                type: type
                                            }, comment._id);
                                        })
                                    })
                                })
                            ]
                        }),
                        type === "reviews" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalErrorBoundary/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews_EditReviewModal, {
                                modalId: "EditReviewModal-".concat(index1),
                                review: review,
                                onEditReview: onEditReview
                            })
                        })
                    ]
                }));
            }
        }
    ]);
    return ReviewItem;
}(react.Component);
/* harmony default export */ var Reviews_ReviewItem = ((0,es/* connect */.$j)(function(state) {
    return {
        user: state.user
    };
}, {
    apiCall: app_actions/* apiCall */.k_,
    addAlert: app_actions/* addAlert */.V_,
    addModal: app_actions/* addModal */.Y_
})(ReviewItem));

;// CONCATENATED MODULE: ./containers/Reviews/ReviewList.js




var ReviewList = function(param) {
    var loading = param.loading, reviews = param.reviews, reviewsSummary = param.reviewsSummary, type = param.type, productId = param.productId, productVariations = param.productVariations, onEditReview = param.onEditReview;
    if (loading) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {
            height: 150
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: "mt-4 p-0",
            children: reviews.map(function(review, i) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "py-20px md:py-33px border-gray-1100 ".concat(i != 0 ? "border-t" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews_ReviewItem, {
                            onEditReview: onEditReview,
                            index: i,
                            review: review,
                            reviewsSummary: reviewsSummary,
                            type: type,
                            productId: productId,
                            productVariation: productVariations && productVariations[review.productSku]
                        })
                    })
                }, review._id);
            })
        })
    }));
};
/* harmony default export */ var Reviews_ReviewList = (ReviewList);

;// CONCATENATED MODULE: ./containers/Reviews/SortFilter.js


function SortFilter_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SortFilter_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SortFilter_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var SortFilter = function(param) {
    var type = param.type, sortFilterData = param.sortFilterData, changeSort = param.changeSort, reviewsSummary = param.reviewsSummary;
    var ratingDistribution = reviewsSummary && reviewsSummary.ratingDistribution ? reviewsSummary.ratingDistribution : {};
    var _rating;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "lg:px-6 py-4 flex flex-row flex-wrap lg:bg-gray-lighter",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "inline-block w-1/2 md:w-auto pr-1 lg:pr-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: "block md:inline-block md:pr-2",
                        children: "Sorteaza"
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "Form-select Form-select--small md:inline-block max-w-full ".concat(type == "review" ? "pr-1" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                            value: undefined,
                            name: "sortare",
                            onChange: function(e) {
                                changeSort(SortFilter_objectSpread({}, sortFilterData, {
                                    sortBy: e.target.value === "populare" ? "upvotes" : "date"
                                }));
                            },
                            className: "max-w-fulli w-full md:w-auto",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "recente",
                                    children: "Cele mai recente primele"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "populare",
                                    children: type === "reviews" ? "Cele mai populare" : "Cele mai votate"
                                })
                            ]
                        })
                    })
                ]
            }),
            type === "reviews" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "inline-block w-1/2 md:w-auto pl-1 lg:pl-0 md:pr-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            className: "block md:inline-block md:pl-6 md:pr-1",
                            children: "Afiseaza"
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "Form-select Form-select--small md:inline-block max-w-full pl-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                name: "vizualizare",
                                value: (_rating = sortFilterData.rating) !== null && _rating !== void 0 ? _rating : "toate",
                                onChange: function(e) {
                                    var newSort = SortFilter_objectSpread({}, sortFilterData);
                                    if (e.target.value === "toate") {
                                        delete newSort.rating;
                                    } else {
                                        newSort.rating = parseInt(e.target.value);
                                    }
                                    changeSort(newSort);
                                },
                                className: "max-w-fulli w-full md:w-auto",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "toate",
                                        children: "Toate recenziile"
                                    }),
                                    [
                                        1,
                                        2,
                                        3,
                                        4,
                                        5
                                    ].map(function(star) {
                                        return ratingDistribution[star] ? /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: star,
                                            children: star === 1 ? "Doar recenziile cu 1 stea" : "Doar recenziile cu ".concat(star, " stele")
                                        }, "option-stars-".concat(star)) : null;
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ var Reviews_SortFilter = (SortFilter);

// EXTERNAL MODULE: ./components/Pagination.js
var Pagination = __webpack_require__(5625);
;// CONCATENATED MODULE: ./components/ProductReviews/ProductReviewsChart.js


function ProductReviewsChart_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ProductReviewsChart_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProductReviewsChart_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ProductReviewsChart = function(param) {
    var ratingDistribution = param.ratingDistribution, reviewsCount = param.reviewsCount, changeRatingFilter = param.changeRatingFilter, sortFilterData = param.sortFilterData, hasRatingFilters = param.hasRatingFilters;
    return [
        5,
        4,
        3,
        2,
        1
    ].map(function(rating) {
        var distribution = ratingDistribution[rating] || 0;
        var width = "".concat(parseFloat(distribution * 100 / reviewsCount).toFixed(2), "%");
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center mb-2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-2 text-sm font-bold leading-15.6",
                    children: rating
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingStar/* default */.Z, {
                        className: "w-13px h-13px ml-3px text-yellow"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-3 mx-3 relative overflow-hidden rounded-full grow bg-newGray",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute rounded-full top-0 left-0 bottom-0 ".concat({
                            5: "bg-[#16B735]",
                            4: "bg-[#C0DC26]",
                            3: "bg-[#FDCD1A]",
                            2: "bg-[#FD672C]",
                            1: "bg-[#D71541]"
                        }[rating]),
                        style: {
                            width: width
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-20 text-sm text-red-brand leading-15.6",
                    children: hasRatingFilters && distribution !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "underline underline-offset-4 cursor-pointer",
                        onClick: function() {
                            return changeRatingFilter(ProductReviewsChart_objectSpread({}, sortFilterData, {
                                rating: rating
                            }));
                        },
                        children: distribution === 1 ? "1 recenzie" : "".concat(distribution, " recenzii")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: distribution === 1 ? "1 recenzie" : "".concat(distribution, " recenzii")
                    })
                })
            ]
        }, "rating-".concat(rating)));
    });
};
/* harmony default export */ var ProductReviews_ProductReviewsChart = (ProductReviewsChart);

// EXTERNAL MODULE: ./node_modules/lodash/times.js
var times = __webpack_require__(98913);
var times_default = /*#__PURE__*/__webpack_require__.n(times);
;// CONCATENATED MODULE: ./components/ProductReviews/ProductReviewsInfo.js





var ProductReviewsInfo = function(param) {
    var reviewsSummary = param.reviewsSummary, placeholder = param.placeholder, visibleForm = param.visibleForm, userCanPostReview = param.userCanPostReview;
    var reviewsCount = get_default()(reviewsSummary, "reviews.value", 0);
    var reviewsRating = get_default()(reviewsSummary, "reviews.total", 0);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "md:flex items-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                minWidth: "200px"
            },
            children: [
                reviewsSummary && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                            className: "my-0 text-4xl lg:text-40px text-black font-medium",
                            children: [
                                isNaN(reviewsRating / reviewsCount) ? 0 : parseFloat(reviewsRating / reviewsCount).toFixed(2),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-gray-light",
                                    children: " din 5"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative inline-block",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex items-center",
                                        children: times_default()(5, function(i) {
                                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(RatingStar/* default */.Z, {
                                                width: "32px",
                                                height: "29px",
                                                className: "mr-1 text-gray-light"
                                            }, i));
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute inline-block top-0 left-0 right-0 overflow-hidden",
                                        style: {
                                            width: "".concat(reviewsRating / reviewsCount <= 5 ? parseFloat((reviewsRating / reviewsCount * 100 / 5).toFixed(2)) : 0, "%")
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex items-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex items-center",
                                                children: times_default()(5, function(i) {
                                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(RatingStar/* default */.Z, {
                                                        width: "32px",
                                                        height: "29px",
                                                        className: "mr-1 fill-current flex-none text-yellow"
                                                    }, i));
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hidden md:block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        title: "Adauga recenzia ta",
                        display: "block",
                        disabled: visibleForm || placeholder,
                        size: "normal",
                        onClick: function() {
                            return userCanPostReview();
                        }
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var ProductReviews_ProductReviewsInfo = (ProductReviewsInfo);

// EXTERNAL MODULE: ./node_modules/react-final-form-listeners/dist/react-final-form-listeners.es.js
var react_final_form_listeners_es = __webpack_require__(73337);
// EXTERNAL MODULE: ./components/LoginModal.js
var LoginModal = __webpack_require__(23409);
// EXTERNAL MODULE: ./components/RegisterModal.js
var RegisterModal = __webpack_require__(70187);
// EXTERNAL MODULE: ./components/ResetPassModal.js
var ResetPassModal = __webpack_require__(16586);
;// CONCATENATED MODULE: ./components/ProductReviews/ProductReviewsFormPlaceholder.js






var ProductReviewsFormPlaceholder_ref = (0,config["default"])(), ProductReviewsFormPlaceholder_settings = ProductReviewsFormPlaceholder_ref.publicRuntimeConfig.settings;
var ProductReviewsFormPlaceholder = function(param) {
    var addModal = param.addModal, label = param.label, _showLogin = param.showLogin, showLogin = _showLogin === void 0 ? true : _showLogin, type = param.type;
    var loginModalId = "add-modal-".concat(type === "reviews" ? "recenzii" : "intrebari");
    var registerModalId = "register-modal-".concat(type === "reviews" ? "recenzii" : "intrebari");
    var resetPassModalId = "reset-pass-modal-".concat(type === "reviews" ? "recenzii" : "intrebari");
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "md:w-1/2 mx-auto py-6 text-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "mb-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "".concat(ProductReviewsFormPlaceholder_settings.websiteStatics, "/images/quotes.svg"),
                        className: "inline align-top",
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-2xl -tracking-0.5 leading-31.2 font-light",
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "".concat(ProductReviewsFormPlaceholder_settings.websiteStatics, "/images/quotes.svg"),
                        className: "inline align-bottom",
                        alt: ""
                    })
                ]
            }),
            showLogin && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        onClick: function() {
                            return addModal(loginModalId);
                        },
                        className: "text-sm text-red-brand hover:text-bleu-hover underline",
                        children: "Intra in cont"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        onClick: function() {
                            return addModal(registerModalId);
                        },
                        className: "text-sm text-red-brand hover:text-bleu-hover underline",
                        children: "Creeaza cont nou"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalErrorBoundary/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginModal/* default */.Z, {
                            location: "pop-up-".concat(type === "reviews" ? "recenzii" : "intrebari"),
                            modalId: loginModalId,
                            registerModalId: registerModalId,
                            resetPassModalId: resetPassModalId
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalErrorBoundary/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResetPassModal/* default */.Z, {
                            modalId: resetPassModalId
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalErrorBoundary/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterModal/* default */.Z, {
                            modalId: registerModalId,
                            loginModalId: loginModalId
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var ProductReviews_ProductReviewsFormPlaceholder = (ProductReviewsFormPlaceholder);

;// CONCATENATED MODULE: ./containers/Reviews/AddReviewForm.js





















function AddReviewForm_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function AddReviewForm_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return AddReviewForm_arrayLikeToArray(arr);
}
function AddReviewForm_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function AddReviewForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function AddReviewForm_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                AddReviewForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                AddReviewForm_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function AddReviewForm_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function AddReviewForm_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function AddReviewForm_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) AddReviewForm_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) AddReviewForm_defineProperties(Constructor, staticProps);
    return Constructor;
}
function AddReviewForm_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AddReviewForm_getPrototypeOf(o) {
    AddReviewForm_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return AddReviewForm_getPrototypeOf(o);
}
function AddReviewForm_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) AddReviewForm_setPrototypeOf(subClass, superClass);
}
function AddReviewForm_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function AddReviewForm_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function AddReviewForm_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AddReviewForm_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function AddReviewForm_possibleConstructorReturn(self, call) {
    if (call && (AddReviewForm_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return AddReviewForm_assertThisInitialized(self);
}
function AddReviewForm_setPrototypeOf(o, p) {
    AddReviewForm_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return AddReviewForm_setPrototypeOf(o, p);
}
function AddReviewForm_toConsumableArray(arr) {
    return AddReviewForm_arrayWithoutHoles(arr) || AddReviewForm_iterableToArray(arr) || AddReviewForm_unsupportedIterableToArray(arr) || AddReviewForm_nonIterableSpread();
}
var AddReviewForm_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function AddReviewForm_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return AddReviewForm_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return AddReviewForm_arrayLikeToArray(o, minLen);
}
function AddReviewForm_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function AddReviewForm_createSuper(Derived) {
    var hasNativeReflectConstruct = AddReviewForm_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = AddReviewForm_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = AddReviewForm_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return AddReviewForm_possibleConstructorReturn(this, result);
    };
}
var AddReviewForm_ref = (0,config["default"])(), AddReviewForm_settings = AddReviewForm_ref.publicRuntimeConfig.settings;
var AddReviewForm = /*#__PURE__*/ function(Component1) {
    "use strict";
    AddReviewForm_inherits(AddReviewForm, Component1);
    var _super = AddReviewForm_createSuper(AddReviewForm);
    function AddReviewForm(props) {
        AddReviewForm_classCallCheck(this, AddReviewForm);
        var _this;
        _this = _super.call(this, props);
        var _this1 = AddReviewForm_assertThisInitialized(_this);
        AddReviewForm_defineProperty(AddReviewForm_assertThisInitialized(_this), "sendForm", function() {
            var _ref = AddReviewForm_asyncToGenerator(runtime_default().mark(function _callee(values) {
                var _props, type, productId, sku, title, body, rating, termsAndContitions, types, typeId, payload, addResponse;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _props = _this1.props, type = _props.type, productId = _props.productId, sku = _props.sku;
                            title = values.title, body = values.body, rating = values.rating, termsAndContitions = values.termsAndContitions, types = values.types;
                            typeId = types;
                            payload = {
                                productId: productId,
                                body: body,
                                typeId: typeId,
                                sku: sku
                            };
                            if (type === "reviews") {
                                payload.title = title;
                                payload.typeId = types;
                                payload.rating = parseInt(rating || 0);
                                if (termsAndContitions) {
                                    payload.terms = termsAndContitions;
                                }
                                if (_this1.state.uploadedFiles.length > 0) {
                                    payload.images = _this1.state.uploadedFiles;
                                }
                            }
                            _ctx.next = 7;
                            return _this1.props.apiCall({
                                spinner: true,
                                alert: true,
                                apiCall: type === "reviews" ? api/* postReviewsApi */.aAN : api/* postQuestionsApi */.NNx,
                                apiArgs: [
                                    payload
                                ],
                                returnResponse: true
                            });
                        case 7:
                            addResponse = _ctx.sent;
                            if (addResponse && addResponse.ok) {
                                _this1.setState({
                                    isSent: true,
                                    uploadedFiles: [],
                                    imagePreviewUrl: []
                                });
                                if (type === "reviews" && rating) {
                                    _this1.props.trackProductReview({
                                        sku: sku,
                                        rating: rating
                                    });
                                }
                            }
                        case 9:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            // this.alertRef.current.closest("#reviews").scrollIntoView();
            }));
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }());
        AddReviewForm_defineProperty(AddReviewForm_assertThisInitialized(_this), "displayForm", function() {
            _this.setState({
                isSent: false
            });
        });
        AddReviewForm_defineProperty(AddReviewForm_assertThisInitialized(_this), "handleFileUpload", function(event) {
            event.persist();
            if (event.target.files && event.target.files.length > 0) {
                var file = event.target.files[0];
                var fileType = file["type"];
                var validImageTypes = [
                    "image/gif",
                    "image/jpeg",
                    "image/png"
                ];
                if (!validImageTypes.includes(fileType) || file.name.split(".").find(function(element) {
                    return element === "jfif";
                }) || file.name.split(".").find(function(element) {
                    return element === "gif";
                })) {
                    _this.props.addAlert({
                        message: "Sunt permise doar fisiere de tipul JPEG, JPG si PNG",
                        variant: "error"
                    });
                    return;
                }
                if (file.size > 5242880) {
                    event.target.value = "";
                    _this.props.addAlert({
                        message: "Sunt permise doar fisiere care sunt mai mici de 5 MB",
                        variant: "error"
                    });
                    return;
                }
                // push images to state for client side display
                // make a copy of the object
                var images = AddReviewForm_toConsumableArray(_this.state.imagePreviewUrl);
                // create img preview object used vor display and same file verification
                var imgFile = {
                    name: event.target.files[0]["name"],
                    objectPreview: URL.createObjectURL(file)
                };
                // check for duplicate file
                if (_this.state.imagePreviewUrl.find(function(item) {
                    return item.name === imgFile.name;
                })) {
                    // reset event value
                    event.target.value = "";
                    // display alert
                    _this.props.addAlert({
                        message: "Fisier duplicat" + " " + imgFile.name,
                        variant: "error"
                    });
                    return;
                }
                // put img object in imagePreview array
                images.push(imgFile);
                _this.setState({
                    imagePreviewUrl: images
                });
                // push img file to state array that will be used for later upload
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function() {
                    var files = _this.state.uploadedFiles;
                    files.push(reader.result);
                    _this.setState({
                        uploadedFiles: files
                    });
                };
                event.target.value = "";
            }
        });
        AddReviewForm_defineProperty(AddReviewForm_assertThisInitialized(_this), "imageRemove", function(key) {
            var imgArray = AddReviewForm_toConsumableArray(_this.state.imagePreviewUrl);
            var imgEncoded = AddReviewForm_toConsumableArray(_this.state.uploadedFiles);
            imgArray.splice(key, 1);
            imgEncoded.splice(key, 1);
            _this.setState({
                uploadedFiles: imgEncoded,
                imagePreviewUrl: imgArray
            });
        });
        _this.state = {
            isSent: false,
            titleValue: "",
            uploadedFiles: [],
            reviewsType: [],
            imagePreviewUrl: []
        };
        _this._isMounted = false;
        _this.alertRef = /*#__PURE__*/ react.createRef();
        return _this;
    }
    AddReviewForm_createClass(AddReviewForm, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return AddReviewForm_asyncToGenerator(runtime_default().mark(function _callee() {
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _this._isMounted = true;
                            case 1:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._isMounted = false;
            }
        },
        {
            key: "setTitle",
            value: function setTitle(e) {
                this.setState({
                    titleValue: e
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, counter = _props.counter, closeForm = _props.closeForm, type = _props.type, placeholder = _props.placeholder, visibleForm = _props.visibleForm, placeholder_label = _props.placeholder_label, isLoggedIn = _props.user.isLoggedIn;
                var isSent = this.state.isSent;
                var url = "";
                if (true) {
                    url = window.location.href.split("/#")[0] + "/#questions";
                }
                if (isSent) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: this.alertRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                            type: "success",
                            onClose: this.displayForm,
                            children: type === "reviews" ? "Recenzia ta a fost adaugata. Iti multumim pentru contributie." : "Intrebarea ta a fost adaugata. Te vom anunta cand primesti un raspuns."
                        })
                    }));
                }
                if (placeholder && !visibleForm) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductReviews_ProductReviewsFormPlaceholder, {
                        label: placeholder_label,
                        showLogin: false
                    }));
                } else if (!placeholder && visibleForm) {
                    var _this3 = this;
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:mb-4 pt-2px pb-10px md:py-27px lg:px-4 md:px-8 text-black relative ".concat(isLoggedIn && !counter && type === "reviews" ? "md:bg-gray-102" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "lg:flex px-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "absolute hidden items-center top-0 right-0 mt-15px mr-15px cursor-pointer\n              ".concat(type !== "reviews" || counter ? "" : "md:flex", "\n              "),
                                    onClick: closeForm,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "pr-1 text-sm font-medium",
                                            children: "Inchide"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "rounded p-1 block appearance-none text-black",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                                width: "15px",
                                                height: "15px"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "lg:w-736px lg:pr-4 mx-auto",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mb-2 ".concat(type !== "reviews" ? "md:mb-1 font-normal leading-8 " : "md:mb-0  "),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                title: type === "reviews" ? "Adauga o recenzie" : "Adauga o intrebare",
                                                as: "h2",
                                                display: "h2"
                                            })
                                        }),
                                        isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
                                            onSubmit: this.sendForm,
                                            mutators: {
                                                setTitleOne: function(args, state, utils) {
                                                    utils.changeValue(state, "title", function() {
                                                        return "Imi place";
                                                    });
                                                },
                                                setTitleTwo: function(args, state, utils) {
                                                    utils.changeValue(state, "title", function() {
                                                        return "Merita";
                                                    });
                                                },
                                                setTitleThree: function(args, state, utils) {
                                                    utils.changeValue(state, "title", function() {
                                                        return "Bun";
                                                    });
                                                },
                                                setTitleFour: function(args, state, utils) {
                                                    utils.changeValue(state, "title", function() {
                                                        return "Recomand";
                                                    });
                                                },
                                                setTitleFive: function(args, state, utils) {
                                                    utils.changeValue(state, "title", function() {
                                                        return "Acceptabil";
                                                    });
                                                }
                                            },
                                            render: function(param) {
                                                var handleSubmit = param.handleSubmit, form = param.form, values = param.values, submitting = param.submitting, pristine = param.pristine, errors = param.errors, touched = param.touched;
                                                var _this2 = _this3;
                                                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                                    onSubmit: handleSubmit,
                                                    noValidate: true,
                                                    children: [
                                                        type === "reviews" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "flex items-center lg:mt-1 mb-2",
                                                                    children: [
                                                                        1,
                                                                        2,
                                                                        3,
                                                                        4,
                                                                        5
                                                                    ].map(function(starVal) {
                                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                                                            name: "rating",
                                                                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingStar/* default */.Z, {
                                                                                width: "23px",
                                                                                height: "21px",
                                                                                className: "mr-3px cursor-pointer ".concat(values && values.rating && values.rating >= starVal ? "text-yellow" : "text-gray-200")
                                                                            }),
                                                                            type: "radio",
                                                                            value: starVal,
                                                                            validate: (0,validations/* isRequired */.q9)(),
                                                                            children: function(props) {
                                                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("label", {
                                                                                    className: "Form-radio m-0 p-0",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", AddReviewForm_objectSpread({}, props.input, {
                                                                                            type: "radio",
                                                                                            disabled: props.disabled,
                                                                                            className: "checkbox-input opacity-0 w-0 h-0"
                                                                                        })),
                                                                                        typeof props.label === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            dangerouslySetInnerHTML: {
                                                                                                __html: props.label
                                                                                            }
                                                                                        }) : props.label
                                                                                    ]
                                                                                });
                                                                            }
                                                                        }, "star-item-".concat(starVal));
                                                                    })
                                                                }),
                                                                errors.rating && touched.rating && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "text-red-brand text-sm",
                                                                    children: errors.rating
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "mt-6 lg:w-full",
                                                            children: type === "reviews" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                htmlFor: "review_title",
                                                                                className: "Form-label is-required inline-block font-medium text-sm leading-4 mb-3",
                                                                                children: "Titlul recenziei"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "inline-block mb-1 ml-1 text-gray-light font-normal text-sm leading-4",
                                                                                children: "(3 — 150 characters)"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                                                        name: "title",
                                                                        id: "review_title",
                                                                        component: InputText/* default */.Z,
                                                                        value: _this3.state.titleValue,
                                                                        inputClassName: "max-w-fulli",
                                                                        validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMinLength */.vd)(3), (0,validations/* hasMaxLength */.aG)(150))
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "mt-6",
                                                            children: type === "reviews" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                            htmlFor: "review_title_suggestions",
                                                                            className: "Form-label inline-block font-medium text-sm leading-4 mb-3",
                                                                            children: "Sugestii titlu"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "font-normal text-sm",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                    type: "button",
                                                                                    className: "bg-orange-dark mt-1 mr-10px py-1 px-3 rounded-full",
                                                                                    onMouseDown: form.mutators.setTitleOne,
                                                                                    children: "Imi place"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                    type: "button",
                                                                                    className: "bg-orange-dark mt-1 mr-10px py-1 px-3 rounded-full",
                                                                                    onMouseDown: form.mutators.setTitleTwo,
                                                                                    children: "Merita"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                    type: "button",
                                                                                    className: "bg-orange-dark mt-1 mr-10px py-1 px-3 rounded-full",
                                                                                    onMouseDown: form.mutators.setTitleThree,
                                                                                    children: "Bun"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                    type: "button",
                                                                                    className: "bg-orange-dark mt-1 mr-10px py-1 px-3 rounded-full",
                                                                                    onMouseDown: form.mutators.setTitleFour,
                                                                                    children: "Recomand"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                    type: "button",
                                                                                    className: "bg-orange-dark mt-1 mr-10px py-1 px-3 rounded-full",
                                                                                    onMouseDown: form.mutators.setTitleFive,
                                                                                    children: "Acceptabil"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "mt-6 lg:w-full",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                            htmlFor: "body",
                                                                            className: "Form-label is-required inline-block font-bold",
                                                                            children: type === "reviews" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "font-medium text-sm leading-4 mb-3",
                                                                                children: "Recenzie"
                                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                children: "Intrebare"
                                                                            })
                                                                        }),
                                                                        type !== "reviews" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "inline-block mb-1 ml-1 text-gray-light",
                                                                            children: "(2 — 1000 de caractere)"
                                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "inline-block mb-1 ml-1 text-gray-light font-normal text-sm leading-4",
                                                                            children: "(30 — 3000 de caractere)"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                                                    name: "body",
                                                                    id: "review_body",
                                                                    component: Textarea/* default */.Z,
                                                                    inputClassName: "max-w-fulli",
                                                                    rows: "6",
                                                                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMinLength */.vd)(type === "reviews" ? 30 : 2), (0,validations/* hasMaxLength */.aG)(type === "reviews" ? 3000 : 1000))
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "mt-6",
                                                            children: type === "reviews" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "flex items-center text-sm font-normal p-2 rounded bg-gray-100 mb-3 lg:w-full",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "grow",
                                                                    children: [
                                                                        "Daca ai o intrebare legata de produs, te rugam sa o adaugi in sectiunea",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            className: "font-bold text-sm text-red-lightdark",
                                                                            children: [
                                                                                "\xa0",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    href: url,
                                                                                    children: "Intrebari"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        "."
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "mt-6",
                                                            children: type === "reviews" && {
                                                            } && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                        htmlFor: "review_title_suggestions",
                                                                        className: "Form-label inline-block font-medium text-sm leading-4 mb-3",
                                                                        children: [
                                                                            "Adauga imagine",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "inline-block mb-1 ml-1 text-gray-light font-normal text-sm leading-4",
                                                                                children: "(maximum 5 imagini)"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "flex justify-start gap-2",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "flex",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                    className: "".concat(_this3.state.imagePreviewUrl.length > 4 ? "disabled" : "", " place-content-center flex flex-col w-48px h-48px items-center bg-gray-100 rounded-md border border-gray-light tracking-wide cursor-pointer hover:bg-gray-101"),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                                            className: "h-6 w-6 text-red-lightdark",
                                                                                            fill: "none",
                                                                                            viewBox: "0 0 24 24",
                                                                                            stroke: "currentColor",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                                                strokeLinecap: "round",
                                                                                                strokeLinejoin: "round",
                                                                                                strokeWidth: "2",
                                                                                                d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
                                                                                            })
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                            id: "attachment",
                                                                                            name: "attachment",
                                                                                            type: "file",
                                                                                            className: "hidden",
                                                                                            // iOS Safari 12 supports only image/* types
                                                                                            accept: "image/jpg,image/png,image/jpeg",
                                                                                            disabled: _this3.state.imagePreviewUrl.length > 4 ? true : false,
                                                                                            ref: _this3.attachmentInput,
                                                                                            onChange: _this3.handleFileUpload
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            _this3.state.imagePreviewUrl.length > 0 && _this3.state.imagePreviewUrl.map(function(item, key) {
                                                                                var _this = _this2;
                                                                                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "absolute ml-8 -mt-2 bg-gray-1300 rounded-xl cursor-pointer",
                                                                                            onClick: function() {
                                                                                                return _this.imageRemove(key);
                                                                                            },
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                                className: "h-5 w-5 rotate-45",
                                                                                                fill: "none",
                                                                                                viewBox: "0 0 24 24",
                                                                                                stroke: "currentColor",
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                                                    strokeLinecap: "round",
                                                                                                    strokeLinejoin: "round",
                                                                                                    strokeWidth: "2",
                                                                                                    d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
                                                                                                })
                                                                                            }, key.toString() + "2")
                                                                                        }, key.toString() + "1"),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                            className: "items-center bg-gray-100 rounded-md tracking-wide hover:bg-gray-101 h-48px w-48px",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                className: "w-48px h-48px rounded-md object-cover",
                                                                                                src: item.objectPreview,
                                                                                                alt: key.toString() + "4"
                                                                                            })
                                                                                        }, key.toString() + "3")
                                                                                    ]
                                                                                }, key.toString() + "0"));
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "mt-6",
                                                            children: type === "reviews" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_listeners_es/* OnChange */.GU, {
                                                                        name: "termsAndContitions",
                                                                        children: function(value) {
                                                                            if (value && values["recommendYes"]) {
                                                                                form.reset(AddReviewForm_objectSpread({}, values, {
                                                                                    termsAndContitions: true
                                                                                }));
                                                                            }
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                                                        name: "termsAndContitions",
                                                                        component: Checkbox/* default */.Z,
                                                                        type: "checkbox",
                                                                        required: true,
                                                                        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            className: "inline-block mb-1 ml-1 font-normal text-sm",
                                                                            children: [
                                                                                "Prin adaugarea acestui review sunt de acord cu",
                                                                                " ",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    href: "".concat(AddReviewForm_settings.baseUrl, "/suport-clienti/informatii-generale-termeni-si-conditii/"),
                                                                                    title: "Termenii si Conditiile",
                                                                                    target: "_blank",
                                                                                    rel: "noopener noreferrer",
                                                                                    className: "font-bold text-sm text-red-lightdark",
                                                                                    children: "Termenii si Conditiile*"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        validate: (0,validations/* isRequired */.q9)()
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_listeners_es/* OnChange */.GU, {
                                                                        name: "gdpr",
                                                                        children: function(value) {
                                                                            if (value && values["recommendYes"]) {
                                                                                form.reset(AddReviewForm_objectSpread({}, values, {
                                                                                    termsAndContitions: true
                                                                                }));
                                                                            }
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                                                        name: "gdpr",
                                                                        component: Checkbox/* default */.Z,
                                                                        type: "checkbox",
                                                                        required: true,
                                                                        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            className: "inline-block mb-1 ml-1 font-normal text-sm",
                                                                            children: [
                                                                                "Sunt de acord cu",
                                                                                " ",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    href: "".concat(AddReviewForm_settings.baseUrl, "/nota-informare-date-caracter-personal/pag/"),
                                                                                    title: "Politica GDPR",
                                                                                    target: "_blank",
                                                                                    rel: "noopener noreferrer",
                                                                                    className: "font-bold text-sm text-red-lightdark",
                                                                                    children: "politica GDPR*"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        validate: (0,validations/* isRequired */.q9)()
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "md:flex items-center mt-4 lg:mb-12 sm:mb-6",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "hidden md:block ".concat(type !== "reviews" ? "md:w-190px" : "md:w-200px", " "),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                        title: type === "reviews" ? "Adauga recenzia ta" : "Trimite intrebarea ta",
                                                                        type: "submit",
                                                                        display: "block",
                                                                        size: "normal"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "md:hidden",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                        title: type === "reviews" ? "Adauga recenzia ta" : "Trimite intrebarea ta",
                                                                        size: "normal",
                                                                        display: "block",
                                                                        type: "submit",
                                                                        disabled: submitting || pristine
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "md:hidden md:ml-4 text-center mt-4 md:mt-0",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                        className: "text-red-brand font-bold focus:outline-none focus:underline hover:underline\n                                          ".concat(counter ? "hidden" : "", "\n                                        "),
                                                                        type: "button",
                                                                        onClick: closeForm,
                                                                        children: "Renunta"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }));
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    }));
                } else {
                    return "";
                }
            }
        }
    ]);
    return AddReviewForm;
}(react.Component);
/* harmony default export */ var Reviews_AddReviewForm = ((0,es/* connect */.$j)(function(state) {
    return {
        user: state.user
    };
}, {
    apiCall: app_actions/* apiCall */.k_,
    trackProductReview: actions/* trackProductReview */.rH,
    addAlert: app_actions/* addAlert */.V_
})(AddReviewForm));

// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation.css
var navigation = __webpack_require__(94375);
;// CONCATENATED MODULE: ./components/ProductReviews/ReviewsImagesSlider.js









var ReviewsImagesSlider_ref = (0,config["default"])(), ReviewsImagesSlider_settings = ReviewsImagesSlider_ref.publicRuntimeConfig.settings;
var ReviewsImagesSlider = function(param1) {
    var reviewsWithImages = param1.reviewsWithImages, onImageSelect = param1.onImageSelect;
    var ref2 = (0,react.useState)(true), isBeginning1 = ref2[0], setIsBeginning = ref2[1];
    var ref1 = (0,react.useState)(false), isEnd1 = ref1[0], setIsEnd = ref1[1];
    var nextArrowRef = (0,react.useRef)(null);
    var prevArrowRef = (0,react.useRef)(null);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: prevArrowRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex items-center h-full bg-[#F6F5F5] w-[25px] ".concat(isBeginning1 ? "opacity-50 cursor-default" : "opacity-90 cursor-pointer"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselNavArrow/* default */.Z, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                className: "w-full overflow-hidden px-[4px]",
                modules: [
                    modules/* Navigation */.W_,
                    modules/* Keyboard */.N1
                ],
                loop: false,
                navigation: {
                    nextEl: nextArrowRef.current,
                    prevEl: prevArrowRef.current
                },
                keyboard: true,
                autoHeight: true,
                onSlideChange: function(param) {
                    var isBeginning = param.isBeginning, isEnd = param.isEnd;
                    setIsBeginning(isBeginning);
                    setIsEnd(isEnd);
                },
                slidesPerGroup: 1,
                slidesPerView: 2,
                spaceBetween: 10,
                breakpoints: {
                    250: {
                        slidesPerGroup: 1,
                        slidesPerView: 2,
                        spaceBetween: 6
                    },
                    320: {
                        slidesPerGroup: 1,
                        slidesPerView: 3,
                        spaceBetween: 6
                    },
                    480: {
                        slidesPerGroup: 1,
                        slidesPerView: 4,
                        spaceBetween: 6
                    },
                    640: {
                        slidesPerGroup: 1,
                        slidesPerView: 5,
                        spaceBetween: 8
                    },
                    768: {
                        slidesPerGroup: 1,
                        slidesPerView: 8,
                        spaceBetween: 10
                    }
                },
                children: reviewsWithImages.map(function(review) {
                    return review.images.map(function(image, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "object-cover aspect-square cursor-pointer h-[120px] rounded-[4px]",
                                    src: "".concat(ReviewsImagesSlider_settings.cdn, "/resize/reviews-files/").concat(review._id, "/").concat(md5_default()("120x0"), "/").concat(image),
                                    alt: review._id,
                                    onClick: function() {
                                        return onImageSelect({
                                            reviewId: review._id,
                                            imageIndex: index
                                        });
                                    }
                                }, image)
                            })
                        }, image);
                    });
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: nextArrowRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex items-center h-full bg-[#F6F5F5] w-[25px] ".concat(isEnd1 ? "opacity-50 cursor-default" : "opacity-90 cursor-pointer"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselNavArrow/* default */.Z, {
                        direction: "right"
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var ProductReviews_ReviewsImagesSlider = (ReviewsImagesSlider);

// EXTERNAL MODULE: ./components/StarLabel.js
var StarLabel = __webpack_require__(80696);
;// CONCATENATED MODULE: ./components/ProductReviews/ReviewDetails.js













var ReviewDetails_ref = (0,config["default"])(), ReviewDetails_settings = ReviewDetails_ref.publicRuntimeConfig.settings;
var ReviewDetails = function(param) {
    var reviewDetails = param.reviewDetails, productVariations = param.productVariations, onPrevImageChange = param.onPrevImageChange, onNextImageChange = param.onNextImageChange, currentImageIndex = param.currentImageIndex;
    var reviewId = reviewDetails._id, customer = reviewDetails.customer, date = reviewDetails.date, verifiedBuyer = reviewDetails.verifiedBuyer, productSku = reviewDetails.productSku, rating = reviewDetails.rating, title = reviewDetails.title, body = reviewDetails.body, images = reviewDetails.images;
    var swiperRef = (0,react.useRef)(null);
    // set active index
    (0,react.useEffect)(function() {
        if (swiperRef.current && swiperRef.current.swiper) {
            swiperRef.current.swiper.activeIndex = currentImageIndex;
            // Update swiper after changing active index
            swiperRef.current.swiper.update();
        }
    }, [
        reviewDetails
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center mb-[25px] sm:mb-0 w-full sm:w-[50%] relative self-baseline",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: onPrevImageChange,
                        className: "arrow-left absolute w-[30px] z-10 left-[10px] rounded-full bg-gray-1300 cursor-pointer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselNavArrow/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        ref: swiperRef,
                        className: "overflow-hidden",
                        centeredSlides: true,
                        modules: [
                            modules/* Navigation */.W_,
                            modules/* Keyboard */.N1
                        ],
                        navigation: {
                            nextEl: ".arrow-right",
                            prevEl: ".arrow-left"
                        },
                        initialSlide: currentImageIndex,
                        slidesPerGroup: 1,
                        slidesPerView: 1,
                        watchOverflow: false,
                        keyboard: true,
                        children: images.map(function(image) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "object-cover",
                                    src: "".concat(ReviewDetails_settings.cdn, "/resize/reviews-files/").concat(reviewId, "/").concat(md5_default()("600x600"), "/").concat(image),
                                    alt: reviewId
                                })
                            }, image);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: onNextImageChange,
                        className: "arrow-right absolute w-[30px] z-10 right-[10px] rounded-full bg-gray-1300 cursor-pointer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselNavArrow/* default */.Z, {
                            direction: "right"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "sm:w-[50%] sm:pl-[15px]",
                children: [
                    (customer === null || customer === void 0 ? void 0 : customer.alias) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "font-bold leading-none",
                        children: customer.alias
                    }),
                    date && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[#808080] text-[14px] mb-[16px]",
                        children: (0,helpers/* formatDate */.p6)(date)
                    }),
                    verifiedBuyer && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center mb-[14px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_VerifiedBuy, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "leading-none ml-[4px]",
                                children: "Achizitie verificata"
                            })
                        ]
                    }),
                    productVariations && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "inline-block w-full mb-[16px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews_ReviewProductVariation, {
                            variation: productVariations[productSku]
                        })
                    }),
                    rating && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-[14px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StarLabel/* default */.Z, {
                            value: rating
                        })
                    }),
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[18px] font-medium mb-[8px]",
                        children: title
                    }),
                    body && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[14px]",
                        children: body
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var ProductReviews_ReviewDetails = (ReviewDetails);

;// CONCATENATED MODULE: ./components/ProductReviews/ProductReviewDetailsModal.js





var ProductReviewDetailsModal_ref = __webpack_require__(12280), ProductReviewDetailsModal_Modal = ProductReviewDetailsModal_ref.default;
var ProductReviewDetailsModal = function(param) {
    var reviewsImagesCount = param.reviewsImagesCount, reviewDetails = param.reviewDetails, productVariations = param.productVariations, onPrevImageChange = param.onPrevImageChange, onNextImageChange = param.onNextImageChange, currentImageIndex = param.currentImageIndex;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ProductReviewDetailsModal_Modal, {
        header: "Detalii imagine",
        id: "review-images-details",
        children: reviewDetails ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                reviewsImagesCount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    onClick: function() {
                        return (0,app_actions/* addModal */.Y_)("reviews-images-modal");
                    },
                    className: "text-red-brand text-[14px] cursor-pointer mb-[16px] hover:text-bleu-hover",
                    children: [
                        "Vezi toate fotografiile (",
                        reviewsImagesCount,
                        ")"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "sm:flex",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductReviews_ReviewDetails, {
                        reviewDetails: reviewDetails,
                        productVariations: productVariations,
                        onPrevImageChange: onPrevImageChange,
                        onNextImageChange: onNextImageChange,
                        currentImageIndex: currentImageIndex
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {
            height: 100
        })
    });
};
/* harmony default export */ var ProductReviews_ProductReviewDetailsModal = ((0,es/* connect */.$j)(null, {
    addModal: app_actions/* addModal */.Y_
})(ProductReviewDetailsModal));

;// CONCATENATED MODULE: ./components/ProductReviews/ProductReviewsImages.js



var ProductReviewsImages_ref = (0,config["default"])(), ProductReviewsImages_settings = ProductReviewsImages_ref.publicRuntimeConfig.settings;
var ProductReviewsImages = function(param) {
    var reviewsWithImages = param.reviewsWithImages, onImageSelect = param.onImageSelect;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: reviewsWithImages.map(function(review) {
            return review.images.map(function(image, index) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("img", {
                    className: "object-cover aspect-square cursor-pointer h-[120px] rounded-[4px]",
                    src: "".concat(ProductReviewsImages_settings.cdn, "/resize/reviews-files/").concat(review._id, "/").concat(md5_default()("120x0"), "/").concat(image),
                    alt: review._id,
                    onClick: function() {
                        return onImageSelect({
                            reviewId: review._id,
                            imageIndex: index
                        });
                    }
                }, image);
            });
        })
    });
};
/* harmony default export */ var ProductReviews_ProductReviewsImages = (ProductReviewsImages);

;// CONCATENATED MODULE: ./components/ProductReviews/ProductReviewsImagesModal.js



var ProductReviewsImagesModal = function(param) {
    var reviewsWithImages = param.reviewsWithImages, onImageSelect = param.onImageSelect;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
        header: "Galerie de imagini",
        id: "reviews-images-modal",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-[10px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductReviews_ProductReviewsImages, {
                reviewsWithImages: reviewsWithImages,
                onImageSelect: onImageSelect
            })
        })
    }));
};
/* harmony default export */ var ProductReviews_ProductReviewsImagesModal = (ProductReviewsImagesModal);

;// CONCATENATED MODULE: ./containers/Reviews/index.js






















function Reviews_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Reviews_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return Reviews_arrayLikeToArray(arr);
}
function Reviews_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Reviews_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Reviews_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Reviews_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function Reviews_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Reviews_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function Reviews_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Reviews_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Reviews_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Reviews_toConsumableArray(arr) {
    return Reviews_arrayWithoutHoles(arr) || Reviews_iterableToArray(arr) || Reviews_unsupportedIterableToArray(arr) || Reviews_nonIterableSpread();
}
function Reviews_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Reviews_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Reviews_arrayLikeToArray(o, minLen);
}
var _accumulator;
var ReviewsContainer = function(param1) {
    var user = param1.user, product = param1.product, type = param1.type, reviewsSummary = param1.reviewsSummary, apiCall1 = param1.apiCall, getReviewsAndQuestions1 = param1.getReviewsAndQuestions, addModal1 = param1.addModal, openedModal = param1.openedModal;
    var ref14;
    var ref1 = (0,react.useState)([]), data1 = ref1[0], setData = ref1[1];
    var ref2 = (0,react.useState)(null), meta = ref2[0], setMeta = ref2[1];
    var ref3 = (0,react.useState)(false), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,react.useState)(false), fetchReviews = ref4[0], setFetchReviews = ref4[1];
    var ref5 = (0,react.useState)(false), visibleForm = ref5[0], setVisibleForm = ref5[1];
    var ref6 = (0,react.useState)(false), placeholder = ref6[0], setPlaceholder = ref6[1];
    var ref7 = (0,react.useState)(null), placeholderLabel = ref7[0], setPlaceholderLabel = ref7[1];
    var ref8 = (0,react.useState)({
        sortBy: "date",
        orderBy: "desc"
    }), sortFilterData = ref8[0], setSortFilterData = ref8[1];
    var ref9 = (0,react.useState)(false), filtered = ref9[0], setFiltered = ref9[1];
    var ref10 = (0,react.useState)(), reviewsWithImages = ref10[0], setReviewsWithImages = ref10[1];
    var ref11 = (0,react.useState)(), reviewDetails = ref11[0], setReviewDetails = ref11[1];
    var ref12 = (0,react.useState)(), currentImageIndex = ref12[0], setSelectedImageIndex = ref12[1];
    var scrollRef = /*#__PURE__*/ (0,react.createRef)();
    var reviewsImagesCount = reviewsWithImages && reviewsWithImages.flatMap(function(review) {
        return Reviews_toConsumableArray(review.images);
    }).length;
    var reviewsHasImages = type === "reviews" && (reviewsWithImages === null || reviewsWithImages === void 0 ? void 0 : reviewsWithImages.length) > 0;
    var reviewsCount = get_default()(reviewsSummary, "reviews.value", 0);
    var questionsCount = get_default()(reviewsSummary, "questions.total", 0);
    var ref13;
    var productVariations = (ref13 = product === null || product === void 0 ? void 0 : (ref14 = product.configurable_options) === null || ref14 === void 0 ? void 0 : ref14.reduce(function(accumulator, param) {
        var values = param.values;
        return accumulator.concat(values);
    }, []).reduce(function(accumulator, param) {
        var sku = param.sku, label = param.label;
        var _sku;
        (_sku = (_accumulator = accumulator)[sku]) !== null && _sku !== void 0 ? _sku : _accumulator[sku] = [];
        accumulator[sku].push(label);
        return accumulator;
    }, {})) !== null && ref13 !== void 0 ? ref13 : null; // Default to null in case product has no variations
    // TODO: why is this needed? if reviewsSummary changes the component rerenders
    (0,react.useEffect)(function() {
        reviewsCount = get_default()(reviewsSummary, "reviews.value", 0);
        questionsCount = get_default()(reviewsSummary, "questions.total", 0);
    }, [
        reviewsSummary
    ]);
    (0,react.useEffect)(function() {
        return getByPage(0);
    }, [
        sortFilterData,
        filtered,
        user.isLoggedIn
    ]); // ? Maybe without filter?
    (0,react.useEffect)(function() {
        var fetchReviewsWithImages = function() {
            var _ref = Reviews_asyncToGenerator(runtime_default().mark(function _callee() {
                var ref, payload, response1;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            payload = [
                                product.sku
                            ];
                            if (productVariations) {
                                payload = Object.keys(productVariations);
                            }
                            _ctx.next = 5;
                            return apiCall1({
                                apiArgs: [
                                    payload
                                ],
                                apiCall: api/* getReviewsWithImagesApi */.w47,
                                returnResponse: true,
                                formatResponse: function(response) {
                                    return response.data;
                                }
                            });
                        case 5:
                            response1 = _ctx.sent;
                            if ((response1 === null || response1 === void 0 ? void 0 : (ref = response1.items) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                                setReviewsWithImages(response1.items);
                            }
                        case 7:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchReviewsWithImages() {
                return _ref.apply(this, arguments);
            };
        }();
        if (type === "reviews") {
            fetchReviewsWithImages();
        }
    }, []);
    var handleReviewDetailsModal = function(param) {
        var reviewId = param.reviewId, imageIndex = param.imageIndex;
        setSelectedImageIndex(imageIndex);
        handleReviewDetails(reviewId);
        if (openedModal !== "review-images-details") {
            addModal1("review-images-details");
        }
    };
    var handleReviewDetails = function() {
        var _ref = Reviews_asyncToGenerator(runtime_default().mark(function _callee(reviewId) {
            var findReviewById, review1, hasReviewData, reviewData, newReviewsWithImages, reviewIndex;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        findReviewById = function(review) {
                            return review._id === reviewId;
                        };
                        review1 = reviewsWithImages.find(findReviewById);
                        hasReviewData = Boolean(review1.body && review1.title);
                        if (!hasReviewData) {
                            _ctx.next = 7;
                            break;
                        }
                        {
                            setReviewDetails(review1);
                        }
                        _ctx.next = 11;
                        break;
                    case 7:
                        _ctx.next = 9;
                        return apiCall1({
                            apiArgs: [
                                reviewId
                            ],
                            apiCall: api/* getReviewByIdApi */.Kzk,
                            formatResponse: function(response) {
                                return response.data;
                            },
                            returnResponse: true
                        });
                    case 9:
                        reviewData = _ctx.sent;
                        if (reviewData) {
                            newReviewsWithImages = Reviews_toConsumableArray(reviewsWithImages);
                            reviewIndex = newReviewsWithImages.findIndex(findReviewById);
                            // populate review with data to avoid future api call
                            newReviewsWithImages[reviewIndex] = reviewData;
                            setReviewsWithImages(newReviewsWithImages);
                            setReviewDetails(reviewData);
                        }
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleReviewDetails(reviewId) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleNextImage = function() {
        // zero based images count to match current image index
        var currentReviewImagesCount = reviewDetails.images.length - 1;
        var nextImageIndex = currentImageIndex + 1;
        // if is not the last image in current review, show next image
        if (nextImageIndex <= currentReviewImagesCount) {
            setSelectedImageIndex(nextImageIndex);
        } else {
            var ref;
            var currentReviewIndex = reviewsWithImages.indexOf(reviewDetails);
            var nextReviewId = (ref = reviewsWithImages[currentReviewIndex + 1]) === null || ref === void 0 ? void 0 : ref._id;
            // if is last image in review and next review is available, get next review in modal
            if (nextReviewId) {
                setSelectedImageIndex(0);
                handleReviewDetails(nextReviewId);
            }
        }
    };
    var handlePrevImage = function() {
        var prevImageIndex = currentImageIndex - 1;
        if (prevImageIndex >= 0) {
            setSelectedImageIndex(prevImageIndex);
        } else {
            var ref, ref15;
            var currentReviewIndex = reviewsWithImages.indexOf(reviewDetails);
            var prevReviewId = (ref = reviewsWithImages[currentReviewIndex - 1]) === null || ref === void 0 ? void 0 : ref._id;
            // zero based images count to match current image index
            var prevReviewImagesCount = ((ref15 = reviewsWithImages[currentReviewIndex - 1]) === null || ref15 === void 0 ? void 0 : ref15.images.length) - 1;
            if (prevReviewId) {
                setSelectedImageIndex(prevReviewImagesCount);
                handleReviewDetails(prevReviewId);
            }
        }
    };
    var userCanPostQuestion = function() {
        if (user.isLoggedIn) {
            setVisibleForm(true);
            setPlaceholder(false);
        } else {
            setVisibleForm(false);
            setPlaceholder(true);
        }
    };
    var userCanPostReview = function() {
        var _ref = Reviews_asyncToGenerator(runtime_default().mark(function _callee() {
            var id, sku;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        id = product.id, sku = product.sku;
                        if (user.isLoggedIn) {
                            _ctx.next = 5;
                            break;
                        }
                        setVisibleForm(false);
                        setPlaceholder(true);
                        return _ctx.abrupt("return");
                    case 5:
                        setLoading(true);
                        _ctx.next = 8;
                        return apiCall1({
                            apiArgs: [
                                {
                                    productId: id,
                                    sku: sku
                                }
                            ],
                            apiCall: api/* isUserEligibleToPostReviewApi */.bMM,
                            formatResponse: function(response) {
                                if (response.status === 200 && !!response.data.is_eligible) {
                                    setVisibleForm(true);
                                    setPlaceholder(false);
                                    setLoading(false);
                                    setPlaceholderLabel("");
                                }
                            },
                            preFail: function(response) {
                                if (response.status === 409) {
                                    setVisibleForm(false);
                                    setPlaceholder(true);
                                    setLoading(false);
                                    setPlaceholderLabel(response.data.message);
                                } else {
                                    setVisibleForm(false);
                                    setPlaceholder(true);
                                    setLoading(false);
                                    setPlaceholderLabel("Serviciu indisponibil momentan. Va rugam reveniti.");
                                }
                            },
                            returnResponse: true
                        });
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function userCanPostReview() {
            return _ref.apply(this, arguments);
        };
    }();
    var getByPage = function() {
        var _ref = Reviews_asyncToGenerator(runtime_default().mark(function _callee(page) {
            var options, _scroll, scroll, elem, productSkus, payload, data, ref, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        options = _args.length > 1 && _args[1] !== void 0 ? _args[1] : {};
                        _scroll = options.scroll, scroll = _scroll === void 0 ? false : _scroll;
                        elem = scrollRef.current;
                        setFetchReviews(true);
                        productSkus = productVariations ? Object.keys(productVariations) : [
                            product.sku
                        ]; // Use current product SKU for the review API call
                        payload = Reviews_objectSpread({
                            page: page,
                            productSkus: productSkus
                        }, sortFilterData);
                        _ctx.next = 8;
                        return getReviewsAndQuestions1(type, payload);
                    case 8:
                        data = _ctx.sent;
                        if (data) {
                            ;
                            setData(data.items || []);
                            setMeta(data.meta || null);
                            setFetchReviews(false);
                            if (scroll && (data === null || data === void 0 ? void 0 : (ref = data.items) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                                (0,helpers/* scrollElementIntoView */.bx)(elem, "smooth");
                            }
                            // getByPage ia called when tab is active
                            // we only call funtion bellow if product has no reviews or questions
                            if (type === "reviews" && get_default()(data, "meta.size", 0) < 1) {
                                userCanPostReview();
                            }
                            if (type === "questions" && !data.items.length) {
                                userCanPostQuestion();
                            }
                        }
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getByPage(page) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleEditReview = function() {
        getByPage(0);
    };
    var changeSort = function() {
        var _ref = Reviews_asyncToGenerator(runtime_default().mark(function _callee(payload) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setSortFilterData(Reviews_objectSpread({}, payload));
                        setFiltered(true);
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function changeSort(payload) {
            return _ref.apply(this, arguments);
        };
    }();
    var closeForm = function() {
        setVisibleForm(false);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "md:mb-16",
        ref: scrollRef,
        children: [
            type === "reviews" && data1.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col md:flex-row items-center md:mb-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductReviews_ProductReviewsInfo, {
                        reviewsSummary: reviewsSummary,
                        visibleForm: visibleForm,
                        placeholder: placeholder,
                        userCanPostReview: userCanPostReview
                    }),
                    reviewsSummary && reviewsSummary.ratingDistribution && Object.keys(reviewsSummary.ratingDistribution).length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "md:ml-52px w-full max-w-[525px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductReviews_ProductReviewsChart, {
                            ratingDistribution: reviewsSummary.ratingDistribution,
                            reviewsCount: reviewsSummary.reviews.value || 0,
                            changeRatingFilter: changeSort,
                            sortFilterData: sortFilterData,
                            hasRatingFilters: Object.keys(reviewsSummary.ratingDistribution).length !== 1
                        })
                    })
                ]
            }),
            data1 && data1.length > 0 && type === "questions" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "py-4 lg:pt-8 md:block md:w-190px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    title: "Adauga o intrebare",
                    display: "block",
                    disabled: visibleForm,
                    size: "normal",
                    onClick: function() {
                        return userCanPostQuestion();
                    }
                })
            }),
            reviewsCount > 0 && !fetchReviews && !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "md:hidden my-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    title: "Adauga recenzia ta",
                    disabled: visibleForm || placeholder,
                    display: "block",
                    size: "normal",
                    onClick: function() {
                        return userCanPostReview();
                    }
                })
            }),
            loading && type === "reviews" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {
                height: 100
            }),
            !user.isLoggedIn && placeholder && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductReviews_ProductReviewsFormPlaceholder, {
                addModal: addModal1,
                type: type,
                showLogin: !user.isLoggedIn,
                label: user.isLoggedIn && placeholder ? placeholderLabel : "Pentru a adauga o\n              ".concat(type === "reviews" ? " recenzie" : " intrebare", "\n               acestui produs trebuie sa fii logat.")
            }),
            user.isLoggedIn && !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews_AddReviewForm, {
                type: type,
                visibleForm: visibleForm,
                placeholder: placeholder,
                placeholder_label: placeholderLabel,
                closeForm: closeForm,
                productId: product.id,
                sku: product.sku,
                counter: type === "reviews" && reviewsCount === 0 ? true : type !== "reviews" && questionsCount === 0 ? true : false
            }),
            reviewsHasImages && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[18px] md:text-[24px]",
                        children: "Recenzii cu imagini"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductReviews_ReviewsImagesSlider, {
                        reviewsWithImages: reviewsWithImages,
                        onImageSelect: handleReviewDetailsModal
                    }),
                    reviewsImagesCount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        onClick: function() {
                            return addModal1("reviews-images-modal");
                        },
                        className: "text-red-brand text-[14px] mt-[15px] cursor-pointer hover:text-bleu-hover",
                        children: [
                            "Vezi toate fotografiile (",
                            reviewsImagesCount,
                            ")"
                        ]
                    })
                ]
            }),
            (meta && meta.size > meta.limit || filtered) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews_SortFilter, {
                type: type,
                reviewsSummary: reviewsSummary,
                sortFilterData: sortFilterData,
                changeSort: changeSort
            }),
            !(data1 && data1.length > 0) && filtered && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "my-4 md:py-8 px-4 md:bg-newGray text-center text-black",
                children: type === "reviews" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "m-0 mb-2",
                    children: "Nu a fost gasita nicio recenzie."
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "m-0 mb-2",
                    children: "Nu a fost gasita nicio intrebare."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews_ReviewList, {
                loading: fetchReviews,
                reviews: data1,
                reviewsSummary: reviewsSummary,
                type: type,
                productId: product.id,
                productVariations: productVariations,
                onEditReview: handleEditReview
            }),
            meta && meta.size > meta.limit && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "md:flex justify-end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full md:w-5/6 pl-0 md:pl-8 mt-10px mb-12 md:mb-0 md:mt-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                        pages: Number.isInteger(meta.size / meta.limit) ? meta.size / meta.limit : Math.trunc(meta.size / meta.limit + 1),
                        goTo: function(pg) {
                            return getByPage(pg - 1, {
                                scroll: true
                            });
                        },
                        activePage: meta.page + 1,
                        meta: meta,
                        showMeta: true,
                        alignment: "justify-center"
                    })
                })
            }),
            reviewsHasImages && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalErrorBoundary/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductReviews_ProductReviewsImagesModal, {
                    reviewsWithImages: reviewsWithImages,
                    onImageSelect: handleReviewDetailsModal
                })
            }),
            reviewsHasImages && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalErrorBoundary/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductReviews_ProductReviewDetailsModal, {
                    reviewsImagesCount: reviewsImagesCount,
                    reviewDetails: reviewDetails,
                    productVariations: productVariations,
                    onPrevImageChange: handlePrevImage,
                    onNextImageChange: handleNextImage,
                    currentImageIndex: currentImageIndex
                })
            })
        ]
    }));
};
/* harmony default export */ var Reviews = ((0,es/* connect */.$j)(function(state) {
    return {
        user: state.user,
        openedModal: state.app.modal
    };
}, {
    getReviewsAndQuestions: catalog_actions/* getReviewsAndQuestions */.Vo,
    addModal: app_actions/* addModal */.Y_,
    apiCall: app_actions/* apiCall */.k_
})(ReviewsContainer));

// EXTERNAL MODULE: ./containers/Catalog/CompareWidget.js + 1 modules
var CompareWidget = __webpack_require__(1144);
// EXTERNAL MODULE: ./components/ProductsCompareTable/ProductsCompareTable.js + 2 modules
var ProductsCompareTable = __webpack_require__(31485);
// EXTERNAL MODULE: ./lib/api/helpers.js
var api_helpers = __webpack_require__(45963);
;// CONCATENATED MODULE: ./containers/Catalog/ProductCompareSection.js










function ProductCompareSection_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ProductCompareSection_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ProductCompareSection_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ProductCompareSection_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var ProductCompareSection = function(param) {
    var product1 = param.product;
    var ref3 = (0,react.useState)(null), compareData = ref3[0], setCompareData = ref3[1];
    var ref1 = (0,react.useState)(true), isLoading = ref1[0], setIsLoading = ref1[1];
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        var loadCompareData = function() {
            var _ref = ProductCompareSection_asyncToGenerator(runtime_default().mark(function _callee() {
                var currentSku, response1;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            currentSku = product1.sku;
                            if (!compareData) {
                                _ctx.next = 5;
                                break;
                            }
                            {
                                setIsLoading(false);
                            }
                            _ctx.next = 10;
                            break;
                        case 5:
                            _ctx.next = 7;
                            return (0,api_helpers/* makeApiCall */.Vo)({
                                apiCall: api/* getCompareDataApi */.UE3,
                                apiArgs: [
                                    currentSku
                                ],
                                formatResponse: function(response) {
                                    var ref, ref2;
                                    return {
                                        products: response.data.products,
                                        attributes: ((ref = response.data.products[0]) === null || ref === void 0 ? void 0 : (ref2 = ref.info) === null || ref2 === void 0 ? void 0 : ref2.groups) || []
                                    };
                                },
                                preFail: function() {
                                    return (0,app_actions/* addAlert */.V_)({
                                        message: "Nu am putut prelua datele.",
                                        variant: "error"
                                    });
                                }
                            });
                        case 7:
                            response1 = _ctx.sent;
                            if (response1) {
                                setCompareData(response1);
                            }
                            setIsLoading(false);
                        case 10:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function loadCompareData() {
                return _ref.apply(this, arguments);
            };
        }();
        loadCompareData();
    }, [
        product1
    ]);
    var handleProductClick = function(product) {
        if (product && product.url_key && product.sku) {
            router.push("/".concat(product.url_key, "/cpd/").concat(product.sku, "/"));
        }
    };
    if (isLoading) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {
            height: 100
        }));
    }
    if (compareData === null) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "p-4 text-center text-gray-600",
            children: "Nici un produs disponibil pentru comparatie."
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsCompareTable/* default */.Z, {
        products: compareData.products,
        productsAttributeGroups: compareData.attributes,
        onProductClick: handleProductClick,
        canRemove: false
    }));
};
/* harmony default export */ var Catalog_ProductCompareSection = ((0,es/* connect */.$j)(function(state) {
    return {
        currentProduct: state.catalog.currentProduct
    };
})(ProductCompareSection));

// EXTERNAL MODULE: ./components/ProductsRecentlyViewed.js
var ProductsRecentlyViewed = __webpack_require__(25357);
// EXTERNAL MODULE: ./components/Form/Radio.js
var Radio = __webpack_require__(13890);
// EXTERNAL MODULE: ./components/Form/Select.js
var Select = __webpack_require__(66569);
;// CONCATENATED MODULE: ./components/ProductPage/Westaco.js









var _this = undefined;
var Condition = function(param1) {
    var when = param1.when, is = param1.is, children = param1.children;
    /*#__PURE__*/ return((0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
        name: when,
        subscription: {
            value: true
        },
        /*#__PURE__*/ children: function(param) {
            var value = param.input.value;
            return value === is ? children : null;
        }
    }));
};
var Westaco = function(param) {
    var options = param.options, callback = param.callback;
    var _this1 = _this;
    var WESTACO_TYPES = [
        {
            value: "DIRECT_RECHARGE",
            label: "Reincarcare directa"
        },
        {
            value: "CASHUP_PINPRINTING",
            label: "Reincarcare Cod/Pin"
        }, 
    ];
    if (!options) {
        return null;
    }
    var WESTACO_CONFIG = {};
    WESTACO_TYPES.forEach(function(type) {
        WESTACO_CONFIG[type.value] = Object.keys(options).map(function(okey) {
            if (options[okey].category_type === type.value) {
                return options[okey];
            }
        }).filter(function(e) {
            return !!e;
        });
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
            onSubmit: function(values) {
                _this1.props.handleAction(values, "payment");
            },
            initialValues: {
                westaco_recharge: WESTACO_CONFIG[WESTACO_TYPES[0].value].length !== 0 ? WESTACO_TYPES[0].value : WESTACO_TYPES[1].value
            },
            render: function() {
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* FormSpy */.lP, {
                            onChange: callback,
                            subscription: {
                                values: true,
                                errors: true
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            as: "h2",
                            display: "h2",
                            title: "Tip reincarcare",
                            border: "bottom",
                            classesProp: "mb-3"
                        }),
                        WESTACO_CONFIG[WESTACO_TYPES[0].value].length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pb-3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                        name: "westaco_recharge",
                                        component: Radio/* default */.Z,
                                        label: WESTACO_TYPES[0].label,
                                        type: "radio",
                                        value: WESTACO_TYPES[0].value
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Condition, {
                                    when: "westaco_recharge",
                                    is: WESTACO_TYPES[0].value,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "pb-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_final_form_es/* Field */.gN, {
                                                name: "option_guid_".concat(WESTACO_TYPES[0].value),
                                                component: Select/* default */.Z,
                                                label: "Valoare reincarcare",
                                                required: true,
                                                validate: (0,validations/* isRequired */.q9)(),
                                                defaultValue: WESTACO_CONFIG[WESTACO_TYPES[0].value][0].guid,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "",
                                                        children: "Alege..."
                                                    }),
                                                    WESTACO_CONFIG[WESTACO_TYPES[0].value].map(function(option) {
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                                            value: option.guid,
                                                            "data-price": option.option_price,
                                                            children: "".concat(option.recharge_value, "€ (").concat(option.selling_price, " ").concat(option.fiscal_currency, " ").concat(option.name, ")")
                                                        }, WESTACO_TYPES[0].value + option.guid);
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "pb-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                                name: "phone_number",
                                                component: InputText/* default */.Z,
                                                label: "Numar de telefon",
                                                type: "tel",
                                                required: true,
                                                validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isPhoneNumber */.xT)())
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        WESTACO_CONFIG[WESTACO_TYPES[1].value].length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pb-3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                        name: "westaco_recharge",
                                        component: Radio/* default */.Z,
                                        label: WESTACO_TYPES[1].label,
                                        type: "radio",
                                        value: WESTACO_TYPES[1].value
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Condition, {
                                    when: "westaco_recharge",
                                    is: WESTACO_TYPES[1].value,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "pb-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_final_form_es/* Field */.gN, {
                                                name: "option_guid_".concat(WESTACO_TYPES[1].value),
                                                component: Select/* default */.Z,
                                                label: "Valoare reincarcare",
                                                required: true,
                                                validate: (0,validations/* isRequired */.q9)(),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "",
                                                        children: "Alege..."
                                                    }),
                                                    WESTACO_CONFIG[WESTACO_TYPES[1].value].map(function(option) {
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                                            value: option.guid,
                                                            "data-price": option.option_price,
                                                            children: "".concat(option.recharge_value, "€ (").concat(option.selling_price, " ").concat(option.fiscal_currency, " ").concat(option.name, ")")
                                                        }, WESTACO_TYPES[1].value + option.guid);
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "pb-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                children: "Codul de reincarcare va fi trimis pe mailul dumneavoastra, imediat dupa ce completati datele dumneavoastra personale."
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }));
            }
        })
    }));
};
Westaco.propTypes = {
    guid: (prop_types_default()).string
};
Westaco.contextTypes = {
    config: (prop_types_default()).object
};
/* harmony default export */ var ProductPage_Westaco = (Westaco);

// EXTERNAL MODULE: ./components/Icons/ArrowDown.js
var ArrowDown = __webpack_require__(26206);
;// CONCATENATED MODULE: ./components/Icons/Resealed/Guaranty.js

var Guaranty = function(param) {
    var _width = param.width, width = _width === void 0 ? "22px" : _width, _height = param.height, height = _height === void 0 ? "24px" : _height, _currentColor = param.currentColor, currentColor = _currentColor === void 0 ? "currentColor" : _currentColor;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 22 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0",
                "mask-type": "alpha",
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "1",
                width: "22",
                height: "23",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M0 0.999939H21.542V23.4459H0V0.999939Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12.1518 1.55832L13.0408 2.41832C13.4798 2.84432 14.0918 3.04232 14.6988 2.95632L15.9228 2.78432C16.9828 2.63432 17.9708 3.35132 18.1568 4.40632L18.3708 5.62432C18.4758 6.22732 18.8538 6.74832 19.3948 7.03532L20.4868 7.61432C21.4328 8.11632 21.8108 9.27832 21.3398 10.2403L20.7978 11.3503C20.5288 11.9013 20.5288 12.5443 20.7978 13.0953L21.3398 14.2053C21.8108 15.1673 21.4328 16.3293 20.4868 16.8313L19.3948 17.4113C18.8538 17.6983 18.4758 18.2183 18.3708 18.8213L18.1568 20.0393C17.9708 21.0943 16.9828 21.8123 15.9228 21.6623L14.6988 21.4893C14.0918 21.4033 13.4798 21.6023 13.0408 22.0283L12.1518 22.8873C11.3818 23.6323 10.1608 23.6323 9.3908 22.8873L8.5028 22.0283C8.0618 21.6023 7.4498 21.4033 6.8428 21.4893L5.6198 21.6623C4.5588 21.8123 3.5708 21.0943 3.3858 20.0393L3.1728 18.8213C3.0668 18.2183 2.6878 17.6983 2.1468 17.4113L1.0548 16.8313C0.108803 16.3293 -0.268197 15.1673 0.201803 14.2053L0.744803 13.0953C1.0138 12.5443 1.0138 11.9013 0.744803 11.3503L0.201803 10.2403C-0.268197 9.27832 0.108803 8.11632 1.0548 7.61432L2.1468 7.03532C2.6878 6.74832 3.0668 6.22732 3.1728 5.62432L3.3858 4.40632C3.5708 3.35132 4.5588 2.63432 5.6198 2.78432L6.8428 2.95632C7.4498 3.04232 8.0618 2.84432 8.5028 2.41832L9.3908 1.55832C10.1608 0.813323 11.3818 0.813323 12.1518 1.55832Z",
                    fill: currentColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.771 12.2229C18.771 16.6409 15.19 20.2229 10.771 20.2229C6.353 20.2229 2.771 16.6409 2.771 12.2229C2.771 7.8049 6.353 4.2229 10.771 4.2229C15.19 4.2229 18.771 7.8049 18.771 12.2229Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.771 18.6096C7.25 18.6096 4.384 15.7446 4.384 12.2226C4.384 8.70061 7.25 5.83661 10.771 5.83661C14.293 5.83661 17.158 8.70061 17.158 12.2226C17.158 15.7446 14.293 18.6096 10.771 18.6096Z",
                fill: currentColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.6198 15.4257C9.3038 15.4257 9.0078 15.3027 8.7848 15.0797L6.4818 12.7757L7.6838 11.5737L9.6198 13.5087L13.8578 9.27069L15.0598 10.4727L10.4538 15.0807C10.2318 15.3027 9.9348 15.4257 9.6198 15.4257Z",
                fill: "white"
            })
        ]
    });
};
/* harmony default export */ var Resealed_Guaranty = (Guaranty);

;// CONCATENATED MODULE: ./components/Icons/Resealed/Return.js

var Return = function(param) {
    var _width = param.width, width = _width === void 0 ? "20px" : _width, _height = param.height, height = _height === void 0 ? "22px" : _height, _currentColor = param.currentColor, currentColor = _currentColor === void 0 ? "currentColor" : _currentColor;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.525 16.2642L15.562 17.3972V9.22125L18.225 7.76125V15.0513C18.225 15.5513 17.959 16.0142 17.525 16.2642ZM10.503 20.3182V11.9942L13.861 10.1532V18.3792L10.503 20.3182ZM2.01 5.78125L5.178 3.95225L13.29 8.52725L9.848 10.4132C9.73 10.3012 9.603 10.1962 9.458 10.1122L2.01 5.78125ZM9.107 1.68425C9.541 1.43325 10.075 1.43325 10.507 1.68425L17.525 5.73525C17.656 5.81025 17.765 5.91025 17.863 6.01925L15.046 7.56425L6.889 2.96425L9.107 1.68425ZM18.564 4.73025L10.858 0.28125C10.209 -0.09375 9.407 -0.09375 8.756 0.28125L1.05 4.73025C0.4 5.10525 0 5.80025 0 6.55025V15.4493C0 16.2003 0.4 16.8933 1.05 17.2693L8.756 21.7183C9.407 22.0933 10.209 22.0933 10.858 21.7183L18.564 17.2693C19.214 16.8933 19.615 16.2003 19.615 15.4493V6.55025C19.615 5.80025 19.214 5.10525 18.564 4.73025Z",
            fill: currentColor
        })
    });
};
/* harmony default export */ var Resealed_Return = (Return);

;// CONCATENATED MODULE: ./components/Icons/Resealed/Tested.js


var Tested = function(param) {
    var _width = param.width, width = _width === void 0 ? "22px" : _width, _height = param.height, height = _height === void 0 ? "22px" : _height, _currentColor = param.currentColor, currentColor = _currentColor === void 0 ? "currentColor" : _currentColor;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "22",
                height: "22",
                rx: "8",
                fill: currentColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "2",
                y: "2",
                width: "18",
                height: "18",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "3",
                y: "3",
                width: "16",
                height: "16",
                rx: "5",
                fill: currentColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5 10L6.51788 13.0358C6.70825 13.4165 7.25698 13.4004 7.42467 13.0091L9.57533 7.99089C9.74302 7.59963 10.2917 7.5835 10.4821 7.96424L13.4602 13.9203C13.6594 14.3188 14.2409 14.2774 14.3817 13.8548L15.6183 10.1452C15.7591 9.72257 16.3406 9.68124 16.5398 10.0797L17.5 12",
                stroke: "white",
                strokeWidth: "1.5",
                strokeLinecap: "round"
            })
        ]
    });
};
/* harmony default export */ var Resealed_Tested = (Tested);

;// CONCATENATED MODULE: ./components/ResealedProductStorePickupModal.js






var ResealedProductStorePickupModal_ref = (0,config["default"])(), ResealedProductStorePickupModal_settings = ResealedProductStorePickupModal_ref.publicRuntimeConfig.settings;
var ResealedProductStorePickupModal = function(param) {
    var resealedModalId = param.resealedModalId, mainProduct = param.mainProduct, resealedProduct = param.resealedProduct;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Modal["default"], {
        id: resealedModalId,
        header: "Produsul a fost adaugat in cos",
        children: resealedProduct ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex border-b border-gray-light pb-[20px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-[40%] md:w-[20%]",
                            children: mainProduct.thumbnail && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "".concat(ResealedProductStorePickupModal_settings.cdn, "/media/").concat(mainProduct.thumbnail),
                                className: "Media-image",
                                alt: mainProduct.name
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-grow flex-col md:flex-row justify-center md:justify-between md:items-center ml-[16px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-[14px]",
                                    children: mainProduct.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "min-w-fit md:ml-[16px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                        size: "smaller",
                                        formatted: true,
                                        resealed: true,
                                        price: resealedProduct.price.selling_price,
                                        regularPrice: resealedProduct.price.base_price,
                                        resealedLabel: "Pret produs nou"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-[20px] mb-[40px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                        type: "info",
                        showIcon: true,
                        children: "Poti continua procesul de rezervare in cosul de cumparaturi."
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "primary",
                    title: "Vezi cosul",
                    href: "/cos-cumparaturi"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
            type: "info",
            showIcon: true,
            children: "Momentan acest produs nu este disponibil in magazinele fizice."
        })
    });
};
/* harmony default export */ var components_ResealedProductStorePickupModal = (ResealedProductStorePickupModal);

// EXTERNAL MODULE: ./store/cart/actions.js
var cart_actions = __webpack_require__(30500);
// EXTERNAL MODULE: ./components/Icons/Cart.js
var Cart = __webpack_require__(24190);
;// CONCATENATED MODULE: ./components/AddToCartReserveInStore.js









function AddToCartReserveInStore_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function AddToCartReserveInStore_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                AddToCartReserveInStore_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                AddToCartReserveInStore_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var AddToCartReserveInStore_ref = (0,config["default"])(), AddToCartReserveInStore_settings = AddToCartReserveInStore_ref.publicRuntimeConfig.settings;
var AddToCartReserveInStore_isBricoStore = AddToCartReserveInStore_settings.websiteName === "bricostore";
var AddToCartReserveInStore = function(param) {
    var product = param.product, addToCart1 = param.addToCart, size = param.size, disabled = param.disabled, _classNames = param.classNames, classNames = _classNames === void 0 ? "" : _classNames, _onPostSuccess = param.onPostSuccess, onPostSuccess = _onPostSuccess === void 0 ? function() {} : _onPostSuccess, _iconOnlyOnMobile = param.iconOnlyOnMobile, iconOnlyOnMobile = _iconOnlyOnMobile === void 0 ? false : _iconOnlyOnMobile;
    var mainOffer = (0,helpers/* productHelper */.gU)(product).mainOffer;
    var sellerId = get_default()(mainOffer, "seller.id") || product.price_seller_id || AddToCartReserveInStore_settings.localSeller;
    var addProductToCart = function() {
        var _ref = AddToCartReserveInStore_asyncToGenerator(runtime_default().mark(function _callee() {
            var payload, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!disabled) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        payload = {
                            sku: product.sku,
                            qty: 1,
                            sellerId: sellerId
                        };
                        if (product.resealed_code) {
                            payload.resealed_code = product.resealed_code;
                        }
                        _ctx.next = 6;
                        return addToCart1(payload, {
                            product: product,
                            actionQuantity: 1
                        });
                    case 6:
                        response = _ctx.sent;
                        if (response && response.cart) {
                            onPostSuccess();
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function addProductToCart() {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classNames,
        onClick: function(e) {
            e.preventDefault();
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            title: "Adauga in cos",
            icon: AddToCartReserveInStore_isBricoStore || iconOnlyOnMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Cart/* default */.Z, {
                fill: "white",
                width: "22px",
                height: "22px"
            }) : null,
            hasMinWidth: false,
            hasIconAndTitle: AddToCartReserveInStore_isBricoStore,
            display: "block",
            font: "medium",
            size: size || "normal",
            variant: "secondary",
            onClick: addProductToCart,
            iconOnlyOnMobile: iconOnlyOnMobile,
            isAddToCart: true
        })
    }));
};
/* harmony default export */ var components_AddToCartReserveInStore = ((0,es/* connect */.$j)(null, {
    addToCart: cart_actions/* addToCart */.Xq
})(AddToCartReserveInStore));

;// CONCATENATED MODULE: ./components/ProductPage/ResealedList.js





















function ResealedList_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ResealedList_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return ResealedList_arrayLikeToArray(arr);
}
function ResealedList_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function ResealedList_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ResealedList_toConsumableArray(arr) {
    return ResealedList_arrayWithoutHoles(arr) || ResealedList_iterableToArray(arr) || ResealedList_unsupportedIterableToArray(arr) || ResealedList_nonIterableSpread();
}
function ResealedList_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ResealedList_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ResealedList_arrayLikeToArray(o, minLen);
}
var ResealedList_ref = (0,config["default"])(), ResealedList_publicRuntimeConfig = ResealedList_ref.publicRuntimeConfig, ResealedList_websiteName = ResealedList_publicRuntimeConfig.settings.websiteName;
var ResealedList_isBricoStore = ResealedList_websiteName === "bricostore";
var INITIAL_VISIBLE_ITEMS = 2;
var ResealedList = function(param1) {
    var product = param1.product, addModal1 = param1.addModal;
    var ref2 = (0,react.useState)(INITIAL_VISIBLE_ITEMS), visibleResealedItems = ref2[0], setVisibleResealedItems = ref2[1];
    var ref1 = (0,react.useState)({
        region: "",
        store: "",
        price: "asc"
    }), filters = ref1[0], setFilters = ref1[1];
    var resealedInfoRef = (0,react.useRef)();
    var availableResealedRegionNames = ResealedList_toConsumableArray(new Set(product.resealed.map(function(resealedItem) {
        return resealedItem.stock.store_availability_location.region_name;
    })));
    var filteredResealedProducts = (0,react.useMemo)(function() {
        var validResealedProducts = product.resealed.filter(function(resealedItem) {
            return resealedItem.sku !== product.sku;
        });
        if (filters.region) {
            validResealedProducts = validResealedProducts.filter(function(resealedItem) {
                return resealedItem.stock.store_availability_location.region_name === filters.region;
            });
        }
        if (filters.store) {
            validResealedProducts = validResealedProducts.filter(function(resealedItem) {
                return resealedItem.stock.store_availability_location.name === filters.store;
            });
        }
        if (validResealedProducts.length > 1) {
            validResealedProducts = validResealedProducts.sort(function(a, b) {
                return filters.price === "asc" ? a.price.selling_price - b.price.selling_price : b.price.selling_price - a.price.selling_price;
            });
        }
        return validResealedProducts;
    }, [
        filters
    ]);
    var availableResealedStoreNames = (0,react.useMemo)(function() {
        var source = filters.region ? product.resealed.filter(function(item) {
            return item.stock.store_availability_location.region_name === filters.region;
        }) : product.resealed;
        return ResealedList_toConsumableArray(new Set(source.map(function(item) {
            return item.stock.store_availability_location.name;
        })));
    }, [
        filters.region,
        product.resealed,
        filteredResealedProducts
    ]);
    var resealedItemsCount = filteredResealedProducts.length;
    var showMoreItems = function(event) {
        event.preventDefault();
        setVisibleResealedItems(function(prevState) {
            // Show 5
            if (prevState === 2) {
                return resealedItemsCount > 5 ? 5 : resealedItemsCount;
            }
            // Show 10
            if (prevState === 5) {
                return resealedItemsCount > 10 ? 10 : resealedItemsCount;
            }
            // Show all
            return resealedItemsCount;
        });
    };
    var collapseList = function(event) {
        event.preventDefault();
        setVisibleResealedItems(INITIAL_VISIBLE_ITEMS);
        setTimeout(function() {
            (0,helpers/* scrollElementIntoView */.bx)(resealedInfoRef.current, "smooth");
        }, 50);
    };
    var handleResealedFilterChange = function(form) {
        var filterValues = form.getState().values;
        if (filters.region !== filterValues.region) {
            form.change("store", "");
        }
        setVisibleResealedItems(INITIAL_VISIBLE_ITEMS);
        setFilters(filterValues);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-5 flow-root",
                ref: resealedInfoRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex text-xl m-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            as: "h2",
                            display: "h2",
                            title: "Produse Resigilate",
                            classesProp: "mb-4"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-md md:space-x-7 lg:space-x-8 md:float-left md:flex w-full text-green",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex mb-10px md:mb-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Resealed_Guaranty, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "pl-6px text-sm lg:text-base leading-18.2 lg:leading-20.8",
                                        children: "Garantia produsului nou"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex mb-10px md:mb-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Resealed_Return, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "pl-6px text-sm lg:text-base leading-18.2 lg:leading-20.8",
                                        children: ResealedList_isBricoStore ? "Retur gratuit in 30 zile" : "Retur gratuit in 14 zile"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Resealed_Tested, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "pl-6px text-sm lg:text-base leading-18.2 lg:leading-20.8",
                                        children: "Produsul a fost testat"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            product.resealed.length > 5 && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
                onSubmit: function() {
                    return null;
                },
                initialValues: {
                    price: "asc",
                    region: null,
                    store: null
                },
                render: function(param) {
                    var form = param.form;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("form", {
                        className: "space-y-[10px] md:grid md:grid-cols-3 lg:max-w-[80%] md:space-y-0 md:mb-[20px] gap-[10px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* FormSpy */.lP, {
                                onChange: function() {
                                    return handleResealedFilterChange(form);
                                },
                                subscription: {
                                    values: true
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_final_form_es/* Field */.gN, {
                                component: Select/* default */.Z,
                                name: "region",
                                inputClassName: "!max-w-full",
                                parse: function(value) {
                                    return value;
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "",
                                        children: "Judet"
                                    }),
                                    availableResealedRegionNames.map(function(region, index) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                            value: region,
                                            children: region
                                        }, index);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_final_form_es/* Field */.gN, {
                                component: Select/* default */.Z,
                                name: "store",
                                inputClassName: "!max-w-full",
                                parse: function(value) {
                                    return value;
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "",
                                        children: "Alege magazin"
                                    }),
                                    availableResealedStoreNames.map(function(store, index) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                            value: store,
                                            children: store
                                        }, index);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_final_form_es/* Field */.gN, {
                                component: Select/* default */.Z,
                                name: "price",
                                inputClassName: "!max-w-full",
                                parse: function(value) {
                                    return value;
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "asc",
                                        children: "Pret crescator"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "desc",
                                        children: "Pret descrescator"
                                    })
                                ]
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "\n            m-0 p-0 border-gray-1100 md:border md:rounded-tr-xl md:rounded-bl-xl\n            ".concat(resealedItemsCount <= visibleResealedItems ? "mb-22px lg:mb-52px" : "mb-23px", "\n          "),
                children: filteredResealedProducts.filter(function(item, index) {
                    return visibleResealedItems >= index + 1;
                }).map(function(resealedItem, index1) {
                    var ref3;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                        className: "p-4 lg:p-20px lg:flex items-center resealed border-gray-1100 border md:border-0 rounded-tr-xl rounded-bl-xl md:rounded-none mt-4 md:mt-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "lg:w-7/12 sm:flex items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "pb-2 lg:pb-0 sm:pr-2 sm:w-1/2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "pl-0",
                                            children: resealedItem.resealed_reasons && resealedItem.resealed_reasons.length > 0 ? resealedItem.resealed_reasons.map(function(resealedReason, index) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        resealedReason,
                                                        "."
                                                    ]
                                                }, index);
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: "Produsul a fost desigilat"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "pb-2 lg:pb-0 sm:pl-2 sm:w-1/2",
                                        children: [
                                            (product === null || product === void 0 ? void 0 : (ref3 = product.resealed_label) === null || ref3 === void 0 ? void 0 : ref3.seller_ids) && product.resealed_label.seller_ids.includes(resealedItem.seller.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mb-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_ProductBenefits, {
                                                    benefits: [
                                                        product.resealed_label
                                                    ]
                                                })
                                            }),
                                            resealedItem.stock.store_availability_location && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    "Disponibil in",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        className: "uppercase",
                                                        children: resealedItem.stock.store_availability_location.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    resealedItem.stock.store_availability_location.address,
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    resealedItem.stock.store_availability_location.region_name,
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "lg:w-5/12 lg:pl-8 flex flex-row items-center space-x-5 sm:space-x-0 justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                        price: resealedItem.price.selling_price,
                                        regularPrice: resealedItem.price.base_price,
                                        formatted: true,
                                        size: "productPage",
                                        resealed: true,
                                        resealedLabel: "Pret produs nou",
                                        displayDiscount: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row-reverse sm:flex-col gap-x-3 sm:gap-x-0 sm:gap-y-2 sm:w-[162px] lg:w-[232px]",
                                        children: [
                                            resealedItem.stock && resealedItem.stock.status === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCart/* default */.Z, {
                                                iconOnlyOnMobile: true,
                                                isCatalog: true,
                                                product: {
                                                    is_resealed: 1,
                                                    mainOffer: 0,
                                                    offers: [
                                                        resealedItem
                                                    ],
                                                    name: product.name,
                                                    sku: resealedItem.sku,
                                                    resealed_code: resealedItem.resealed_code,
                                                    image: product.image,
                                                    resealed_reasons: resealedItem.resealed_reasons
                                                }
                                            }),
                                            resealedItem.stock && resealedItem.stock.status === 0 && resealedItem.stock.available_in_store === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AddToCartReserveInStore, {
                                                onPostSuccess: function() {
                                                    return addModal1("resealedProductStorePickup_".concat(index1));
                                                },
                                                product: resealedItem,
                                                iconOnlyOnMobile: true
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalErrorBoundary/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ResealedProductStorePickupModal, {
                                                    mainProduct: product,
                                                    resealedProduct: resealedItem,
                                                    resealedModalId: "resealedProductStorePickup_".concat(index1)
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, index1);
                })
            }),
            resealedItemsCount > INITIAL_VISIBLE_ITEMS && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("flex justify-center mb-[22px] lg:mb-[52px]", {
                    "text-bleu": ResealedList_websiteName === "bricostore",
                    "text-black": ResealedList_websiteName !== "bricostore"
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    href: "",
                    className: "flex items-center",
                    onClick: visibleResealedItems === resealedItemsCount ? collapseList : showMoreItems,
                    children: [
                        visibleResealedItems === resealedItemsCount ? "Restrange lista" : "Vezi mai multe produse resigilate",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "ml-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                                fill: "currentColor",
                                customClassName: "duration-75 ".concat(visibleResealedItems === resealedItemsCount ? "rotate-180" : "")
                            })
                        })
                    ]
                })
            })
        ]
    }));
};
ResealedList.propTypes = {
    product: (prop_types_default()).object.isRequired
};
/* harmony default export */ var ProductPage_ResealedList = ((0,es/* connect */.$j)(null, {
    addModal: app_actions/* addModal */.Y_
})(ResealedList));

;// CONCATENATED MODULE: ./containers/Catalog/Bundles/BundleItem.js







var BundleItem_ref = (0,config["default"])(), BundleItem_publicRuntimeConfig = BundleItem_ref.publicRuntimeConfig, BundleItem_settings = BundleItem_publicRuntimeConfig.settings, content = BundleItem_publicRuntimeConfig.content;
var BundleItem = function(param) {
    var bundleProductsCount = param.bundleProductsCount, bundleProductIndex = param.bundleProductIndex, bundleProduct = param.bundleProduct;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative flex justify-between h-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mr-[16px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: "/".concat(bundleProduct.url_key, "/cpd/").concat(bundleProduct.sku, "/"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "flex justify-center relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-[120px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: (0,helpers/* resizeImage */.tg)(bundleProduct.thumbnail || bundleProduct.small_image || bundleProduct.image, "300x300"),
                                            alt: bundleProduct.name
                                        })
                                    }),
                                    bundleProduct.quantity > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "bg-red-brand absolute font-bold text-sm rounded-[30] text-center text-white min-w-[30] px-3 h-[30] left-0 top-0 leading-[30px]",
                                        children: [
                                            bundleProduct.quantity,
                                            "x"
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        "aria-hidden": "true",
                        className: "hidden md:block absolute text-[44px] -right-[22px] z-[1] top-1/2 -translate-y-1/2 select-none text-yellow",
                        children: bundleProductIndex < bundleProductsCount - 1 && "+"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col justify-between flex-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                href: "/".concat(bundleProduct.url_key, "/cpd/").concat(bundleProduct.sku, "/"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "block line-clamp-3 mb-2 text-[14px]",
                                    children: bundleProduct.name || ""
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "hidden md:flex flex-col w-full space-y-2 mt-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                        price: bundleProduct.price,
                                        regularPrice: bundleProduct.regularPrice,
                                        formatted: true,
                                        displayDiscount: true,
                                        discountType: bundleProduct.discount_type,
                                        msrp: bundleProduct.msrp_price,
                                        isBundle: true,
                                        size: "smaller"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCart/* default */.Z, {
                                        iconOnly: true,
                                        noMargin: false,
                                        product: {
                                            stock_status: 1,
                                            sku: bundleProduct.sku,
                                            mainOffer: 0,
                                            offers: [
                                                {
                                                    stock: {
                                                        status: 1
                                                    },
                                                    seller: {
                                                        id: BundleItem_settings.websiteId,
                                                        identifier: BundleItem_settings.websiteName,
                                                        url_key: bundleProduct.websiteName,
                                                        name: content.websiteTitle,
                                                        order: 1
                                                    }
                                                }, 
                                            ]
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-[16px] items-center justify-end w-full md:hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                        price: bundleProduct.price,
                        regularPrice: bundleProduct.regularPrice,
                        formatted: true,
                        displayDiscount: true,
                        discountType: bundleProduct.discount_type,
                        msrp: bundleProduct.msrp_price,
                        isBundle: true,
                        size: "smaller"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCart/* default */.Z, {
                        iconOnly: true,
                        noMargin: true,
                        product: {
                            stock_status: 1,
                            sku: bundleProduct.sku,
                            mainOffer: 0,
                            offers: [
                                {
                                    stock: {
                                        status: 1
                                    },
                                    seller: {
                                        id: BundleItem_settings.websiteId,
                                        identifier: BundleItem_settings.websiteName,
                                        url_key: bundleProduct.websiteName,
                                        name: content.websiteTitle,
                                        order: 1
                                    }
                                }, 
                            ]
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-yellow md:hidden h-[30px] text-5xl leading-[30px] left-0 right-0 text-center bottom-[-30px] select-none",
                children: [
                    " ",
                    bundleProductsCount - 1 === bundleProductIndex ? "=" : "+",
                    " "
                ]
            })
        ]
    });
};
/* harmony default export */ var Bundles_BundleItem = (BundleItem);

;// CONCATENATED MODULE: ./containers/Catalog/Bundles/index.js








function Bundles_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Bundles_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return Bundles_arrayLikeToArray(arr);
}
function Bundles_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function Bundles_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Bundles_toConsumableArray(arr) {
    return Bundles_arrayWithoutHoles(arr) || Bundles_iterableToArray(arr) || Bundles_unsupportedIterableToArray(arr) || Bundles_nonIterableSpread();
}
function Bundles_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Bundles_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Bundles_arrayLikeToArray(o, minLen);
}
var INITIAL_MAX_VISIBLE_ITEMS = 1;
var Bundles = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var productBundles = param.productBundles;
    var ref1 = (0,react.useState)(INITIAL_MAX_VISIBLE_ITEMS), maxVisibleListItems = ref1[0], setMaxVisibleListItems = ref1[1];
    var bundles = productBundles.bundles, product = productBundles.product;
    var bundlesCount = bundles.length;
    var expandList = function(event) {
        event.preventDefault();
        setMaxVisibleListItems(function(previous) {
            // Show 5
            if (previous === 2) {
                return bundlesCount > 5 ? 5 : bundlesCount;
            }
            // Show 10
            if (previous === 5) {
                return bundlesCount > 10 ? 10 : bundlesCount;
            }
            // Show all
            return bundlesCount;
        });
    };
    var collapseList = function(event) {
        event.preventDefault();
        setMaxVisibleListItems(INITIAL_MAX_VISIBLE_ITEMS);
        setTimeout(function() {
            (0,helpers/* scrollElementIntoView */.bx)(ref.current, "smooth");
        }, 50);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-5 mb-6 package-wrapper",
                children: bundles.filter(function(visibleBundle, index) {
                    return maxVisibleListItems >= index + 1;
                }).map(function(bundle, bundleIndex) {
                    var bundleProducts = [
                        product
                    ].concat(Bundles_toConsumableArray(bundle.products));
                    var bundleProductsCount = bundleProducts.length;
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "p-[15px] lg:p-[20px]",
                        id: "pachet-".concat(bundleIndex + 1),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col md:flex-row items-center justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classnames_default()("flex flex-col md:flex-row relative", {
                                            "md:flex-wrap": bundleProductsCount > 2,
                                            "md:justify-between": bundleProductsCount < 3
                                        }),
                                        children: [
                                            bundleProducts.map(function(bundleProduct, bundleProductIndex) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                    className: classnames_default()("w-full md:space-x-[8px] md:p-[8px]", {
                                                        "md:max-w-[50%]": bundleProductsCount > 2,
                                                        "mt-[12px] md:mt-0": bundleProductIndex > 0
                                                    }),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bundles_BundleItem, {
                                                        bundleProductsCount: bundleProductsCount,
                                                        bundleProductIndex: bundleProductIndex,
                                                        bundleProduct: bundleProduct
                                                    }, "package-".concat(bundleIndex, "-product-").concat(bundleProductIndex))
                                                }, bundleProductIndex);
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                "aria-hidden": "true",
                                                className: classnames_default()("hidden md:block absolute text-[44px] -right-[10px] z-[1] top-1/2 -translate-y-1/2 select-none text-yellow", {
                                                    "top-[80%]": bundleProductsCount > 2
                                                }),
                                                children: "="
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classnames_default()("flex gap-[16px] w-full py-4 justify-end md:justify-center items-center md:flex-col md:pl-[16px]", {
                                            "md:w-[50%] self-end": bundleProductsCount > 2,
                                            "md:w-[30%]": bundleProductsCount === 2
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                price: bundle.price,
                                                regularPrice: bundle.regular_price,
                                                formatted: true,
                                                displayDiscount: true,
                                                isBundle: true,
                                                size: "navbar"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCart/* default */.Z, {
                                                iconOnlyOnMobile: true,
                                                bundleProducts: bundleProducts,
                                                product: product,
                                                isBundle: true,
                                                noMargin: true
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }, bundleIndex));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-center mt-2 md:mt-0 pt-1",
                children: [
                    bundlesCount > maxVisibleListItems && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        "aria-expanded": maxVisibleListItems < bundlesCount,
                        className: "flex items-center text-red-brand",
                        onClick: expandList,
                        children: [
                            "Vezi mai multe pachete",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "ml-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {})
                            })
                        ]
                    }),
                    maxVisibleListItems === bundlesCount && bundlesCount > INITIAL_MAX_VISIBLE_ITEMS && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        "aria-expanded": false,
                        className: "flex items-center text-red-brand",
                        onClick: collapseList,
                        children: [
                            "Restrange lista",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "rotate-180 ml-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {})
                            })
                        ]
                    })
                ]
            })
        ]
    }));
});
Bundles.displayName = "Bundles";
/* harmony default export */ var Catalog_Bundles = (Bundles);

// EXTERNAL MODULE: ./components/ExpandableProductList.js + 1 modules
var ExpandableProductList = __webpack_require__(4761);
;// CONCATENATED MODULE: ./components/ProductOffers.js










var ProductOffers_ref = (0,config["default"])(), ProductOffers_settings = ProductOffers_ref.publicRuntimeConfig.settings;
var INITIAL_VISIBLE_OFFERS = 3;
var ProductOffers = function(param) {
    var product = param.product, offers = param.offers, getIsInSpecialCampaign = param.getIsInSpecialCampaign, getLabelsBySellerId = param.getLabelsBySellerId;
    var ref1 = (0,react.useState)(INITIAL_VISIBLE_OFFERS), visibleOffersLimit = ref1[0], setVisibleOffersLimit = ref1[1];
    var containerEl = (0,react.useRef)(null);
    var offersNumber = offers.length;
    var showMore = function(event) {
        event.preventDefault();
        // Show 6
        if (visibleOffersLimit === INITIAL_VISIBLE_OFFERS) {
            return setVisibleOffersLimit(offersNumber > 6 ? 6 : offersNumber);
        }
        // Show 10
        if (visibleOffersLimit === 6) {
            return setVisibleOffersLimit(offersNumber > 10 ? 10 : offersNumber);
        }
        // Show all
        return setVisibleOffersLimit(offersNumber);
    };
    var collapse = function(event) {
        event.preventDefault();
        setVisibleOffersLimit(INITIAL_VISIBLE_OFFERS);
        setTimeout(function() {
            (0,helpers/* scrollElementIntoView */.bx)(containerEl.current, "smooth");
        }, 50);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "",
        ref: containerEl,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-5 flow-root",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex text-xl m-0 mb-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        as: "h2",
                        display: "h2",
                        title: "Alte oferte ale acestui produs",
                        border: "bottom",
                        classesProp: "mb-4"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "\n            m-0 p-0 border-gray-1100 md:border md:rounded-tr-xl md:rounded-bl-xl\n            ".concat(product.resealed.length <= offersNumber ? "mb-22px lg:mb-52px" : "mb-23px", "\n          "),
                children: offers.filter(function(offer, index) {
                    return visibleOffersLimit >= index + 1;
                }).map(function(offer, index) {
                    var isInSpecialCampaign = getIsInSpecialCampaign(offer.seller.id, product);
                    var labels = getLabelsBySellerId(offer.seller.id, product);
                    var hasBenefits = (labels === null || labels === void 0 ? void 0 : labels.length) > 0;
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: "p-4 lg:p-20px md:flex justify-between items-center resealed border-gray-1100 border md:border-0 rounded-tr-xl rounded-bl-xl md:rounded-none mt-4 md:mt-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "lg:w-7/12 flex items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mr-8",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: (0,helpers/* resizeImage */.tg)(product.thumbnail, "300x300"),
                                            alt: product.name,
                                            className: "w-32"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "",
                                        children: [
                                            "Vandut si livrat de ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                                className: "block lg:hidden"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                href: "/vendor/".concat(offer.seller.url_key, "/"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "underline text-bleu font-medium",
                                                    children: offer.seller.name
                                                })
                                            }),
                                            isInSpecialCampaign && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "my-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "".concat(ProductOffers_settings.websiteStatics, "/images/oferta-de-black-friday.svg"),
                                                    alt: "oferta de black friday",
                                                    width: 80
                                                })
                                            }),
                                            hasBenefits && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "my-2 hidden xs:block",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_ProductBenefits, {
                                                    benefits: labels
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            hasBenefits && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "my-2 xs:hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_ProductBenefits, {
                                    benefits: labels
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "lg:w-5/12 flex lg:flex-wrap items-center justify-between md:justify-end",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                        price: offer.price.selling_price,
                                        regularPrice: offer.price.base_price,
                                        formatted: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "xl:w-232px flex flex-row-reverse sm:block md:ml-8 lg:ml-20",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "ml-4 sm:ml-0 mb-0 sm:mb-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCart/* default */.Z, {
                                                iconOnlyOnMobile: true,
                                                product: {
                                                    mainOffer: 0,
                                                    offers: [
                                                        offer
                                                    ],
                                                    name: product.name,
                                                    sku: product.sku,
                                                    image: product.image
                                                }
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }, index));
                })
            }),
            (offersNumber > visibleOffersLimit || visibleOffersLimit === offersNumber && offersNumber > INITIAL_VISIBLE_OFFERS) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center mt-2 md:mt-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    href: "#",
                    className: "flex items-center text-red-brand hover:text-bleu-hover font-medium text-sm",
                    onClick: visibleOffersLimit === offersNumber ? collapse : showMore,
                    children: [
                        visibleOffersLimit === offersNumber ? "Restrange lista" : "Vezi mai multe oferte",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "ml-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                                customClassName: "duration-75 ".concat(visibleOffersLimit === offersNumber ? "rotate-180" : "")
                            })
                        })
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ var components_ProductOffers = (ProductOffers);

;// CONCATENATED MODULE: ./components/ProductPage/ProductPageStickyHeader.js









function ProductPageStickyHeader_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var ProductPageStickyHeader_ref = (0,config["default"])(), ProductPageStickyHeader_publicRuntimeConfig = ProductPageStickyHeader_ref.publicRuntimeConfig, ProductPageStickyHeader_websiteName = ProductPageStickyHeader_publicRuntimeConfig.settings.websiteName;
var isAltex = ProductPageStickyHeader_websiteName === "altex";
var isMediaGalaxy = ProductPageStickyHeader_websiteName === "mediagalaxy";
var ProductPageStickyHeader_isBricoStore = ProductPageStickyHeader_websiteName === "bricostore";
// active product-tab underline: none on brico (the light-red fill is the marker
// on its own), red-brand on altex/MG
var activeTabBorder = ProductPageStickyHeader_isBricoStore ? "border-transparent" : "border-red-brand";
var ProductPageStickyHeader = function(param) {
    var isVisible = param.isVisible, product = param.product, reviews = param.reviews, onSectionClick = param.onSectionClick, sectionInView = param.sectionInView, westacoData = param.westacoData, isWestacoDataValid = param.isWestacoDataValid, activeServices = param.activeServices, hasProductAccesories = param.hasProductAccesories, hasBundles = param.hasBundles;
    var ref1 = (0,helpers/* productHelper */.gU)(product), isProductVisible = ref1.isVisible, isEol = ref1.isEol, isSaleable = ref1.isSaleable, hasStorePickup = ref1.hasStorePickup, hasResealed = ref1.hasResealed, isWestaco = ref1.isWestaco, mainOffer = ref1.mainOffer, hasOtherOffers = ref1.hasOtherOffers;
    // brico tabs mirror the homepage MainMenu items: hover + active use the light
    // red (red-hover), which is the active marker on its own - no underline.
    // altex/MG keep the original underline-only behavior.
    var tabClass = function(section) {
        var _obj;
        return classnames_default()("pt-2 pb-1 border-b-[1px]", (_obj = {
            "px-3": ProductPageStickyHeader_isBricoStore
        }, ProductPageStickyHeader_defineProperty(_obj, activeTabBorder, sectionInView === section), ProductPageStickyHeader_defineProperty(_obj, "bg-red-hover", ProductPageStickyHeader_isBricoStore && sectionInView === section), ProductPageStickyHeader_defineProperty(_obj, "border-transparent cursor-pointer", sectionInView !== section), ProductPageStickyHeader_defineProperty(_obj, "hover:bg-red-hover", ProductPageStickyHeader_isBricoStore && sectionInView !== section), _obj));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fixed w-full z-[2000] left-0 top-0 transform transition-transform ease-in-out ".concat(!isVisible ? "translate-y-0" : "-translate-y-[120px]"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "hidden md:sticky md:flex md:flex-col items-center justify-between md:top-0 md:w-full h-[120px] md:z-50 bg-white",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row items-center justify-between space-x-4 w-full xl:max-w-7xl h-[80px] md:max-w-5xl px-4 xl:px-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-row items-center space-x-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (0,helpers/* resizeImage */.tg)(product.image, "120x120"),
                                    className: "h-[60px] w-[60px]",
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-base font-medium leading-5 line-clamp-2 max-w-[250px] lg:max-w-xs",
                                    children: product.name
                                })
                            ]
                        }),
                        !isEol && isProductVisible && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                !isWestaco && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "hidden xl:flex",
                                    children: get_default()(reviews, "items[0].reviews.value", 0) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_ProductPageHeaderRatings, {
                                        onClick: function(event) {
                                            event.preventDefault();
                                            onSectionClick("reviews");
                                        },
                                        reviewsCount: get_default()(reviews, "items[0].reviews.value", 0),
                                        ratingSummary: get_default()(reviews, "items[0].reviews.total", null),
                                        productUrl: "/".concat(product.url_key, "/cpd/").concat(product.sku, "/")
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Ratings_NoRatingsDataPlaceholder, {
                                        onClick: function(event) {
                                            event.preventDefault();
                                            onSectionClick("reviews");
                                        },
                                        productUrl: "/".concat(product.url_key, "/cpd/").concat(product.sku, "/")
                                    })
                                }),
                                mainOffer && /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                    productId: parseInt(product.id),
                                    price: mainOffer.price.selling_price,
                                    regularPrice: mainOffer.price.base_price,
                                    msrp: mainOffer.price.msrp_price,
                                    showMSRPTooltip: true,
                                    formatted: true,
                                    size: "navbar",
                                    discountType: mainOffer.price.discount_type,
                                    displayDiscount: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-row items-center justify-end space-x-5",
                                    children: (isSaleable || hasStorePickup) && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCart/* default */.Z, {
                                        noMargin: true,
                                        iconOnly: true,
                                        product: product,
                                        activeServices: activeServices,
                                        westaco: westacoData,
                                        disabled: isWestaco && !isWestacoDataValid
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("w-full", {
                        "bg-[#FFC348F2]/95": isAltex,
                        "bg-[#244196]/95": isMediaGalaxy,
                        "bg-red-brand": ProductPageStickyHeader_isBricoStore
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: classnames_default()("flex space-x-8 select-none ", {
                                "text-black": isAltex,
                                "text-white": isMediaGalaxy || ProductPageStickyHeader_isBricoStore
                            }),
                            children: [
                                hasOtherOffers && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: tabClass("oferte"),
                                    onClick: function() {
                                        return onSectionClick("oferte");
                                    },
                                    children: "Alte oferte"
                                }),
                                hasBundles && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: tabClass("pachete"),
                                    onClick: function() {
                                        return onSectionClick("pachete");
                                    },
                                    children: "Pachete Promo"
                                }),
                                hasResealed > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: tabClass("resigilate"),
                                    onClick: function() {
                                        return onSectionClick("resigilate");
                                    },
                                    children: "Resigilate"
                                }),
                                !isWestaco && hasProductAccesories && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: tabClass("accessories"),
                                    onClick: function() {
                                        return onSectionClick("accessories");
                                    },
                                    children: "Accesorii"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: tabClass("description"),
                                    onClick: function() {
                                        return onSectionClick("description");
                                    },
                                    children: "Descriere"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: tabClass("additional"),
                                    onClick: function() {
                                        return onSectionClick("additional");
                                    },
                                    children: "Specificatii"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: tabClass("reviews"),
                                    onClick: function() {
                                        return onSectionClick("reviews");
                                    },
                                    children: "Recenzii"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: tabClass("questions"),
                                    onClick: function() {
                                        return onSectionClick("questions");
                                    },
                                    children: "Intrebari"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: tabClass("compare"),
                                    onClick: function() {
                                        return onSectionClick("compare");
                                    },
                                    children: "Compara"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var ProductPage_ProductPageStickyHeader = (ProductPageStickyHeader);

;// CONCATENATED MODULE: ./components/ProductLabelDescription.js



var ProductLabelDescription = function(param) {
    var cmsBlock = param.cmsBlock;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        dangerouslySetInnerHTML: {
            __html: cmsBlock
        }
    });
};
ProductLabelDescription.propTypes = {
    cmsBlock: (prop_types_default()).string.isRequired
};
/* harmony default export */ var components_ProductLabelDescription = (ProductLabelDescription);

;// CONCATENATED MODULE: ./components/Price/PricePerUnit.js


var PricePerUnit = function(param) {
    var price = param.price, unit = param.unit, factor = param.factor, hasPricePerFactor = param.hasPricePerFactor;
    var _package_selling_price = price.package_selling_price, package_selling_price = _package_selling_price === void 0 ? null : _package_selling_price, _selling_price = price.selling_price, selling_price = _selling_price === void 0 ? null : _selling_price;
    var priceUnit = unit === null || unit === void 0 ? void 0 : unit.split("/")[1];
    if (hasPricePerFactor && package_selling_price) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "text-[16px] text-[#71717B]",
            children: [
                package_selling_price,
                " lei/buc"
            ]
        }));
    }
    if (selling_price && factor && priceUnit) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mb-0.5",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                className: "leading-none text-gray-1200 text-xs",
                children: [
                    "".concat((0,helpers/* formatPrice */.T4)(selling_price / parseFloat(factor))),
                    " lei/",
                    priceUnit
                ]
            })
        }));
    }
    return null;
};
/* harmony default export */ var Price_PricePerUnit = (PricePerUnit);

;// CONCATENATED MODULE: ./components/Icons/WarrantyRibbon.js


function WarrantyRibbon_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function WarrantyRibbon_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            WarrantyRibbon_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function WarrantyRibbon_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = WarrantyRibbon_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function WarrantyRibbon_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var WarrantyRibbon = function(_param) /*#__PURE__*/ {
    var _width = _param.width, width = _width === void 0 ? "17px" : _width, _height = _param.height, height = _height === void 0 ? "17px" : _height, _fill = _param.fill, fill = _fill === void 0 ? "#d71540" : _fill, props = WarrantyRibbon_objectWithoutProperties(_param, [
        "width",
        "height",
        "fill"
    ]);
    return (0,jsx_runtime.jsxs)("svg", WarrantyRibbon_objectSpread({
        clipRule: "evenodd",
        fillRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: "2",
        viewBox: "0 0 543 543",
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: fill
    }, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "266.67",
                cy: "206.83",
                r: "85.625",
                fill: fill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M468.08 199.25a34.421 34.421 0 007.164-21.018 34.442 34.442 0 00-14.205-27.857l-14.584-10.583a34.452 34.452 0 01-14.083-30.834L433.914 91c.095-1.043.143-2.09.143-3.138 0-18.149-14.356-33.339-32.477-34.362l-18-1a34.453 34.453 0 01-28.5-18.333l-8.333-15.959A34.458 34.458 0 00316.35-.068a34.416 34.416 0 00-17.061 4.526l-15.667 8.875a34.45 34.45 0 01-33.917 0l-15.666-8.875a34.427 34.427 0 00-16.962-4.469 34.458 34.458 0 00-30.455 18.386l-8.333 15.958a34.452 34.452 0 01-28.5 18.334l-18 1c-18.121 1.023-32.477 16.212-32.477 34.362 0 1.047.048 2.094.143 3.138l1.542 17.958a34.45 34.45 0 01-14.083 30.833L72.33 150.542a34.442 34.442 0 00-14.205 27.856c0 7.604 2.52 14.998 7.164 21.019l11 14.25a34.452 34.452 0 014.833 33.541l-6.542 16.667a34.431 34.431 0 00-2.35 12.502c0 14.513 9.181 27.537 22.85 32.415l16.959 6.041a34.455 34.455 0 0122.208 25.625l3.25 15.834-43.292 140.71 68.667-21.5 42.75 57.833 39.042-127.62c11.978 9.942 29.282 10.578 41.958 1.542l41.083 126.08 42.75-57.833 68.667 21.5-44.333-136c.291-.958.541-1.875.75-2.875l3.541-17.667a34.454 34.454 0 0122.209-25.625l16.958-6.041c13.67-4.878 22.851-17.902 22.851-32.415 0-4.277-.797-8.517-2.351-12.502l-6.542-16.667a34.45 34.45 0 014.834-33.541l11.041-14.417zm-320.38 7.583c0-65.258 53.7-118.96 118.96-118.96 65.258 0 118.96 53.7 118.96 118.96 0 65.259-53.7 118.96-118.96 118.96-65.233-.069-118.89-53.726-118.96-118.96z",
                fill: fill,
                fillRule: "nonzero"
            })
        ]
    }));
};
/* harmony default export */ var Icons_WarrantyRibbon = (WarrantyRibbon);

;// CONCATENATED MODULE: ./components/ProductWarranty.js



var tooltipContent = {
    garantie_comerciala_global: "pentru persoane juridice",
    garantie_conformitate_global: "pentru persoane fizice"
};
var Warranty = function(param) {
    var data = param.data;
    return data.map(function(warranty, index) {
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
            className: "Warranty-info flex justify-start items-center u-border-dotted",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "Warranty-icon mr-1 w-4 h-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_WarrantyRibbon, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "Warranty-info text-black text-xs leading-[14px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "Warranty-label",
                            children: warranty.label
                        }),
                        ": ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "Warranty-qty font-bold",
                            children: warranty.value
                        })
                    ]
                }),
                tooltipContent[warranty.attribute_code] && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "ml-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                        content: tooltipContent[warranty.attribute_code]
                    })
                })
            ]
        }, index);
    });
};
/* harmony default export */ var ProductWarranty = (Warranty);

;// CONCATENATED MODULE: ./components/ProductGreenTax.js




var ProductGreenTax_ref = (0,config["default"])(), ProductGreenTax_settings = ProductGreenTax_ref.publicRuntimeConfig.settings;
var ProductGreenTax = function(param) {
    var data = param.data;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "Warranty-info flex justify-start items-center u-border-dotted",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "Warranty-icon mr-1 w-4 h-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_WarrantyRibbon, {
                    fill: "#319D10"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "Warranty-info text-black",
                style: {
                    fontSize: "12px",
                    lineHeight: "14px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "Warranty-label",
                        children: "Include taxa verde"
                    }),
                    ": ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "Warranty-qty font-bold",
                        children: [
                            (0,helpers/* formatPrice */.T4)(data),
                            " ",
                            ProductGreenTax_settings.currency
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_ProductGreenTax = (ProductGreenTax);

// EXTERNAL MODULE: ./components/ProductButtonViewResealed.js
var ProductButtonViewResealed = __webpack_require__(1412);
// EXTERNAL MODULE: ./components/Accordion/index.js + 1 modules
var Accordion = __webpack_require__(71604);
// EXTERNAL MODULE: ./components/Accordion/Item/index.js
var Item = __webpack_require__(4259);
// EXTERNAL MODULE: ./components/Accordion/Item/Header.js + 1 modules
var Header = __webpack_require__(85929);
// EXTERNAL MODULE: ./components/Accordion/Item/Body.js
var Body = __webpack_require__(66707);
;// CONCATENATED MODULE: ./components/Icons/Repeat.js

var Repeat = function(param) {
    var _height = param.height, height = _height === void 0 ? "14px" : _height, _width = param.width, width = _width === void 0 ? "14px" : _width;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        height: height,
        width: width,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M6 9h20.2l-3.6-3.6L24 4l6 6-6 6-1.4-1.4 3.6-3.6H6v4H4v-4c0-1.1.9-2 2-2zM9.4 17.4 5.8 21H26v-4h2v4a2 2 0 0 1-2 2H5.8l3.6 3.6L8 28l-6-6 6-6 1.4 1.4z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                d: "M0 0h32v32H0z"
            })
        ]
    });
};
/* harmony default export */ var Icons_Repeat = (Repeat);

;// CONCATENATED MODULE: ./components/ProductPage/ProductStoreAvailability/NoStoreSelected.js





var NoStoreSelected = function(param) {
    var addModal1 = param.addModal;
    var handleAddStoreSelectModal = function(event) {
        event.preventDefault();
        addModal1("StoreSelectModal");
    };
    var handleAddAvailableStoresModal = function(event) {
        event.preventDefault();
        addModal1("AvailableStoresModal");
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col lg:flex-row items-start lg:items-center lg:justify-between gap-[8px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-[14px] font-medium mb-[10px] lg:mb-0",
                children: [
                    "Ridicare imediata, gratuita din magazin",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex gap-[10px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: "flex items-end text-red-brand gap-[3px] cursor-pointer",
                            href: "#",
                            onClick: handleAddStoreSelectModal,
                            rel: "noopener noreferrer",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Repeat, {
                                    width: "18px",
                                    height: "18px"
                                }),
                                "alege un magazin favorit"
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                title: "Vezi stocul in magazine",
                size: "small",
                variant: "third",
                isOrderAgain: true,
                onClick: handleAddAvailableStoresModal
            })
        ]
    }));
};
/* harmony default export */ var ProductStoreAvailability_NoStoreSelected = ((0,es/* connect */.$j)(null, {
    addModal: app_actions/* addModal */.Y_
})(NoStoreSelected));

// EXTERNAL MODULE: ./components/ProductPage/ProductStoreAvailability/StoresFilters.js
var StoresFilters = __webpack_require__(57924);
// EXTERNAL MODULE: ./components/ProductPage/ProductStoreAvailability/StoresList.js
var StoresList = __webpack_require__(53641);
// EXTERNAL MODULE: ./components/ProductPage/ProductStoreAvailability/StoreSchedule.js
var StoreSchedule = __webpack_require__(26945);
// EXTERNAL MODULE: ./components/ProductPage/ProductStoreAvailability/StoreSpecialSchedule.js
var StoreSpecialSchedule = __webpack_require__(23880);
// EXTERNAL MODULE: ./components/Icons/AltexStar.js
var AltexStar = __webpack_require__(85860);
;// CONCATENATED MODULE: ./components/ProductPage/ProductStoreAvailability/StoreStockStatus.js



var StoreStockStatus_ref = (0,config["default"])(), StoreStockStatus_publicRuntimeConfig = StoreStockStatus_ref.publicRuntimeConfig, StoreStockStatus_websiteName = StoreStockStatus_publicRuntimeConfig.settings.websiteName;
var StoreStockStatus_isBricoStore = StoreStockStatus_websiteName === "bricostore";
var getStoreAvailabilityProductQuantityLabel = function(quantity) {
    var label = undefined;
    var textColor = undefined;
    if (StoreStockStatus_isBricoStore) {
        if (quantity >= 6) {
            label = "Stoc suficient (".concat(quantity, " buc)");
            textColor = "text-green";
        } else if (quantity > 2) {
            label = "Cantitate redusa (".concat(quantity, " buc)");
            textColor = "text-orange";
        } else if (quantity === 2) {
            label = "Ultimul produs sigilat (".concat(quantity, " buc)");
            textColor = "text-orange";
        } else if (quantity === 1) {
            label = "Produs expus in magazin (".concat(quantity, " buc)");
            textColor = "text-orange";
        } else {
            label = "Produsul nu este in stoc";
            textColor = "text-red-brand";
        }
    } else {
        if (quantity >= 6) {
            label = "Stoc suficient";
            textColor = "text-green";
        } else if (quantity > 2) {
            label = "Cantitate redusa";
            textColor = "text-orange";
        } else if (quantity === 2) {
            label = "Ultimul produs sigilat";
            textColor = "text-orange";
        } else if (quantity === 1) {
            label = "Produs expus in magazin";
            textColor = "text-orange";
        } else {
            label = "Produsul nu este in stoc";
            textColor = "text-red-brand";
        }
    }
    return {
        label: label,
        textColor: textColor
    };
};
var StoreStockStatus = function(param) {
    var quantity = param.quantity;
    // A store the product has no stock in is missing from the availability
    // payload, so it reaches this component without a qty.
    var ref1 = getStoreAvailabilityProductQuantityLabel(quantity !== null && quantity !== void 0 ? quantity : 0), label = ref1.label, textColor = ref1.textColor;
    if (!label) {
        return null;
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center gap-[4px] font-medium ".concat(textColor),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AltexStar/* default */.Z, {
                width: "12px",
                height: "12px"
            }),
            label
        ]
    }));
};
/* harmony default export */ var ProductStoreAvailability_StoreStockStatus = (StoreStockStatus);

;// CONCATENATED MODULE: ./components/Icons/HeartMarker.js

var HeartMarker = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        fill: "#D11F44",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M5.5 0A5.507 5.507 0 0 0 0 5.5a5.444 5.444 0 0 0 1.108 3.3s.15.197.174.226L5.5 14l4.22-4.976c.022-.027.172-.224.172-.224v-.001A5.442 5.442 0 0 0 11 5.5 5.507 5.507 0 0 0 5.5 0Zm2.105 5.851L5.501 8 3.395 5.851a1.4 1.4 0 0 1 0-1.948 1.33 1.33 0 0 1 1.908 0l.198.203.197-.203a1.33 1.33 0 0 1 1.907 0 1.4 1.4 0 0 1 0 1.948Z"
        })
    });
};
/* harmony default export */ var Icons_HeartMarker = (HeartMarker);

;// CONCATENATED MODULE: ./components/ProductPage/ProductStoreAvailability/AvailableStoresModal/AvailableStoresModalStoreCard.js








var AvailableStoresModalStoreCard_ref = (0,config["default"])(), AvailableStoresModalStoreCard_settings = AvailableStoresModalStoreCard_ref.publicRuntimeConfig.settings;
var AvailableStoresModalStoreCard = function(param) {
    var storeData = param.storeData, onStoreSelect = param.onStoreSelect, selectedStoreId = param.selectedStoreId, product = param.product;
    var hasSpecialSchedule = Boolean(storeData.special_schedule);
    var isSelectedStore = selectedStoreId === storeData.id;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col md:flex-row md:justify-between md:items-center gap-[20px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-[14px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductStoreAvailability_StoreStockStatus, {
                        quantity: storeData.qty
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col sm:flex-row sm:items-center sm:gap-[10px]",
                        children: [
                            (storeData === null || storeData === void 0 ? void 0 : storeData.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: storeData.name
                            }),
                            !isSelectedStore && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "flex items-center cursor-pointer text-red-brand text-[14px] font-medium",
                                href: "#",
                                rel: "noopener noreferrer",
                                onClick: function(event) {
                                    event.preventDefault();
                                    onStoreSelect(storeData);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_HeartMarker, {}),
                                    "Seteaza ca magazin favorit"
                                ]
                            })
                        ]
                    }),
                    storeData.address && storeData.address,
                    hasSpecialSchedule ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreSpecialSchedule/* default */.Z, {
                        schedule: storeData.special_schedule
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreSchedule/* default */.Z, {
                        schedule: storeData.schedule
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "".concat(AvailableStoresModalStoreCard_settings.baseUrl, "/magazine/").concat(storeData.url_key, "/"),
                        rel: "noopener noreferrer",
                        target: "_blank",
                        className: "text-red-brand hover:text-bleu-hover underline",
                        title: "",
                        children: "Vezi harta"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col md:flex-row gap-[10px] md:gap-[20px] min-w-fit",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                        productId: parseInt(product.id),
                        price: product.priceInfo.selling_price || product.price,
                        regularPrice: product.priceInfo.base_price,
                        formatted: true,
                        size: "smaller",
                        displayDiscount: true,
                        msrp: product.msrp_price,
                        discountType: product.discount_type
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AddToCartReserveInStore, {
                        product: product
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var AvailableStoresModal_AvailableStoresModalStoreCard = (AvailableStoresModalStoreCard);

// EXTERNAL MODULE: ./lib/sortedStores.js
var sortedStores = __webpack_require__(35254);
// EXTERNAL MODULE: ./lib/filterStores.js
var filterStores = __webpack_require__(19626);
;// CONCATENATED MODULE: ./components/ProductPage/ProductStoreAvailability/AvailableStoresModal/index.js









var AvailableStoresModal = function(param1) {
    var product = param1.product, onStoreSelect = param1.onStoreSelect, selectedStore = param1.selectedStore;
    var ref = (0,react.useState)(), regionIdFilter = ref[0], setRegionIdFilter = ref[1];
    var ref1 = (0,react.useState)(""), storeNameFilter = ref1[0], setStoreNameFilter = ref1[1];
    var storesData = (0,react.useMemo)(function() {
        return (0,sortedStores/* default */.Z)({
            storesData: product === null || product === void 0 ? void 0 : product.stockInfo,
            stickyStore: selectedStore
        });
    }, [
        product,
        selectedStore
    ]);
    // Get available regions form product stores
    var regions = (0,react.useMemo)(function() {
        return storesData.reduce(function(acc, store) {
            if (!acc.find(function(region) {
                return region.id === store.region_id;
            })) {
                acc.push({
                    id: store.region_id,
                    name: store.region_name
                });
            }
            return acc;
        }, []).sort(function(a, b) {
            return a.name.localeCompare(b.name);
        });
    }, [
        product
    ]);
    var handleFiltersChange = function(param) {
        var regionId = param.regionId, storeSearch = param.storeSearch;
        if (regionId !== regionIdFilter) {
            setRegionIdFilter(regionId);
        }
        if (storeSearch && storeSearch.length > 2) {
            setStoreNameFilter(storeSearch);
        } else if (!storeSearch || storeSearch.length <= 2) {
            setStoreNameFilter("");
        }
    };
    var filteredStores = (0,filterStores/* default */.Z)({
        storesData: storesData,
        regionId: regionIdFilter,
        storeName: storeNameFilter
    });
    var hasStores = filteredStores.length > 0;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal["default"], {
        header: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "text-[18px]",
            children: "Produsul este disponibil doar in magazinele de mai jos"
        }),
        id: "AvailableStoresModal",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-[20px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                    type: "info",
                    showIcon: true,
                    children: "Pentru a rezerva acest produs, trebuie sa il adaugi in cos. Poti continua de acolo procesul de rezervare."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StoresFilters/* default */.Z, {
                regions: regions,
                onFiltersChange: handleFiltersChange
            }),
            hasStores ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StoresList/* default */.Z, {
                storesData: filteredStores,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AvailableStoresModal_AvailableStoresModalStoreCard, {
                    onStoreSelect: onStoreSelect,
                    selectedStoreId: selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.id,
                    product: product
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-[20px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                    type: "error",
                    showIcon: true,
                    children: "Nu am gasit un magazin care sa indeplineasca criteriile filtrelor selectate."
                })
            })
        ]
    }));
};
/* harmony default export */ var ProductStoreAvailability_AvailableStoresModal = (AvailableStoresModal);

;// CONCATENATED MODULE: ./components/ProductPage/ProductStoreAvailability/StoreSelected.js







var StoreSelected = function(param) {
    var storeData = param.storeData, isStockKnown = param.isStockKnown, addModal1 = param.addModal;
    var handleAddStoreSelectModal = function(event) {
        event.preventDefault();
        addModal1("StoreSelectModal");
    };
    var handleAddAvailableStoresModal = function(event) {
        event.preventDefault();
        addModal1("AvailableStoresModal");
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col lg:flex-row items-start lg:items-center lg:justify-between gap-[8px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-[14px] flex flex-col font-medium",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_HeartMarker, {}),
                            " ",
                            storeData.name,
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "text-red-brand cursor-pointer ml-[6px]",
                                href: "#",
                                onClick: handleAddStoreSelectModal,
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Repeat, {
                                    width: "18px",
                                    height: "18px"
                                })
                            })
                        ]
                    }),
                    isStockKnown && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductStoreAvailability_StoreStockStatus, {
                        quantity: storeData.qty
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                title: "Vezi in alta locatie",
                isOrderAgain: true,
                variant: "third",
                onClick: handleAddAvailableStoresModal
            })
        ]
    }));
};
/* harmony default export */ var ProductStoreAvailability_StoreSelected = ((0,es/* connect */.$j)(null, {
    addModal: app_actions/* addModal */.Y_
})(StoreSelected));

// EXTERNAL MODULE: ./lib/clientStore.js
var clientStore = __webpack_require__(66208);
// EXTERNAL MODULE: ./store/user/actions.js
var user_actions = __webpack_require__(49865);
// EXTERNAL MODULE: ./components/ProductPage/ProductStoreAvailability/StoreSelectModal/index.js + 1 modules
var StoreSelectModal = __webpack_require__(78220);
;// CONCATENATED MODULE: ./components/ProductPage/ProductStoreAvailability/index.js














var ProductStoreAvailability_ref = (0,config["default"])(), ProductStoreAvailability_publicRuntimeConfig = ProductStoreAvailability_ref.publicRuntimeConfig, ProductStoreAvailability_websiteName = ProductStoreAvailability_publicRuntimeConfig.settings.websiteName;
var ProductStoreAvailability_isBricoStore = ProductStoreAvailability_websiteName === "bricostore";
var ProductStoreAvailability = function(param) {
    var productStoreAvailability = param.productStoreAvailability, user = param.user, getProductStoreAvailability1 = param.getProductStoreAvailability, identifier = param.identifier, removeModal1 = param.removeModal, stores = param.stores, setFavouriteStoreId1 = param.setFavouriteStoreId, openedModal = param.openedModal;
    var product = productStoreAvailability.data, isLoading = productStoreAvailability.isLoading;
    var customer = user.customer, favouriteStoreId = user.favouriteStoreId, isLoggedIn = user.isLoggedIn;
    // Stores without stock are left out of the availability payload, so a store
    // that carries no qty means "out of stock" only once this product's stockInfo
    // has actually landed. Until then (loading, request failed, or the payload
    // still belongs to the previously viewed sku) the stock state is unknown and
    // no status is shown.
    var isStockKnown = (product === null || product === void 0 ? void 0 : product.sku) === identifier && Array.isArray(product.stockInfo);
    var ref3 = (0,react.useState)(null), selectedStore1 = ref3[0], setSelectedStore = ref3[1];
    var ref1, ref2;
    // Determine the selected store ID from customer, favorite, or local storage
    var selectedStoreId = (ref2 = (ref1 = customer === null || customer === void 0 ? void 0 : customer.store_id) !== null && ref1 !== void 0 ? ref1 : favouriteStoreId) !== null && ref2 !== void 0 ? ref2 : clientStore/* localClientStore.get */.C.get("favouriteStoreId");
    (0,react.useEffect)(function() {
        var resolveSelectedStore = function() {
            if (selectedStoreId && (stores === null || stores === void 0 ? void 0 : stores.length)) {
                // Find the selected store in the stores array
                var selectedStore = stores.find(function(store) {
                    return store.id === selectedStoreId;
                });
                if (!(product === null || product === void 0 ? void 0 : product.stockInfo)) {
                    setSelectedStore(selectedStore);
                    return;
                }
                // Find the selected store in product stock availability
                var storeWithStock = product.stockInfo.find(function(store) {
                    return store.id === selectedStoreId;
                });
                // Update the selected store with stock info or fallback to the selected store
                setSelectedStore(storeWithStock || selectedStore);
            }
        };
        resolveSelectedStore();
    }, [
        product,
        isLoggedIn,
        customer,
        favouriteStoreId,
        stores,
        selectedStoreId, 
    ]);
    (0,react.useEffect)(function() {
        if (!product || product.sku !== identifier) {
            getProductStoreAvailability1(identifier);
        }
    }, [
        identifier
    ]);
    var handleStoreSelect = function(store) {
        setSelectedStore(store);
        setFavouriteStoreId1(store.id);
        removeModal1();
    };
    if (isLoading) return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("py-[40px] px-[20px]", {
            "bg-[#FAFAFA]": !ProductStoreAvailability_isBricoStore,
            "border rounded-[4px] border-gray-light": ProductStoreAvailability_isBricoStore
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {
            hasMarginBottom: false
        })
    }));
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("p-[16px] rounded-[4px]", {
            "bg-[#FAFAFA]": !ProductStoreAvailability_isBricoStore,
            "border border-gray-light": ProductStoreAvailability_isBricoStore
        }),
        children: [
            selectedStore1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductStoreAvailability_StoreSelected, {
                storeData: selectedStore1,
                isStockKnown: isStockKnown
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductStoreAvailability_NoStoreSelected, {}),
            openedModal === "AvailableStoresModal" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductStoreAvailability_AvailableStoresModal, {
                product: product,
                onStoreSelect: handleStoreSelect,
                selectedStore: selectedStore1
            }),
            openedModal === "StoreSelectModal" && /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreSelectModal/* default */.Z, {
                onStoreSelect: handleStoreSelect,
                selectedStore: selectedStore1
            })
        ]
    }));
};
/* harmony default export */ var ProductPage_ProductStoreAvailability = ((0,es/* connect */.$j)(function(state) {
    return {
        productStoreAvailability: state.catalog.productStoreAvailability,
        user: state.user,
        stores: state.stores.data,
        openedModal: state.app.modal
    };
}, {
    getProductStoreAvailability: catalog_actions/* getProductStoreAvailability */.$A,
    removeModal: app_actions/* removeModal */.a_,
    setFavouriteStoreId: user_actions/* setFavouriteStoreId */.T5
})(ProductStoreAvailability));

;// CONCATENATED MODULE: ./components/ProductPage/VivinoWidget.js

var VivinoWidget = function(param) {
    var vivinoId = param.vivinoId;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("iframe", {
        className: "w-[200px] h-[60px]",
        srcDoc: "\n        <body style=\"margin: 0\">\n          <div\n            class=\"vivino-widget vivino-wine-card-widget\"\n            style=\"position: absolute\"\n            data-vivino-widget-type=\"wine\"\n            data-vivino-vintage-id=\"".concat(vivinoId, "\"\n            data-vivino-widget-language=\"en\"\n            data-vivino-widget-layout=\"small_new\"\n          ></div>\n\n          <script\n            src=\"https://www.vivino.com/external/vivino-widgets.js\"\n            async\n          ></script>\n        </body>\n    ")
    });
};
/* harmony default export */ var ProductPage_VivinoWidget = (VivinoWidget);

// EXTERNAL MODULE: ./components/Tabs.js
var Tabs = __webpack_require__(30672);
;// CONCATENATED MODULE: ./components/ProductPage/ProductPageStickyFooter.js



var ProductPageStickyFooter = function(param) {
    var product = param.product, activeServices = param.activeServices, westacoData = param.westacoData, isWestacoDataValid = param.isWestacoDataValid;
    var isWestaco = (0,helpers/* productHelper */.gU)(product).isWestaco;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCart/* default */.Z, {
            product: product,
            activeServices: activeServices,
            westaco: westacoData,
            disabled: isWestaco && !isWestacoDataValid
        })
    }));
};
/* harmony default export */ var ProductPage_ProductPageStickyFooter = (ProductPageStickyFooter);

;// CONCATENATED MODULE: ./components/ProductPage/ProductBrand.js




var ProductBrand = function(param) {
    var product = param.product;
    var brand_link = product.brand_link, brand_logo = product.brand_logo, brand_name = product.brand_name;
    var isAppleBrand = brand_name.toLowerCase() === "apple";
    var link = isAppleBrand ? "/shop/apple" : brand_link;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mx-auto max-w-lg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
            href: link,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "border-[#D9D9D9] border rounded-md p-4 flex flex-col xs:flex-row items-center justify-between text-14px gap-1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (0,helpers/* resizeImage */.tg)(brand_logo, "300x300"),
                            alt: brand_name,
                            className: "h-10 w-auto"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "Vezi toate produsele"
                        })
                    ]
                })
            })
        })
    }));
};
/* harmony default export */ var ProductPage_ProductBrand = (ProductBrand);

// EXTERNAL MODULE: ./lib/GTMHelper.js
var GTMHelper = __webpack_require__(17242);
;// CONCATENATED MODULE: ./components/Icons/FreeShippingIcon.js

var FreeShippingIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? "20px" : _width, _height = param.height, height = _height === void 0 ? "20px" : _height;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#F95",
                d: "M8.8 0C8 0 7.5.6 7.5 1.3V10c0 .7.6 1.3 1.3 1.3h10c.6 0 1.2-.6 1.2-1.3V1.3c0-.7-.6-1.3-1.3-1.3h-10Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#E4EFF8",
                d: "M12.2 0v3.8c0 .2.2.3.4.2l1.2-.5 1 .5c.3.1.5 0 .5-.2V0h-3.1Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FFC6A0",
                d: "M18.1 14.6c-.2-.6-.8-.9-1.4-.7l-4.6 1.6c0-.3-.2-.6-.6-.8l-3.2-1.9s-.7-.4-1.7-.4c-.8 0-1.8.5-2.8 1.1v5.2l1.8-.3c.3 0 .8.4 1.4.8.6.4 1.3.8 2 .8a44.2 44.2 0 0 0 8.4-4c.6-.3 1-.9.7-1.4Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FFAF7A",
                d: "M3.8 13.5v5.2l.9-.2v-5l-.1-.4-.8.4Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FFAF7A",
                d: "M17.5 15.3a96.5 96.5 0 0 1-6.4 3.4 6 6 0 0 1-2 .7c-.8 0-1.5-.5-2.1-.9-.6-.4-1-.7-1.4-.7a9.8 9.8 0 0 0-1.8.2v.7l1.8-.3c.3 0 .8.4 1.4.8.6.4 1.3.8 2 .8a44.2 44.2 0 0 0 8.4-4c.6-.3.9-.8.7-1.4 0 .3-.3.6-.6.7Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FFAF7A",
                d: "M8.7 15.2c-.3-.2-.6.4-.3.6l1.9 1c.6.4 1.3.2 1.7-.4.3-.5.2-1-.1-1.4.2.3.2.7 0 1a1 1 0 0 1-1.3.3l-1.9-1Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#549AD4",
                d: "M.6 12.8c-.3 0-.6.3-.6.6v5.7c0 .3.3.6.6.6h2.8c.4 0 .7-.3.7-.6v-5.7c0-.3-.3-.6-.7-.6H.6Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#E4EFF8",
                d: "M1.6 18.4a.3.3 0 1 1-.7 0 .3.3 0 0 1 .7 0Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#3588CB",
                d: "M1.3 19a.6.6 0 0 1-.7-.6v-5.6c-.3 0-.6.3-.6.6v5.7c0 .3.3.6.6.6h2.8c.4 0 .7-.3.7-.6H1.3Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#C4DCF0",
                d: "M12.2 0v3.8c0 .2.2.3.4.2h.3V0h-.7Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FF7F29",
                d: "M8.2.1c-.4.2-.7.6-.7 1.2V10c0 .7.6 1.3 1.3 1.3h10c.5 0 .9-.4 1-.8l-.4.1h-10c-.7 0-1.3-.5-1.3-1.2V.6l.1-.5Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#ECB200",
                d: "M5 2.5c-.4 0-.4.6 0 .6h1.3c.4 0 .4-.6 0-.6H5Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FFCA28",
                d: "M.3 3.7c-.4 0-.4.7 0 .7h3.8c.4 0 .4-.7 0-.7H.3Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#ECB200",
                d: "M2.5 5.6c-.4 0-.4.7 0 .7H5c.4 0 .4-.7 0-.7H2.5Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FFCA28",
                d: "M1 7.5c-.5 0-.5.6 0 .6h3c.5 0 .5-.6 0-.6H1Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#E4EFF8",
                d: "M15.6 8.1c-.1 0-.3.1-.3.3v1c0 .4.6.4.6 0v-1c0-.2-.1-.3-.3-.3ZM16.9 8.1c-.2 0-.3.1-.3.3v1c0 .4.6.4.6 0v-1c0-.2-.2-.3-.3-.3ZM18.1 8.1c-.1 0-.3.1-.3.3v1c0 .4.6.4.6 0v-1c0-.2-.1-.3-.3-.3Z"
            })
        ]
    });
};
/* harmony default export */ var Icons_FreeShippingIcon = (FreeShippingIcon);

;// CONCATENATED MODULE: ./components/ProductPage/FreeShippingPromoMessage.js


var FreeShippingPromoMessage = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center gap-4 rounded-lg bg-[#F5FBF4] p-[8px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex p-[8px] items-center justify-center rounded-full bg-[#F6F6F6]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_FreeShippingIcon, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-[#319D10] text-[14px]",
                children: "Felicitari! Beneficiezi de transport gratuit datorita comenzilor tale recente."
            })
        ]
    });
};
/* harmony default export */ var ProductPage_FreeShippingPromoMessage = (FreeShippingPromoMessage);

// EXTERNAL MODULE: ./components/ProductFinancing/index.js + 7 modules
var ProductFinancing = __webpack_require__(73363);
// EXTERNAL MODULE: ./components/CredexUserPromoBanner/index.js + 2 modules
var CredexUserPromoBanner = __webpack_require__(87246);
;// CONCATENATED MODULE: ./components/ProductPage/ProductPageSellerInfo.js


var ProductPageSellerInfo = function(param) {
    var seller = param.seller;
    var name = seller.name, url_key = seller.url_key;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "text-[14px]",
        children: [
            "Vandut si livrat de:",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                href: "/vendor/".concat(url_key),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    title: name,
                    className: "text-[#1D4ED8] underline font-medium",
                    children: name
                })
            })
        ]
    }));
};
/* harmony default export */ var ProductPage_ProductPageSellerInfo = (ProductPageSellerInfo);

// EXTERNAL MODULE: ./components/Price/FormatedPrice.js
var FormatedPrice = __webpack_require__(12298);
;// CONCATENATED MODULE: ./components/ProductPage/ProductPageResealedInfo.js




var ProductPageResealedInfo_ref = (0,config["default"])(), ProductPageResealedInfo_publicRuntimeConfig = ProductPageResealedInfo_ref.publicRuntimeConfig, ProductPageResealedInfo_websiteName = ProductPageResealedInfo_publicRuntimeConfig.settings.websiteName;
var ProductPageResealedInfo_isBricoStore = ProductPageResealedInfo_websiteName === "bricostore";
var ProductPageResealedInfo = function(param) {
    var resealedList = param.resealedList, onResealedClick = param.onResealedClick;
    var resealedCount = resealedList.length;
    var resealedLabel = resealedCount === 1 ? "resigilat" : "resigilate";
    var lowestPrice = resealedList.reduce(function(cheapest, current) {
        return parseFloat(current.price.selling_price) < parseFloat(cheapest) ? current.price.selling_price : cheapest;
    }, resealedList[0].price.selling_price);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(ProductPageResealedInfo_isBricoStore ? "text-green" : "bg-[#F0FDF4] text-[#16A34A]", " p-[8px] font-medium text-[14px] rounded"),
        onClick: onResealedClick,
        children: [
            resealedCount,
            " ",
            resealedLabel,
            ", de la",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatedPrice/* default */.Z, {
                price: lowestPrice,
                currency: "lei"
            }),
            ".",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                href: "#resigilate",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: "".concat(ProductPageResealedInfo_isBricoStore ? "text-orange" : "text-[#1D4ED8]", " underline"),
                    children: [
                        "Vezi ",
                        resealedLabel
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ var ProductPage_ProductPageResealedInfo = (ProductPageResealedInfo);

// EXTERNAL MODULE: ./components/ProductPage/ProductServices/ProductServicesAfmForm.js
var ProductServicesAfmForm = __webpack_require__(3567);
;// CONCATENATED MODULE: ./components/ProductPage/ProductServices/Services.js









function Services_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Services_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Services_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Services_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Services_slicedToArray(arr, i) {
    return Services_arrayWithHoles(arr) || Services_iterableToArrayLimit(arr, i) || Services_unsupportedIterableToArray(arr, i) || Services_nonIterableRest();
}
function Services_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Services_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Services_arrayLikeToArray(o, minLen);
}
var Services_ref = (0,config["default"])(), Services_settings = Services_ref.publicRuntimeConfig.settings;
var getTypeId = function(serviceKey) {
    return Services_settings.servicesCodes[serviceKey];
};
var CheckboxCheckedIcon = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("svg", {
        width: "10",
        height: "10",
        viewBox: "0 0 10 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
            width: "10",
            height: "10",
            rx: "5",
            fill: "#319D10"
        })
    });
};
var Services = function(param1) {
    var services = param1.services, activeServices = param1.activeServices, onServiceSelect = param1.onServiceSelect;
    var ref1 = (0,react.useState)(false), showAfmForm = ref1[0], setShowAfmForm = ref1[1];
    var toggleAfmForm = function() {
        setShowAfmForm(function(prev) {
            return !prev;
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "space-y-[16px]",
        children: Object.entries(services).map(function(param) {
            var _param = Services_slicedToArray(param, 2), serviceKey = _param[0], servicesOptions = _param[1];
            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-[#FFF9EB] p-[16px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            as: "h3",
                            display: "h4",
                            classesProp: "text-[20px] leading-[24px]",
                            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceTitle/* default */.Z, {
                                serviceKey: serviceKey
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: servicesOptions.map(function(serviceOption) {
                            var ref3, ref2;
                            var sku = serviceOption.sku, short_description = serviceOption.short_description, name = serviceOption.name, price = serviceOption.price, product_links = serviceOption.product_links, id = serviceOption.id;
                            var hasVoucherService = Services_settings.serviceAFMVoucherSkus.includes(sku);
                            return hasVoucherService ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "my-1 md:my-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                        className: "flex items-start md:mr-3 mt-2 font-normal cursor-pointer",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                className: "checkbox-input sr-only",
                                                type: "checkbox",
                                                name: "product_services".concat(serviceKey),
                                                value: sku,
                                                checked: showAfmForm,
                                                onChange: toggleAfmForm
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "checkbox-control is-radio flex-none w-5 h-5 p-1 mr-2 border-gray-1600 hover:border-black border rounded-full bg-white",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxCheckedIcon, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: " text-base leading-5",
                                                children: "Voucher AFM “Rabla pentru electrocasnice”"
                                            })
                                        ]
                                    }),
                                    showAfmForm && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "ml-[30px] pb-[24px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductServicesAfmForm/* default */.Z, {
                                            serviceClick: onServiceSelect,
                                            serviceKey: serviceKey,
                                            serviceOption: serviceOption
                                        })
                                    })
                                ]
                            }, "".concat(serviceKey, "-").concat(sku)) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "my-1 md:my-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                        className: "flex items-start md:mr-3 mt-2 font-normal cursor-pointer",
                                        htmlFor: "".concat(serviceKey, "-").concat(sku),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                className: "checkbox-input opacity-0 w-0 h-0",
                                                type: "checkbox",
                                                id: "".concat(serviceKey, "-").concat(sku),
                                                name: "product_services".concat(serviceKey),
                                                value: sku,
                                                checked: (activeServices === null || activeServices === void 0 ? void 0 : (ref3 = activeServices[serviceKey]) === null || ref3 === void 0 ? void 0 : ref3.sku) === sku,
                                                onChange: function() {
                                                    onServiceSelect({
                                                        serviceKey: serviceKey,
                                                        sku: sku
                                                    });
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "checkbox-control is-radio flex-none w-5 h-5 p-1 mr-2 border-gray-1600 hover:border-black border rounded-full bg-white",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxCheckedIcon, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-wrap gap-x-1 text-base leading-5",
                                                children: [
                                                    short_description !== null && short_description !== void 0 ? short_description : name,
                                                    Boolean(price) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "- ".concat((0,helpers/* formatPrice */.T4)(price), " lei")
                                                    }),
                                                    serviceKey === "install" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "ml-0.5",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                            content: name
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (product_links === null || product_links === void 0 ? void 0 : (ref2 = product_links[serviceKey]) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "ml-6",
                                        children: product_links[serviceKey].map(function(childService) {
                                            var ref5, ref4;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                className: "my-1 md:my-0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: "flex items-start md:mr-3 mt-2 font-normal cursor-pointer",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            className: "checkbox-input opacity-0 w-0 h-0",
                                                            type: "checkbox",
                                                            name: "product_services[".concat(getTypeId(serviceKey), "].childService"),
                                                            value: id,
                                                            checked: (activeServices === null || activeServices === void 0 ? void 0 : (ref5 = activeServices[serviceKey]) === null || ref5 === void 0 ? void 0 : (ref4 = ref5.additional_data) === null || ref4 === void 0 ? void 0 : ref4.childSku) === childService.sku,
                                                            onChange: function() {
                                                                return onServiceSelect({
                                                                    serviceKey: serviceKey,
                                                                    sku: sku,
                                                                    additional_data: {
                                                                        childSku: childService.sku
                                                                    }
                                                                });
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "checkbox-control is-radio flex-none w-5 h-5 p-1 mr-2 border-gray-1600 hover:border-black border bg-white",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxCheckedIcon, {})
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex flex-wrap gap-x-1 text-base leading-5",
                                                            children: [
                                                                childService.name,
                                                                childService && Boolean(childService.price) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: "- ".concat((0,helpers/* formatPrice */.T4)(childService.price), " lei")
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }, sku + childService.sku);
                                        })
                                    })
                                ]
                            }, "".concat(serviceKey, "-").concat(sku));
                        })
                    }),
                    serviceKey === "buyback" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-[20px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                            type: "info",
                            hasMinWidth: false,
                            showIcon: true,
                            children: "La ridicare, produsul trebuie sa fie deja deconectat de la retele si dezinstalat."
                        })
                    })
                ]
            }, serviceKey));
        })
    }));
};
/* harmony default export */ var ProductServices_Services = (Services);

;// CONCATENATED MODULE: ./components/ProductPage/ProductServices/ProductServicesModal.js



var ProductServicesModal = function(param) {
    var services = param.services, activeServices = param.activeServices, serviceClick = param.serviceClick;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Modal["default"], {
        id: "productServicesModal",
        header: "Adauga extra servicii",
        position: "right",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductServices_Services, {
            services: services,
            activeServices: activeServices,
            onServiceSelect: serviceClick
        })
    });
};
/* harmony default export */ var ProductServices_ProductServicesModal = (ProductServicesModal);

// EXTERNAL MODULE: ./components/Icons/CompareProduct.js
var CompareProduct = __webpack_require__(89675);
// EXTERNAL MODULE: ./components/Icons/Heart.js
var Heart = __webpack_require__(24388);
// EXTERNAL MODULE: ./store/wishlist/actions.js
var wishlist_actions = __webpack_require__(506);
;// CONCATENATED MODULE: ./components/ProductPage/ProductPageWishlistAndCompare.js









function ProductPageWishlistAndCompare_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var ProductPageWishlistAndCompare_ref = (0,config["default"])(), ProductPageWishlistAndCompare_publicRuntimeConfig = ProductPageWishlistAndCompare_ref.publicRuntimeConfig, ProductPageWishlistAndCompare_websiteName = ProductPageWishlistAndCompare_publicRuntimeConfig.settings.websiteName;
var ProductPageWishlistAndCompare_isBricoStore = ProductPageWishlistAndCompare_websiteName === "bricostore";
// Favorite/Compara: bricostore uses pills (rounded-full) like add-to-cart; altex/MG keep the diagonal radius
var WISH_COMPARE_RADIUS = ProductPageWishlistAndCompare_isBricoStore ? "rounded-full" : "rounded-tr rounded-bl";
// Brico: red palette (was blue #1D4ED8); altex/MG keep the blue
var WC_BORDER = ProductPageWishlistAndCompare_isBricoStore ? "border-red-brand" : "border-[#1D4ED8]";
var wcSelected = ProductPageWishlistAndCompare_isBricoStore ? "bg-red-brand text-white" : "bg-[#1D4ED8] text-white";
var wcUnselected = ProductPageWishlistAndCompare_isBricoStore ? "bg-white text-red-brand" : "bg-white text-[#1D4ED8]";
var ProductPageWishlistAndCompare = function(param) {
    var addToCompare1 = param.addToCompare, removeFromCompare1 = param.removeFromCompare, addToWishlist1 = param.addToWishlist, deleteFromWishlist1 = param.deleteFromWishlist, wishlistProductsList = param.wishlistProductsList, compareProductsList = param.compareProductsList, product = param.product, user = param.user;
    var ref2;
    var ref1 = (0,helpers/* productHelper */.gU)(product), isWestaco = ref1.isWestaco, isVirtualService = ref1.isVirtualService;
    if (((ref2 = user.customer) === null || ref2 === void 0 ? void 0 : ref2.sales_consultant_id) || isWestaco || isVirtualService) {
        return null;
    }
    var isInCompare = Boolean(compareProductsList.find(function(compareProduct) {
        return compareProduct.sku === product.sku;
    }));
    var isInWishlist = Boolean(wishlistProductsList === null || wishlistProductsList === void 0 ? void 0 : wishlistProductsList.includes(product.sku));
    var _obj, _obj1;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: classnames_default()("flex items-center justify-center gap-[4px] w-full border ".concat(WC_BORDER, " ").concat(WISH_COMPARE_RADIUS, " text-[14px] py-[8px] px-[16px]"), (_obj = {}, ProductPageWishlistAndCompare_defineProperty(_obj, wcSelected, isInWishlist), ProductPageWishlistAndCompare_defineProperty(_obj, wcUnselected, !isInWishlist), _obj)),
                onClick: function() {
                    return isInWishlist ? deleteFromWishlist1(product) : addToWishlist1(product);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heart/* default */.Z, {
                        width: "20px",
                        height: "20px"
                    }),
                    " Favorite"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: classnames_default()("flex items-center justify-center gap-[4px] w-full border ".concat(WC_BORDER, " ").concat(WISH_COMPARE_RADIUS, " text-[14px] py-[8px] px-[16px]"), (_obj1 = {}, ProductPageWishlistAndCompare_defineProperty(_obj1, wcSelected, isInCompare), ProductPageWishlistAndCompare_defineProperty(_obj1, wcUnselected, !isInCompare), _obj1)),
                onClick: function() {
                    return isInCompare ? removeFromCompare1(product.sku) : addToCompare1(product.sku);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompareProduct/* default */.Z, {
                        width: "20px",
                        height: "20px"
                    }),
                    " Compara"
                ]
            })
        ]
    }));
};
/* harmony default export */ var ProductPage_ProductPageWishlistAndCompare = ((0,es/* connect */.$j)(function(state) {
    return {
        user: state.user,
        wishlistProductsList: state.wishlist.productsAll,
        compareProductsList: state.catalog.compare
    };
}, {
    addToCompare: catalog_actions/* addToCompare */.a$,
    removeFromCompare: catalog_actions/* removeFromCompare */.q7,
    addToWishlist: wishlist_actions/* addToWishlist */.Mp,
    deleteFromWishlist: wishlist_actions/* deleteFromWishlist */.ib
})(ProductPageWishlistAndCompare));

// EXTERNAL MODULE: ./components/Icons/Lockers/SelectedLockerMarkerIcon.js
var SelectedLockerMarkerIcon = __webpack_require__(30247);
// EXTERNAL MODULE: ./components/Lockers/_lib/constants.js
var constants = __webpack_require__(14003);
// EXTERNAL MODULE: ./components/Lockers/LockerCard/LockerCardRoutingAction.js
var LockerCardRoutingAction = __webpack_require__(1272);
// EXTERNAL MODULE: ./components/Lockers/LockerCard/LockerCardName.js
var LockerCardName = __webpack_require__(28006);
// EXTERNAL MODULE: ./components/Lockers/LockerCard/LockerCardAddress.js
var LockerCardAddress = __webpack_require__(35203);
// EXTERNAL MODULE: ./components/Lockers/LockerCard/LockerCardInactiveTag.js
var LockerCardInactiveTag = __webpack_require__(1441);
;// CONCATENATED MODULE: ./components/ProductPage/ProductLockerAvailability/UserWithLocker.js










var UserWithLocker = function(param) {
    var selectedLocker = param.selectedLocker, addModal1 = param.addModal;
    var handleAddLockerModal = function(event) {
        event.preventDefault();
        addModal1(constants/* PRODUCT_PAGE_MODAL_LOCKERS_MAP_ID */.AR);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col lg:flex-row items-start lg:items-center lg:justify-between gap-[8px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-[14px] space-y-[8px] leading-tight",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-wrap items-center gap-[4px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedLockerMarkerIcon/* default */.Z, {
                                        color: "#2CAAE1"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LockerCardName/* default */.Z, {
                                        locker: selectedLocker
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LockerCardInactiveTag/* default */.Z, {
                                        locker: selectedLocker
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LockerCardAddress/* default */.Z, {
                                locker: selectedLocker
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LockerCardRoutingAction/* default */.Z, {
                        locker: selectedLocker
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                title: "Schimba",
                size: "small",
                variant: "third",
                isOrderAgain: true,
                onClick: handleAddLockerModal
            })
        ]
    }));
};
/* harmony default export */ var ProductLockerAvailability_UserWithLocker = ((0,es/* connect */.$j)(null, {
    addModal: app_actions/* addModal */.Y_
})(UserWithLocker));

;// CONCATENATED MODULE: ./components/ProductPage/ProductLockerAvailability/UserWithoutLocker.js





var UserWithoutLocker = function(param) {
    var addModal1 = param.addModal;
    var handleAddLockerModal = function(event) {
        event.preventDefault();
        addModal1(constants/* PRODUCT_PAGE_MODAL_LOCKERS_MAP_ID */.AR);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col lg:flex-row items-start lg:items-center lg:justify-between gap-[8px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-[14px] font-medium mb-[10px] lg:mb-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Punct de ridicare"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-[#808080] text-[12px] leading-[14px]",
                        children: "Selecteaza un punct favorit"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                title: "Selecteaza",
                size: "small",
                variant: "third",
                isOrderAgain: true,
                onClick: handleAddLockerModal
            })
        ]
    }));
};
/* harmony default export */ var ProductLockerAvailability_UserWithoutLocker = ((0,es/* connect */.$j)(null, {
    addModal: app_actions/* addModal */.Y_
})(UserWithoutLocker));

// EXTERNAL MODULE: ./components/LockersMapWithFilters/LockersMapWithFiltersModal.js + 19 modules
var LockersMapWithFiltersModal = __webpack_require__(4434);
;// CONCATENATED MODULE: ./components/ProductPage/ProductLockerAvailability/index.js















function ProductLockerAvailability_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ProductLockerAvailability_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ProductLockerAvailability_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ProductLockerAvailability_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var ProductLockerAvailability_ref = (0,config["default"])(), ProductLockerAvailability_publicRuntimeConfig = ProductLockerAvailability_ref.publicRuntimeConfig, ProductLockerAvailability_websiteName = ProductLockerAvailability_publicRuntimeConfig.settings.websiteName;
var ProductLockerAvailability_isBricoStore = ProductLockerAvailability_websiteName === "bricostore";
var ProductLockerAvailability = function(param) {
    var user = param.user, openedModal = param.openedModal, lockers = param.lockers;
    var ref2 = (0,react.useState)(true), isLoading = ref2[0], setIsLoading = ref2[1];
    var ref1 = (0,react.useState)(null), selectedLocker = ref1[0], setSelectedLocker = ref1[1];
    var customer = user.customer, favouriteLockerId = user.favouriteLockerId;
    var selectedLockerId = (customer === null || customer === void 0 ? void 0 : customer.locker_id) || favouriteLockerId || clientStore/* localClientStore.get */.C.get("favourite_locker_id");
    (0,react.useEffect)(function() {
        var getLockerById = function() {
            var _ref = ProductLockerAvailability_asyncToGenerator(runtime_default().mark(function _callee() {
                var lockerFromList, response1;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!isLoading) {
                                setIsLoading(true);
                            }
                            lockerFromList = lockers.length > 0 && lockers.find(function(locker) {
                                return locker.id === selectedLockerId;
                            });
                            if (!lockerFromList) {
                                _ctx.next = 6;
                                break;
                            }
                            {
                                setSelectedLocker(lockerFromList);
                                setIsLoading(false);
                            }
                            _ctx.next = 10;
                            break;
                        case 6:
                            _ctx.next = 8;
                            return (0,api_helpers/* makeApiCall */.Vo)({
                                apiArgs: [
                                    selectedLockerId
                                ],
                                apiCall: api/* getLockerbyIdApi */.lEP,
                                formatResponse: function(response) {
                                    return response.data.data.locker;
                                }
                            });
                        case 8:
                            response1 = _ctx.sent;
                            if (response1) {
                                setSelectedLocker(response1);
                            }
                        case 10:
                            setIsLoading(false);
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function getLockerById() {
                return _ref.apply(this, arguments);
            };
        }();
        if (selectedLockerId && !selectedLocker || selectedLockerId && selectedLocker && selectedLocker.id !== selectedLockerId) {
            getLockerById();
        } else {
            setSelectedLocker(null);
            setIsLoading(false);
        }
    }, [
        selectedLockerId
    ]);
    if (isLoading) return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("py-[40px] px-[20px]", {
            "bg-[#FAFAFA]": !ProductLockerAvailability_isBricoStore,
            "border rounded-[4px] border-gray-light": ProductLockerAvailability_isBricoStore
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {
            hasMarginBottom: false
        })
    }));
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("p-[16px] rounded-[4px]", {
            "bg-[#FAFAFA]": !ProductLockerAvailability_isBricoStore,
            "border border-gray-light": ProductLockerAvailability_isBricoStore
        }),
        children: [
            selectedLocker ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductLockerAvailability_UserWithLocker, {
                selectedLocker: selectedLocker
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductLockerAvailability_UserWithoutLocker, {}),
            openedModal === constants/* PRODUCT_PAGE_MODAL_LOCKERS_MAP_ID */.AR && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalErrorBoundary/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LockersMapWithFiltersModal/* default */.Z, {
                    mapId: constants/* PRODUCT_PAGE_LOCKERS_MAP_ID */.w0,
                    modalId: constants/* PRODUCT_PAGE_MODAL_LOCKERS_MAP_ID */.AR
                })
            })
        ]
    }));
};
/* harmony default export */ var ProductPage_ProductLockerAvailability = ((0,es/* connect */.$j)(function(state) {
    return {
        user: state.user,
        openedModal: state.app.modal,
        lockers: state.stores.lockers
    };
})(ProductLockerAvailability));

// EXTERNAL MODULE: ./node_modules/date-fns/esm/add/index.js
var add = __webpack_require__(29422);
// EXTERNAL MODULE: ./components/Icons/DeliveryIcon.js
var DeliveryIcon = __webpack_require__(22202);
;// CONCATENATED MODULE: ./components/Icons/Lockers/LockerIcon.js

var LockerIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? "16" : _width, _height = param.height, height = _height === void 0 ? "16" : _height;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M15 1H1v1h14V1Zm0 13H1v1h14v-1ZM7 5H2v1h5V5Zm7 0H8v1h6V5ZM7 9H2v1h5V9Zm7 0H8v1h6V9ZM4 3H3v1h1V3Zm6 0H9v1h1V3ZM4 7H3v1h1V7Zm6 5H9v1h1v-1Zm-6 0H3v1h1v-1ZM2 2H1v12h1V2Zm13 0h-1v12h1V2ZM8 2H7v12h1V2Z"
        })
    });
};
/* harmony default export */ var Lockers_LockerIcon = (LockerIcon);

;// CONCATENATED MODULE: ./components/Icons/Store.js


var Store_ref = (0,config["default"])(), Store_publicRuntimeConfig = Store_ref.publicRuntimeConfig, Store_websiteName = Store_publicRuntimeConfig.settings.websiteName;
var Store = function(param) {
    var _width = param.width, width = _width === void 0 ? "16px" : _width, _height = param.height, height = _height === void 0 ? "16px" : _height;
    return Store_websiteName === "bricostore" ? // Material Design "storefront" (24x24, Apache-2.0). Color via currentColor.
    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M21.9 8.89l-1.05-4.37c-.22-.9-1-1.52-1.91-1.52H5.05c-.9 0-1.69.63-1.9 1.52L2.1 8.89c-.24 1.02-.02 2.06.62 2.88.08.11.19.19.28.29V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6.94c.09-.09.2-.18.28-.28.64-.82.87-1.87.62-2.89Zm-2.99-3.9 1.05 4.37c.1.42.01.84-.25 1.17-.14.18-.44.47-.94.47-.61 0-1.14-.49-1.21-1.14L16.98 5l1.93-.01ZM13 5h1.96l.54 4.52c.05.39-.07.78-.33 1.07-.22.26-.54.41-.95.41-.67 0-1.22-.59-1.22-1.31V5ZM8.49 9.52 9.04 5H11v4.69c0 .72-.55 1.31-1.29 1.31-.34 0-.65-.15-.89-.41-.25-.29-.37-.68-.33-1.07Zm-4.4-.16L5.09 5h1.97l-.65 5.4c-.09.65-.62 1.14-1.23 1.14-.5 0-.8-.29-.94-.47-.26-.33-.35-.75-.25-1.17ZM5 19v-6.03c.08.01.15.03.23.03.87 0 1.66-.36 2.24-.95.6.6 1.4.95 2.31.95.87 0 1.65-.36 2.22-.93.58.57 1.37.93 2.24.93.85 0 1.65-.35 2.25-.95.58.59 1.37.95 2.24.95.08 0 .15-.02.23-.03V19H5Z"
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "m15 5.34-1-3a.5.5 0 0 0-.5-.34h-11a.5.5 0 0 0-.5.34l-1 3V8.5a.5.5 0 0 0 .5.5H2v5h1V9h3v5h8V9h.5a.5.5 0 0 0 .5-.5V5.34ZM13 13H7V9h6v4Zm1-5h-2V6h-1v2H8.5V6h-1v2H5V6H4v2H2V5.58L2.86 3h10.28L14 5.58V8Z"
        })
    });
};
/* harmony default export */ var Icons_Store = (Store);

;// CONCATENATED MODULE: ./components/ProductPage/ProductPageShipping.js








function ProductPageShipping_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ProductPageShipping_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ProductPageShipping_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ProductPageShipping_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ProductPageShipping_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = ProductPageShipping_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ProductPageShipping_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ProductPageShipping_slicedToArray(arr, i) {
    return ProductPageShipping_arrayWithHoles(arr) || ProductPageShipping_iterableToArrayLimit(arr, i) || ProductPageShipping_unsupportedIterableToArray(arr, i) || ProductPageShipping_nonIterableRest();
}
function ProductPageShipping_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ProductPageShipping_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ProductPageShipping_arrayLikeToArray(o, minLen);
}
var ProductPageShipping_ref = (0,config["default"])(), ProductPageShipping_publicRuntimeConfig = ProductPageShipping_ref.publicRuntimeConfig, ProductPageShipping_websiteName = ProductPageShipping_publicRuntimeConfig.settings.websiteName;
var ProductPageShipping_isBricoStore = ProductPageShipping_websiteName === "bricostore";
var deliveryPointClass = ProductPageShipping_isBricoStore ? "text-orange capitalize" : "text-[#1D4ED8] capitalize";
var deliveryEstimateClass = ProductPageShipping_isBricoStore ? "text-green" : "text-[#16A34A]";
var deliveryMethodInfo = {
    home: {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryIcon/* default */.Z, {}),
        name: "Livrare"
    },
    locker: {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Lockers_LockerIcon, {}),
        name: "Locker"
    },
    ship_to_store: {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Store, {}),
        name: "La magazin"
    }
};
var formatShippingMonth = function(date) {
    return date.toLocaleString("ro-RO", {
        month: "short"
    }).replace(".", "").replace(/^./, function(c) {
        return c.toUpperCase();
    });
};
var formatShippingDate = function(date) {
    return date.toLocaleDateString("ro-RO", {
        month: "long",
        day: "numeric"
    }).replace(/\.$/, "").replace(/\b[a-z]/, function(c) {
        return c.toUpperCase();
    });
};
var getShippingEstimateDays = function(shippingOption) {
    var estimated_delivery_days = shippingOption.estimated_delivery_days, estimated_delivery = shippingOption.estimated_delivery;
    if (estimated_delivery_days && estimated_delivery_days.toString() === "1") {
        return "Maine";
    } else if (Number(estimated_delivery_days) > 1) {
        var today = new Date();
        var shippingDate = (0,add/* default */.Z)(today, {
            days: Number(estimated_delivery_days)
        });
        return formatShippingDate(shippingDate);
    }
    if (estimated_delivery && estimated_delivery.length) {
        var ref1 = ProductPageShipping_slicedToArray(estimated_delivery.split("-").map(Number), 2), minDays = ref1[0], maxDays = ref1[1];
        var today1 = new Date();
        var d1 = (0,add/* default */.Z)(today1, {
            days: minDays
        });
        var d2 = (0,add/* default */.Z)(today1, {
            days: maxDays
        });
        var day1 = d1.getDate();
        var day2 = d2.getDate();
        var month1 = formatShippingMonth(d1);
        var month2 = formatShippingMonth(d2);
        if (month1 === month2) {
            return "".concat(day1, "-").concat(day2, " ").concat(month1);
        }
        return "".concat(day1, " ").concat(month1, " - ").concat(day2, " ").concat(month2);
    }
};
// The locker fee is flat, so "de la" would wrongly suggest the price can still grow
var getShippingCostLabel = function(deliveryMode, estimatedTax) {
    return deliveryMode === "locker" ? "- ".concat((0,helpers/* formatPrice */.T4)(estimatedTax), " lei") : "- de la ".concat((0,helpers/* formatPrice */.T4)(estimatedTax), " lei");
};
var ProductPageShipping = function(param) {
    var shippingInfo = param.shippingInfo, hasFreeShippingPromo = param.hasFreeShippingPromo;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("ul", {
        className: "space-y-[4px]",
        children: sortBy_default()(shippingInfo, "estimated_tax").map(function(_param) {
            var delivery_mode = _param.delivery_mode, delivery_point = _param.delivery_point, estimated_tax = _param.estimated_tax, carrier = _param.carrier, rest = ProductPageShipping_objectWithoutProperties(_param, [
                "delivery_mode",
                "delivery_point",
                "estimated_tax",
                "carrier"
            ]);
            if (!deliveryMethodInfo[delivery_mode]) {
                return null;
            }
            var normalizedDeliveryPointName = (delivery_point === null || delivery_point === void 0 ? void 0 : delivery_point.name) && delivery_point.name.toLowerCase();
            var shippingEstimateLabel = getShippingEstimateDays(rest);
            var isNextDay = shippingEstimateLabel === "Maine";
            var isFreeShipping = Number(estimated_tax) === 0 || hasFreeShippingPromo;
            var isALD = (carrier === null || carrier === void 0 ? void 0 : carrier.toLowerCase()) === "altex";
            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                className: "flex items-center space-x-2 text-[14px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(ProductPageShipping_isBricoStore ? "bg-orange-light text-ironBlack" : "bg-[#F0FDF4]", " p-[4px] rounded-full max-w-fit"),
                        children: deliveryMethodInfo[delivery_mode].icon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-[#737373]",
                        children: [
                            isALD ? "Livrare estimata" : deliveryMethodInfo[delivery_mode].name,
                            ": ",
                            isNextDay && isFreeShipping && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "font-medium text-black",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: deliveryEstimateClass,
                                        children: shippingEstimateLabel
                                    }),
                                    " ",
                                    normalizedDeliveryPointName && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            "in",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: deliveryPointClass,
                                                children: [
                                                    normalizedDeliveryPointName,
                                                    " "
                                                ]
                                            }),
                                            "-"
                                        ]
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: deliveryEstimateClass,
                                        children: "gratuit"
                                    })
                                ]
                            }),
                            isNextDay && !isFreeShipping && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "font-medium text-black",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: deliveryEstimateClass,
                                        children: shippingEstimateLabel
                                    }),
                                    " ",
                                    normalizedDeliveryPointName && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            "in",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: deliveryPointClass,
                                                children: normalizedDeliveryPointName
                                            })
                                        ]
                                    }),
                                    " ",
                                    estimated_tax && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: getShippingCostLabel(delivery_mode, estimated_tax)
                                    })
                                ]
                            }),
                            !isNextDay && isFreeShipping && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "font-medium text-black",
                                children: [
                                    shippingEstimateLabel,
                                    " ",
                                    normalizedDeliveryPointName && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            "in",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: deliveryPointClass,
                                                children: [
                                                    normalizedDeliveryPointName,
                                                    " -"
                                                ]
                                            })
                                        ]
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: deliveryEstimateClass,
                                        children: "gratuit"
                                    })
                                ]
                            }),
                            !isNextDay && !isFreeShipping && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "font-medium text-black",
                                children: [
                                    shippingEstimateLabel,
                                    " ",
                                    normalizedDeliveryPointName && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            "in",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: deliveryPointClass,
                                                children: normalizedDeliveryPointName
                                            })
                                        ]
                                    }),
                                    " ",
                                    estimated_tax && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: getShippingCostLabel(delivery_mode, estimated_tax)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, delivery_mode));
        })
    });
};
/* harmony default export */ var ProductPage_ProductPageShipping = (ProductPageShipping);

// EXTERNAL MODULE: ./components/CredexCashbackBanner.js
var CredexCashbackBanner = __webpack_require__(13812);
// EXTERNAL MODULE: ./lib/replaceDiacriticsWithBaseCharacter.js
var replaceDiacriticsWithBaseCharacter = __webpack_require__(59982);
;// CONCATENATED MODULE: ./containers/Catalog/View.js









































































function View_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function View_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return View_arrayLikeToArray(arr);
}
function View_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function View_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                View_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                View_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function View_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function View_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function View_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function View_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            View_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function View_toConsumableArray(arr) {
    return View_arrayWithoutHoles(arr) || View_iterableToArray(arr) || View_unsupportedIterableToArray(arr) || View_nonIterableSpread();
}
function View_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return View_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return View_arrayLikeToArray(o, minLen);
}
var View_ref = (0,config["default"])(), View_publicRuntimeConfig = View_ref.publicRuntimeConfig, View_settings = View_publicRuntimeConfig.settings, oney = View_publicRuntimeConfig.oney, credex = View_publicRuntimeConfig.credex;
var CatalogView = function(param1) {
    var currentProduct = param1.currentProduct, addModal1 = param1.addModal, user = param1.user, trackProductClick1 = param1.trackProductClick, addProductToProductNavigationHistory1 = param1.addProductToProductNavigationHistory, cart = param1.cart, apiCall1 = param1.apiCall, credexConfig = param1.credexConfig, getAddresses1 = param1.getAddresses;
    var ref47, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32;
    var router = (0,next_router.useRouter)();
    var galleryRef = (0,react.useRef)();
    var addToCartRef = (0,react.useRef)();
    var bundlesRef = (0,react.useRef)();
    var ref33 = (0,react.useState)([]), openedAccordionItems = ref33[0], setOpenedAccordionItems = ref33[1];
    var ref34 = (0,react.useState)(""), activeSection = ref34[0], setActiveSection = ref34[1];
    var ref35 = (0,react.useState)({}), activeServices = ref35[0], setActiveServices = ref35[1];
    var ref36 = (0,react.useState)(null), westacoData = ref36[0], setWestacoData = ref36[1];
    var ref37 = (0,react.useState)({}), westacoValid = ref37[0], setWestacoValid = ref37[1];
    var ref38 = (0,react.useState)(), productRecommendations = ref38[0], setProductRecommendations = ref38[1];
    var ref39 = (0,react.useState)({
        tax_total: null,
        sgr_tax: null
    }), shippingTax = ref39[0], setShippingTax = ref39[1];
    var ref40 = (0,react.useState)(null), productBundles = ref40[0], setProductBundles = ref40[1];
    var ref41 = (0,react.useState)(), loanSimulation = ref41[0], setLoanSimulation = ref41[1];
    var ref42 = (0,react.useState)(false), showBenefits = ref42[0], setShowBenefits = ref42[1];
    var isStickyHeaderVisible = useOnScreen({
        ref: galleryRef,
        rootMargin: "-300px"
    });
    var isStickyFooterVisible = useOnScreen({
        ref: addToCartRef,
        rootMargin: "0px"
    });
    var product1 = currentProduct.product;
    var customer = user.customer, favouriteLockerId = user.favouriteLockerId;
    var selectedLockerId = (customer === null || customer === void 0 ? void 0 : customer.locker_id) || favouriteLockerId || clientStore/* localClientStore.get */.C.get("favourite_locker_id");
    var shippingInfo = shippingTax.shipping_info, sgrTax = shippingTax.sgr_tax, hasFreeShippingPromo = shippingTax.has_freeshipping_promo;
    var ref43 = (0,helpers/* productHelper */.gU)(product1), isSaleable = ref43.isSaleable, hasStorePickup = ref43.hasStorePickup, isResealed = ref43.isResealed, hasResealed = ref43.hasResealed, isVirtualService = ref43.isVirtualService, isEol = ref43.isEol, isVisible = ref43.isVisible, isWestaco = ref43.isWestaco, isLocalSeller = ref43.isLocalSeller, mainOffer = ref43.mainOffer, hasOtherOffers = ref43.hasOtherOffers, otherOffers = ref43.otherOffers, hasPriceUnit = ref43.hasPriceUnit, isVirtualProduct = ref43.isVirtualProduct, getWarranty = ref43.getWarranty, hasWarranty = ref43.hasWarranty, productNumber = ref43.productNumber, hasPricePerFactor = ref43.hasPricePerFactor;
    var vivinoId = (ref47 = (0,helpers/* getProductAttributeByCode */.mo)(product1, "vivino_id")) === null || ref47 === void 0 ? void 0 : ref47.value;
    var ref44;
    var reviewsCount = (ref44 = (ref1 = currentProduct.reviews_summary) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.items) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.reviews) === null || ref4 === void 0 ? void 0 : ref4.value) !== null && ref44 !== void 0 ? ref44 : 0;
    var ref45;
    var reviewsScore = (ref45 = (ref5 = currentProduct.reviews_summary) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.items) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.reviews) === null || ref8 === void 0 ? void 0 : ref8.total) !== null && ref45 !== void 0 ? ref45 : 0;
    var ref46;
    var questionsCount = (ref46 = (ref9 = currentProduct.reviews_summary) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.items) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[0]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.questions) === null || ref12 === void 0 ? void 0 : ref12.total) !== null && ref46 !== void 0 ? ref46 : 0;
    var reviewAverage = Math.round((reviewsScore / reviewsCount + Number.EPSILON) * 100) / 100;
    var mainOfferSellerId = mainOffer === null || mainOffer === void 0 ? void 0 : (ref13 = mainOffer.seller) === null || ref13 === void 0 ? void 0 : ref13.id;
    var getIsInSpecialCampaign = function(sellerId, product) {
        var ref48;
        return sellerId && (product === null || product === void 0 ? void 0 : (ref48 = product.in_special_campaign_sellers) === null || ref48 === void 0 ? void 0 : ref48.length) > 0 && product.in_special_campaign_sellers.includes(sellerId);
    };
    var isInSpecialCampaign = getIsInSpecialCampaign(mainOfferSellerId, product1);
    var getLabelsBySellerId = function(sellerId, product) {
        var ref49;
        if (!(product === null || product === void 0 ? void 0 : (ref49 = product.label_actions_serialized) === null || ref49 === void 0 ? void 0 : ref49[0])) {
            return [];
        }
        return product.label_actions_serialized.filter(function(label) {
            return label === null || label === void 0 ? void 0 : label.seller_ids.includes(sellerId);
        });
    };
    var labels = getLabelsBySellerId(mainOfferSellerId, product1);
    var hasLabels = labels === null || labels === void 0 ? void 0 : labels[0];
    var hasBenefits = (labels === null || labels === void 0 ? void 0 : labels.length) > 0;
    var hasCredexUserPromo = (customer === null || customer === void 0 ? void 0 : customer.has_promo) === "CC12RATE";
    var _product_links;
    var hasServices = (isSaleable || hasStorePickup) && isLocalSeller && Object.keys((_product_links = product1.product_links) !== null && _product_links !== void 0 ? _product_links : {}).length > 0;
    var hasFinancingOptions = Boolean(product1.installments_price > 0 && (credex.isEnabled && !isVirtualService || oney.isEnabled));
    var hasGreenTax = !isEol && isVisible && isLocalSeller && (mainOffer === null || mainOffer === void 0 ? void 0 : (ref14 = mainOffer.price) === null || ref14 === void 0 ? void 0 : ref14.green_tax) > 0;
    var hasBundles = (productBundles === null || productBundles === void 0 ? void 0 : (ref15 = productBundles.bundles) === null || ref15 === void 0 ? void 0 : ref15.length) > 0;
    var hasProductVariations = ((ref16 = product1.configurable_options) === null || ref16 === void 0 ? void 0 : ref16.length) > 0;
    var hasProductAccesories = (productRecommendations === null || productRecommendations === void 0 ? void 0 : (ref17 = productRecommendations.cross_sell_tabs) === null || ref17 === void 0 ? void 0 : ref17.length) > 0;
    var warranty = getWarranty();
    var productDescriptionCMSBlocks = (ref18 = product1.label_actions_serialized) === null || ref18 === void 0 ? void 0 : (ref19 = ref18[0]) === null || ref19 === void 0 ? void 0 : ref19.cmsBLock;
    var hasEnergyClass = Boolean(product1.energy_class);
    var hasEnergyLabel = product1.energy_class && product1.energy_class_image && !product1.energy_class_image.includes("no_selection");
    var installmentValue = mainOffer && credexConfig && Number(mainOffer.price.selling_price / credexConfig.promoRates).toFixed(2);
    var isLockerEligible = Boolean(product1.locker_eligible) && !(isWestaco || isVirtualProduct || isVirtualService);
    var serviceClick = function(param) {
        var serviceKey = param.serviceKey, sku = param.sku, additional_data = param.additional_data;
        if (activeServices[serviceKey] && activeServices[serviceKey].sku === sku) {
            var ref50;
            var current_additional_data = (ref50 = activeServices[serviceKey]) === null || ref50 === void 0 ? void 0 : ref50.additional_data;
            if (additional_data === null || additional_data === void 0 ? void 0 : additional_data.childSku) {
                if ((current_additional_data === null || current_additional_data === void 0 ? void 0 : current_additional_data.childSku) && (current_additional_data === null || current_additional_data === void 0 ? void 0 : current_additional_data.childSku) === additional_data.childSku) {
                    var tempActiveServices = View_objectSpread({}, activeServices);
                    delete tempActiveServices[serviceKey].additional_data.childSku;
                    setActiveServices(tempActiveServices);
                } else {
                    var tempActiveServices1 = View_objectSpread({}, activeServices, View_defineProperty({}, serviceKey, {
                        sku: sku,
                        additional_data: additional_data
                    }));
                    setActiveServices(tempActiveServices1);
                }
            } else {
                var tempActiveServices2 = View_objectSpread({}, activeServices);
                delete tempActiveServices2[serviceKey];
                setActiveServices(tempActiveServices2);
            }
        } else {
            var tempActiveServices3 = View_objectSpread({}, activeServices, View_defineProperty({}, serviceKey, {
                sku: sku,
                additional_data: additional_data
            }));
            setActiveServices(tempActiveServices3);
        }
    };
    var removeService = function(param) {
        var key = param.key, child = param.child;
        var tempActiveServices = View_objectSpread({}, activeServices);
        if (child) {
            delete tempActiveServices[key].additional_data;
        } else {
            delete tempActiveServices[key];
        }
        setActiveServices(tempActiveServices);
    };
    var toggleBenefits = function(e) {
        e.preventDefault();
        setShowBenefits(function(prev) {
            return !prev;
        });
    };
    var westacoFormCb = function(data) {
        setWestacoData(data.values);
        setWestacoValid(Object.keys(data.errors).length ? false : true);
    };
    var handleProductClick = function(data, options) {
        // Track product click
        trackProductClick1(data, options);
    };
    var handleEnergyClassClick = function(event) {
        event.preventDefault();
        addModal1("productEnergyLabel");
    };
    var getProductLoanSimulation = function() {
        var _ref = View_asyncToGenerator(runtime_default().mark(function _callee() {
            var methods, ref51, response1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        methods = [];
                        if (oney.isEnabled && oney.showInfoInProductPage) methods.push("oney_facilypay");
                        if (isSaleable && !isVirtualService && mainOffer) methods.push("credex");
                        if (!(!isEol && isVisible && mainOffer)) {
                            _ctx.next = 9;
                            break;
                        }
                        ;
                        _ctx.next = 7;
                        return apiCall1({
                            apiCall: api/* getLoanSimulationApi */.caK,
                            apiArgs: [
                                {
                                    amount: (ref51 = mainOffer.price) === null || ref51 === void 0 ? void 0 : ref51.selling_price,
                                    method: methods,
                                    sku: product1.sku
                                }, 
                            ],
                            formatResponse: function(response) {
                                return response.data.data;
                            },
                            returnResponse: true
                        });
                    case 7:
                        response1 = _ctx.sent;
                        if (response1 && !response1.error) {
                            setLoanSimulation(response1);
                        }
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getProductLoanSimulation() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleGTMProductImpressions = function(productData) {
        var ref55, ref52, ref53, ref54;
        if (((ref55 = productData.cross_sell_tabs) === null || ref55 === void 0 ? void 0 : ref55.length) > 0) {
            productData.cross_sell_tabs.forEach(function(tab) {
                var ref56;
                if ((tab === null || tab === void 0 ? void 0 : (ref56 = tab.products) === null || ref56 === void 0 ? void 0 : ref56.length) > 0) {
                    var newProductFormat = tab.products.map(function(product, index) {
                        return View_objectSpread({}, product, {
                            index: index + 1,
                            item_list_name: "accesorii"
                        });
                    });
                    (0,GTMHelper/* setGTMProductsImpressions */.SS)(newProductFormat);
                }
            });
        }
        if (((ref52 = productData.up_sell) === null || ref52 === void 0 ? void 0 : ref52.length) > 0) {
            var newProductFormat3 = productData.up_sell.map(function(product, index) {
                return View_objectSpread({}, product, {
                    index: index + 1,
                    item_list_name: "produse similare"
                });
            });
            (0,GTMHelper/* setGTMProductsImpressions */.SS)(newProductFormat3);
        }
        if (((ref53 = productData.also_bought) === null || ref53 === void 0 ? void 0 : ref53.length) > 0) {
            var newProductFormat1 = productData.also_bought.map(function(product, index) {
                return View_objectSpread({}, product, {
                    index: index + 1,
                    item_list_name: "alti vizitatori au cumparat"
                });
            });
            (0,GTMHelper/* setGTMProductsImpressions */.SS)(newProductFormat1);
        }
        if (((ref54 = productData.bought_together) === null || ref54 === void 0 ? void 0 : ref54.length) > 0) {
            var newProductFormat2 = productData.bought_together.map(function(product, index) {
                return View_objectSpread({}, product, {
                    index: index + 1,
                    item_list_name: "cumparate frecvent impreuna"
                });
            });
            (0,GTMHelper/* setGTMProductsImpressions */.SS)(newProductFormat2);
        }
    };
    var setSection = function(section) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _scroll = options.scroll, scroll = _scroll === void 0 ? false : _scroll, _hashChange = options.hashChange, hashChange = _hashChange === void 0 ? false : _hashChange, _expand = options.expand, expand = _expand === void 0 ? false : _expand;
        if (scroll) {
            var sectionElement = document.getElementById(section);
            if (sectionElement) {
                var newOpenedAccordionItems = View_toConsumableArray(openedAccordionItems).concat([
                    section
                ]);
                // Close description before scrolling because it can contain
                // dynamic content
                if (section !== "description" && openedAccordionItems.includes("description")) {
                    newOpenedAccordionItems = newOpenedAccordionItems.filter(function(item) {
                        return item !== "description";
                    });
                    setOpenedAccordionItems(newOpenedAccordionItems);
                    // Scroll after animations are done
                    setTimeout(function() {
                        var stickyHeaderOffset = innerWidth >= 640 ? 120 + 20 : 0;
                        var offsetPosition = sectionElement.getBoundingClientRect().top + window.scrollY - stickyHeaderOffset;
                        window.scrollTo({
                            top: offsetPosition,
                            behavior: "smooth"
                        });
                    }, 350);
                } else {
                    setOpenedAccordionItems(newOpenedAccordionItems);
                    var stickyHeaderOffset1 = innerWidth >= 640 ? 120 + 20 : 0;
                    var offsetPosition1 = sectionElement.getBoundingClientRect().top + window.scrollY - stickyHeaderOffset1;
                    window.scrollTo({
                        top: offsetPosition1,
                        behavior: "smooth"
                    });
                }
            }
        } else {
            if (expand) {
                if (!openedAccordionItems.includes(section)) {
                    setOpenedAccordionItems(View_toConsumableArray(openedAccordionItems).concat([
                        section
                    ]));
                }
            } else {
                setOpenedAccordionItems(openedAccordionItems.filter(function(item) {
                    return item !== section;
                }));
            }
        }
        if (hashChange) {
            // Change hash without re-render or scroll
            history.replaceState({}, "", "#".concat(expand ? section : ""));
        }
        setActiveSection(section);
    };
    var onSectionClick = function(section) {
        setSection(section, {
            scroll: true,
            hashChange: true,
            expand: true
        });
        if (section === "reviews") {
            (0,GTMHelper/* setGTMProductOpenReviewsSection */.VW)(product1.sku);
        }
    };
    var onAccordionItemToggle = function(param) {
        var item = param.item, expanded = param.expanded;
        return setSection(item, {
            scroll: false,
            hashChange: true,
            expand: expanded
        });
    };
    var onHeaderRatingsClick = function(event) {
        event.preventDefault();
        setSection("reviews", {
            scroll: true,
            hashChange: true,
            expand: true
        });
        (0,GTMHelper/* setGTMProductOpenReviewsSection */.VW)(product1.sku);
    };
    var onResealedClick = function(event) {
        event.preventDefault();
        setSection("resigilate", {
            scroll: true,
            hashChange: true,
            expand: true
        });
    };
    (0,react.useEffect)(function() {
        var getShippingTax = function() {
            var _ref = View_asyncToGenerator(runtime_default().mark(function _callee() {
                var ref64, ref57, ref58, ref59, ref60, ref61, ref62, attributes, city, region, ref63, defaultShippingAddress, fallbackAddress, addresses, _greutate_kg_global, _televizoare_dimensiune_ecran, response2;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            ;
                            attributes = (ref62 = (ref64 = product1.info) === null || ref64 === void 0 ? void 0 : (ref57 = ref64.groups) === null || ref57 === void 0 ? void 0 : ref57.reduce(function(attributesAcc, group) {
                                var ref65;
                                return View_objectSpread({}, attributesAcc, (ref65 = group.attributes) === null || ref65 === void 0 ? void 0 : ref65.reduce(function(groupAttributesAcc, attribute) {
                                    return attribute.attribute_code ? View_objectSpread({}, groupAttributesAcc, View_defineProperty({}, attribute.attribute_code, attribute.value)) : groupAttributesAcc;
                                }, {}));
                            }, {})) !== null && ref62 !== void 0 ? ref62 : {};
                            city = "Bucuresti";
                            region = "Bucuresti";
                            if (!((cart === null || cart === void 0 ? void 0 : (ref58 = cart.miniCart) === null || ref58 === void 0 ? void 0 : (ref59 = ref58.shipping_address) === null || ref59 === void 0 ? void 0 : ref59.city) && (cart === null || cart === void 0 ? void 0 : (ref60 = cart.miniCart) === null || ref60 === void 0 ? void 0 : (ref61 = ref60.shipping_address) === null || ref61 === void 0 ? void 0 : ref61.region))) {
                                _ctx.next = 9;
                                break;
                            }
                            {
                                city = cart.miniCart.shipping_address.city;
                                region = cart.miniCart.shipping_address.region;
                            }
                            _ctx.next = 22;
                            break;
                        case 9:
                            if (!user.isLoggedIn) {
                                _ctx.next = 22;
                                break;
                            }
                            ;
                            ;
                            ;
                            if (!(((ref63 = user.addresses) === null || ref63 === void 0 ? void 0 : ref63.length) > 0)) {
                                _ctx.next = 17;
                                break;
                            }
                            {
                                defaultShippingAddress = user.addresses.find(function(address) {
                                    return address.default_shipping;
                                });
                                fallbackAddress = user.addresses.find(function(address) {
                                    return address.city && address.region;
                                });
                            }
                            _ctx.next = 21;
                            break;
                        case 17:
                            _ctx.next = 19;
                            return getAddresses1();
                        case 19:
                            addresses = _ctx.sent;
                            if (addresses && addresses.length) {
                                defaultShippingAddress = addresses.find(function(address) {
                                    return address.default_shipping;
                                });
                                fallbackAddress = addresses.find(function(address) {
                                    return address.city && address.region;
                                });
                            }
                        case 21:
                            if (defaultShippingAddress || fallbackAddress) {
                                if ((defaultShippingAddress === null || defaultShippingAddress === void 0 ? void 0 : defaultShippingAddress.city) || (fallbackAddress === null || fallbackAddress === void 0 ? void 0 : fallbackAddress.city)) {
                                    city = (defaultShippingAddress === null || defaultShippingAddress === void 0 ? void 0 : defaultShippingAddress.city) || fallbackAddress.city;
                                } else if ((defaultShippingAddress === null || defaultShippingAddress === void 0 ? void 0 : defaultShippingAddress.region) || (fallbackAddress === null || fallbackAddress === void 0 ? void 0 : fallbackAddress.region)) {
                                    region = (defaultShippingAddress === null || defaultShippingAddress === void 0 ? void 0 : defaultShippingAddress.region) || fallbackAddress.region;
                                }
                            }
                        case 22:
                            ;
                            _ctx.next = 25;
                            return apiCall1({
                                apiArgs: [
                                    View_objectSpread({
                                        sku: product1.sku,
                                        seller_id: mainOffer.seller.id,
                                        selling_price: mainOffer.price.selling_price,
                                        attribute_set_id: product1.attribute_set_id,
                                        // TODO: Some products don't have brands,
                                        // we should discuss with backend and see what payload
                                        // we should send
                                        brand: product1.brand,
                                        weight: (_greutate_kg_global = attributes.greutate_kg_global) !== null && _greutate_kg_global !== void 0 ? _greutate_kg_global : 0,
                                        city: (0,replaceDiacriticsWithBaseCharacter/* default */.Z)(city),
                                        region: (0,replaceDiacriticsWithBaseCharacter/* default */.Z)(region),
                                        televizoare_dimensiune_ecran: (_televizoare_dimensiune_ecran = attributes.televizoare_dimensiune_ecran) !== null && _televizoare_dimensiune_ecran !== void 0 ? _televizoare_dimensiune_ecran : 0
                                    }, attributes.bauturi_cantitate_bax && {
                                        get_sgr: 1
                                    }, isLockerEligible && selectedLockerId && {
                                        locker_id: selectedLockerId
                                    }), 
                                ],
                                apiCall: api/* getProductShippingCostApi */.l$G,
                                formatResponse: function(response) {
                                    return response.data;
                                },
                                returnResponse: true
                            });
                        case 25:
                            response2 = _ctx.sent;
                            if (response2) {
                                setShippingTax(response2);
                            }
                        case 27:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function getShippingTax() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!cart.miniCartLoading && mainOffer && isSaleable && !isVirtualProduct && !isWestaco) {
            getShippingTax();
        }
    }, [
        apiCall1,
        cart.miniCartLoading,
        product1,
        mainOffer,
        isSaleable,
        isVirtualProduct,
        isWestaco,
        selectedLockerId, 
    ]);
    (0,react.useEffect)(function() {
        var init = function() {
            var _ref = View_asyncToGenerator(runtime_default().mark(function _callee() {
                var hash, section, sectionElement;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            addProductToProductNavigationHistory1({
                                id: product1.id,
                                sku: product1.sku,
                                name: product1.name,
                                image: (0,helpers/* resizeImage */.tg)(product1.small_image, "300x300"),
                                route: "".concat(View_settings.baseUrl, "/").concat(product1.url_key, "/cpd/").concat(product1.sku, "/"),
                                isNavigationHistory: true
                            });
                            hash = router.asPath.split("#")[1];
                            if (!(hasCredexUserPromo && !loanSimulation)) {
                                _ctx.next = 5;
                                break;
                            }
                            _ctx.next = 5;
                            return getProductLoanSimulation();
                        case 5:
                            if (hash) {
                                section = (0,helpers/* getSlug */.QF)(hash);
                                sectionElement = document.getElementById(section);
                                if (sectionElement) {
                                    setSection(section, {
                                        scroll: true,
                                        expand: true
                                    });
                                } else {
                                    setSection("description", {
                                        scroll: false,
                                        expand: true
                                    });
                                }
                            } else {
                                setSection("description", {
                                    scroll: false,
                                    expand: true
                                });
                            }
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function init() {
                return _ref.apply(this, arguments);
            };
        }();
        init();
    }, []);
    (0,react.useEffect)(function() {
        var getProductRecommendations = function() {
            var _ref = View_asyncToGenerator(runtime_default().mark(function _callee() {
                var response3;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return apiCall1({
                                apiArgs: [
                                    {
                                        sku: product1.sku
                                    }
                                ],
                                apiCall: api/* getProductRecommendationsApi */.Kyu,
                                formatResponse: function(response) {
                                    return response.data;
                                },
                                returnResponse: true
                            });
                        case 2:
                            response3 = _ctx.sent;
                            if (response3 === null || response3 === void 0 ? void 0 : response3.data) {
                                setProductRecommendations(response3.data);
                                handleGTMProductImpressions(response3.data);
                            }
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function getProductRecommendations() {
                return _ref.apply(this, arguments);
            };
        }();
        getProductRecommendations();
    }, []);
    (0,react.useEffect)(function() {
        var getProductBundles = function() {
            var _ref = View_asyncToGenerator(runtime_default().mark(function _callee() {
                var response4;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return apiCall1({
                                apiArgs: [
                                    {
                                        sku: product1.sku
                                    }
                                ],
                                apiCall: api/* getProductBundlesApi */.Yx5,
                                formatResponse: function(response) {
                                    return response.data;
                                },
                                returnResponse: true
                            });
                        case 2:
                            response4 = _ctx.sent;
                            if (response4 === null || response4 === void 0 ? void 0 : response4.data) {
                                setProductBundles(response4.data);
                            }
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function getProductBundles() {
                return _ref.apply(this, arguments);
            };
        }();
        if (View_settings.websiteName !== "bricostore") {
            getProductBundles();
        }
    }, []);
    // Scrollspy: auto-mark the section currently in view in the sticky nav (bricostore only,
    // to keep altex/mediagalaxy behavior unchanged).
    (0,react.useEffect)(function() {
        if (View_settings.websiteName !== "bricostore") return;
        if (typeof IntersectionObserver === "undefined") return;
        var sectionIds = [
            "oferte",
            "pachete",
            "resigilate",
            "accessories",
            "description",
            "additional",
            "reviews",
            "questions",
            "compare", 
        ];
        var elements = sectionIds.map(function(id) {
            return document.getElementById(id);
        }).filter(Boolean);
        if (!elements.length) return;
        var observer = new IntersectionObserver(function(entries) {
            // pick the intersecting section closest to the top of the active band
            var topMost = entries.filter(function(entry) {
                return entry.isIntersecting;
            }).sort(function(a, b) {
                return a.boundingClientRect.top - b.boundingClientRect.top;
            })[0];
            if (topMost) {
                setActiveSection(topMost.target.id);
            }
        }, // offset for the ~120px sticky header; a section is "current" once its
        // top passes just under the bar (top band ~140px..45% of viewport)
        {
            rootMargin: "-140px 0px -55% 0px",
            threshold: 0
        });
        elements.forEach(function(el) {
            return observer.observe(el);
        });
        return function() {
            return observer.disconnect();
        };
    }, [
        product1 === null || product1 === void 0 ? void 0 : product1.sku,
        hasOtherOffers,
        hasBundles,
        hasResealed,
        hasProductAccesories, 
    ]);
    var _sku, _sku1, _sku2, _description, _description_editor_object, _description1, _description_editor_object1, _sku3, _sku4, _sku5;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_ProductPageStickyHeader, {
                isVisible: isStickyHeaderVisible,
                product: product1,
                reviews: currentProduct.reviews_summary,
                sectionInView: View_settings.websiteName === "bricostore" ? activeSection : undefined,
                onSectionClick: onSectionClick,
                westacoData: westacoData,
                isWestacoDataValid: westacoValid,
                activeServices: activeServices,
                hasProductAccesories: hasProductAccesories,
                hasBundles: hasBundles
            }),
            !isEol && isVisible && (isSaleable || hasStorePickup) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fixed block md:hidden bottom-0 left-0 right-0 z-[900] bg-white px-[15px] pt-[10px] transition-transform ease-in-out ".concat(isStickyFooterVisible ? "translate-y-[66.8px]" : "translate-y-0"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_ProductPageStickyFooter, {
                    product: product1,
                    westacoData: westacoData,
                    isWestacoDataValid: westacoValid,
                    activeServices: activeServices
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_ProductBreadcrumbs, {
                breadcrumbs: currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.breadcrumbs,
                sku: product1.sku
            }),
            hasFreeShippingPromo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_FreeShippingPromoMessage, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-5 flex flex-col-reverse md:flex-col gap-[16px] md:gap-[0]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        as: "h1",
                        display: "h1",
                        font: "normal",
                        classesProp: "!text-[20px] md:!text-[24px] !leading-26 md:!leading-36",
                        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                isResealed && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Resigilat: "
                                }),
                                product1.name
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-wrap items-center mt-1 gap-2 md:gap-0",
                        children: !isWestaco && (reviewsCount > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_ProductPageHeaderRatings, {
                            reviewsCount: reviewsCount,
                            ratingSummary: reviewsScore,
                            productUrl: "/".concat(product1.url_key, "/cpd/").concat(product1.sku, "/"),
                            onClick: onHeaderRatingsClick
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Ratings_NoRatingsDataPlaceholder, {
                            onClick: onHeaderRatingsClick,
                            productUrl: "/".concat(product1.url_key, "/cpd/").concat(product1.sku, "/")
                        }))
                    })
                ]
            }),
            isInSpecialCampaign && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "".concat(View_settings.websiteStatics, "/images/oferta-de-black-friday.svg"),
                alt: "oferta de black friday",
                className: "w-[124px]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-start flex-col md:flex-row space-y-[16px] md:space-y-0 md:space-x-[48px] justify-center xl:justify-between mb-[32px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative md:sticky md:top-0 w-full md:overflow-hidden space-y-[16px] xl:max-w-[45%]",
                        ref: galleryRef,
                        id: "gallery",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "md:max-h-120",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProductMedia, {
                                    product: product1
                                })
                            }),
                            product1.brand_link && product1.brand_logo && product1.brand_name && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_ProductBrand, {
                                product: product1
                            }),
                            vivinoId && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute top-0 right-[10px] z-[1]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_VivinoWidget, {
                                    vivinoId: vivinoId
                                })
                            }),
                            hasLabels && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_ProductLabels, {
                                labels: labels[0]
                            }),
                            hasEnergyClass && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute right-0 top-2 z-10",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_ProductEnergyClass, {
                                            energyClass: product1.energy_class,
                                            isClickable: hasEnergyLabel,
                                            onClick: handleEnergyClassClick,
                                            width: "80px"
                                        })
                                    }),
                                    hasEnergyLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_ProductEnergyLabelModal, {
                                        productName: product1.name,
                                        labelPath: product1.energy_class_image
                                    })
                                ]
                            }),
                            (productDescriptionCMSBlocks === null || productDescriptionCMSBlocks === void 0 ? void 0 : (ref20 = productDescriptionCMSBlocks["altex_label/rule_action_type_cmsBlock"]) === null || ref20 === void 0 ? void 0 : ref20.content) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "px-4 md:px-10 md:mb-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProductLabelDescription, {
                                    cmsBlock: productDescriptionCMSBlocks["altex_label/rule_action_type_cmsBlock"].content
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full xl:max-w-[45%]",
                        children: [
                            isEol && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-2 w-full mb-3 lg:px-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                                    type: "info",
                                    showIcon: true,
                                    children: "Produsul nu mai face parte din catalogul magazinului."
                                })
                            }),
                            !isEol && !isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-2 w-full mb-3 lg:px-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                                    type: "info",
                                    showIcon: true,
                                    children: "Acest produs nu poate fi adaugat in cos individual."
                                })
                            }),
                            !isEol && isVisible && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "space-y-[16px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col md:flex-row gap-[16px]",
                                                children: [
                                                    mainOffer && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "lg:w-3/5 flex flex-col w-full",
                                                        children: [
                                                            isWestaco && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: "De la"
                                                            }),
                                                            product1.discount_type === "repositioning" && isSaleable && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_ProductLabel, {
                                                                label: "super pret",
                                                                id: "super-pret"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                                                productId: parseInt(product1.id),
                                                                price: mainOffer.price.selling_price,
                                                                regularPrice: mainOffer.price.base_price,
                                                                msrp: mainOffer.price.msrp_price,
                                                                showMSRPTooltip: true,
                                                                formatted: true,
                                                                size: "productPage",
                                                                discountType: mainOffer.price.discount_type,
                                                                displayDiscount: true,
                                                                displayUnit: hasPricePerFactor ? product1.price_unit.split("/")[1] : false
                                                            }),
                                                            hasPriceUnit && ((mainOffer === null || mainOffer === void 0 ? void 0 : (ref21 = mainOffer.price) === null || ref21 === void 0 ? void 0 : ref21.selling_price) || (mainOffer === null || mainOffer === void 0 ? void 0 : (ref22 = mainOffer.price) === null || ref22 === void 0 ? void 0 : ref22.package_selling_price)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Price_PricePerUnit, {
                                                                price: mainOffer.price,
                                                                unit: product1.price_unit,
                                                                factor: product1.price_factor,
                                                                hasPricePerFactor: hasPricePerFactor
                                                            }),
                                                            Boolean(sgrTax === null || sgrTax === void 0 ? void 0 : sgrTax.value) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "text-gray-1200 text-xs leading-none inline-block mt-[6px]",
                                                                children: [
                                                                    "Taxa garantie returnare: ",
                                                                    sgrTax.value,
                                                                    " lei"
                                                                ]
                                                            }),
                                                            hasFinancingOptions && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductFinancing/* default */.Z, {
                                                                product: product1,
                                                                label: "productPage",
                                                                simulation: loanSimulation === null || loanSimulation === void 0 ? void 0 : loanSimulation[product1.installments_provider || "credex"]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "w-full",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Status/* default */.Z, {
                                                                product: product1
                                                            }),
                                                            mainOffer && !isLocalSeller && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_ProductPageSellerInfo, {
                                                                seller: mainOffer.seller
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            hasResealed && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_ProductPageResealedInfo, {
                                                resealedList: product1.resealed,
                                                onResealedClick: onResealedClick
                                            }),
                                            hasProductVariations && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_ProductVariations, {
                                                product: product1
                                            }),
                                            !isSaleable && hasResealed && !hasStorePickup && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductButtonViewResealed/* default */.Z, {
                                                href: "#resigilate"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex flex-col items-center space-y-2 !mt-5 md:mt-0 lg:flex-row lg:space-y-0 lg:space-x-4",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classnames_default()("w-full", {
                                                        "lg:w-3/4": hasPricePerFactor,
                                                        "lg:w-1/2": !hasPricePerFactor
                                                    }),
                                                    ref: addToCartRef,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCart/* default */.Z, {
                                                        product: product1,
                                                        activeServices: activeServices,
                                                        westaco: westacoData,
                                                        disabled: isWestaco && !westacoValid || !isSaleable && !hasStorePickup,
                                                        noMargin: true,
                                                        isInSpecialCampaign: isInSpecialCampaign
                                                    })
                                                })
                                            }),
                                            hasStorePickup && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_ProductStoreAvailability, {
                                                identifier: product1.sku
                                            }),
                                            isLockerEligible && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_ProductLockerAvailability, {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-[24px] space-y-[24px]",
                                        children: [
                                            (shippingInfo === null || shippingInfo === void 0 ? void 0 : shippingInfo.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_ProductPageShipping, {
                                                shippingInfo: shippingInfo,
                                                hasFreeShippingPromo: hasFreeShippingPromo
                                            }),
                                            (credexConfig === null || credexConfig === void 0 ? void 0 : (ref23 = credexConfig.cashbackBanner) === null || ref23 === void 0 ? void 0 : ref23.enabled) && (credexConfig === null || credexConfig === void 0 ? void 0 : (ref24 = credexConfig.cashbackBanner) === null || ref24 === void 0 ? void 0 : ref24.label) && !isWestaco && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[14px]",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CredexCashbackBanner/* default */.Z, {})
                                            }),
                                            hasServices && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_ProductServices, {
                                                        services: product1.product_links,
                                                        activeServices: activeServices,
                                                        removeService: removeService,
                                                        serviceClick: serviceClick
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductServices_ProductServicesModal, {
                                                        services: product1.product_links,
                                                        activeServices: activeServices,
                                                        serviceClick: serviceClick
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: classnames_default()("flex flex-col gap-[24px]", {
                                                    "md:flex-row-reverse": hasBenefits
                                                }),
                                                children: [
                                                    hasBenefits && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "bg-[#F5F5F4] p-[8px] rounded h-fit w-full md:max-w-[50%]",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                htmlFor: "toggle-benefits",
                                                                className: "flex items-center justify-between cursor-pointer",
                                                                onClick: toggleBenefits,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "flex items-center gap-[8px]",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                                                title: "Extra beneficii",
                                                                                as: "h2",
                                                                                display: "h5",
                                                                                classesProp: "font-medium",
                                                                                sameSizeOnMobile: true
                                                                            }),
                                                                            labels.map(function(param) {
                                                                                var title = param.title, image = param.image;
                                                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(ImageWithFallback/* default */.Z, {
                                                                                    src: image ? "".concat(View_settings.cdn, "/").concat(image) : null,
                                                                                    className: classnames_default()("max-w-[20px] h-auto transition-all duration-300", {
                                                                                        "h-0": showBenefits
                                                                                    }),
                                                                                    fallback: "".concat(View_settings.websiteStatics, "/images/benefits-placeholder.svg")
                                                                                }, title);
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: classnames_default()("transition-transform duration-300", {
                                                                            "rotate-180": showBenefits
                                                                        }),
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {})
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: classnames_default()("overflow-hidden transition-all duration-300", {
                                                                    "h-auto pt-[8px]": showBenefits,
                                                                    "h-0": !showBenefits
                                                                }),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_ProductBenefits, {
                                                                    benefits: labels
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: classnames_default()("flex flex-col w-full md:w-[50%] gap-[16px]", {
                                                            "flex-wrap": hasBenefits
                                                        }),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_ProductPageWishlistAndCompare, {
                                                            product: product1
                                                        })
                                                    })
                                                ]
                                            }),
                                            hasCredexUserPromo && /*#__PURE__*/ (0,jsx_runtime.jsx)(CredexUserPromoBanner/* default */.Z, {
                                                layout: "extraInfo",
                                                installmentValue: installmentValue
                                            })
                                        ]
                                    }),
                                    isWestaco && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_Westaco, {
                                        options: mainOffer.westaco_options,
                                        callback: westacoFormCb
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            hasOtherOffers && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "oferte",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProductOffers, {
                    offers: otherOffers,
                    product: product1,
                    getIsInSpecialCampaign: getIsInSpecialCampaign,
                    getLabelsBySellerId: getLabelsBySellerId
                })
            }),
            hasBundles && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "pachete",
                className: "mt-27px pb-22px md:mt-15px",
                ref: bundlesRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        as: "h2",
                        display: "h2",
                        title: "Cumpara impreuna",
                        border: "bottom",
                        classesProp: "mb-4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Catalog_Bundles, {
                        productBundles: productBundles,
                        ref: bundlesRef
                    })
                ]
            }),
            hasResealed && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "resigilate",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_ResealedList, {
                    product: product1
                }, (_sku = product1.sku) !== null && _sku !== void 0 ? _sku : "")
            }),
            productRecommendations && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    !isWestaco && hasProductAccesories && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "accessories",
                        className: "lg:py-5 py-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                as: "h2",
                                display: "h2",
                                title: "Accesorii",
                                border: "bottom",
                                classesProp: "mb-4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "md:mx-[-15px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* default */.Z, {
                                    children: productRecommendations.cross_sell_tabs.map(function(param, index1) {
                                        var title = param.title, products = param.products;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Tabs/* Tab */.O, {
                                            selected: index1 === 0,
                                            title: title,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandableProductList/* default */.Z, {
                                                externalTracking: true,
                                                products: products.map(function(product, index) {
                                                    return View_objectSpread({}, product, {
                                                        index: index + 1,
                                                        item_list_name: "accesorii"
                                                    });
                                                }),
                                                desktopVisibleProducts: 5,
                                                onProductClick: function(product) {
                                                    return handleProductClick(product);
                                                }
                                            }, (_sku1 = currentProduct.product.sku) !== null && _sku1 !== void 0 ? _sku1 : "")
                                        }, index1);
                                    })
                                })
                            })
                        ]
                    }),
                    ((ref25 = productRecommendations.up_sell) === null || ref25 === void 0 ? void 0 : ref25.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "lg:pt-4 lg:pb-5 py-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                as: "h2",
                                display: "h2",
                                title: "Produse similare",
                                border: "bottom",
                                classesProp: "mb-4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandableProductList/* default */.Z, {
                                externalTracking: true,
                                products: productRecommendations.up_sell.map(function(product, index) {
                                    return View_objectSpread({}, product, {
                                        index: index + 1,
                                        item_list_name: "produse similare"
                                    });
                                }),
                                onProductClick: function(product) {
                                    return handleProductClick(product);
                                }
                            }, (_sku2 = currentProduct.product.sku) !== null && _sku2 !== void 0 ? _sku2 : "")
                        ]
                    })
                ]
            }),
            isWestaco ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "description",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_ProductDescription, {
                    staticHTML: (_description = product1.description) !== null && _description !== void 0 ? _description : "",
                    contentEditorBlock: (_description_editor_object = product1.description_editor_object) !== null && _description_editor_object !== void 0 ? _description_editor_object : "",
                    cmsBlocks: productDescriptionCMSBlocks
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "space-y-2 py-2 divide-y divide-black/30 border-y mb-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                    expandedItems: openedAccordionItems,
                    onToggle: onAccordionItemToggle,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item/* default */.Z, {
                            id: "description",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                        title: "Descriere"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Body/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPage_ProductDescription, {
                                            // TODO: Re-check if product.use_external_description returns INT
                                            // If true, remove strict equality check
                                            useExternalContentProvider: product1.use_external_description === 1,
                                            staticHTML: (_description1 = product1.description) !== null && _description1 !== void 0 ? _description1 : "",
                                            contentEditorBlock: (_description_editor_object1 = product1.description_editor_object) !== null && _description_editor_object1 !== void 0 ? _description_editor_object1 : "",
                                            cmsBlocks: productDescriptionCMSBlocks,
                                            ean: ((ref26 = product1.ean_codes) === null || ref26 === void 0 ? void 0 : ref26.split(",")[0]) || "",
                                            productNumber: productNumber,
                                            brand: product1.brand_name || ""
                                        }),
                                        (hasWarranty() || hasGreenTax) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col space-y-2 md:flex-row md:space-y-0 md:space-x-4 items-start md:items-center col-span-2 border-t border-[#999999]/60 py-2.5",
                                            children: [
                                                hasWarranty() && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductWarranty, {
                                                    data: warranty
                                                }),
                                                hasGreenTax && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProductGreenTax, {
                                                    data: mainOffer.price.green_tax
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item/* default */.Z, {
                            id: "additional",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                        title: "Specificatii"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Specifications, {
                                        groups: product1.info.groups
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item/* default */.Z, {
                            id: "reviews",
                            isPreRendered: false,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center space-x-2.5",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                as: "h2",
                                                display: "h2",
                                                title: "Recenzii"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Ratings/* default */.Z, {
                                                reviewsCount: reviewsCount,
                                                ratingSummary: reviewsScore
                                            }),
                                            reviewsScore > 0 && reviewsCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-2xl font-medium mx-10px lg:mr-7px",
                                                children: reviewAverage
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "py-1 px-2 bg-yellow rounded-md text-sm leading-none",
                                                children: reviewsCount
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews, {
                                        product: product1,
                                        type: "reviews",
                                        reviewsSummary: (ref27 = currentProduct.reviews_summary) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.items) === null || ref28 === void 0 ? void 0 : ref28[0]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item/* default */.Z, {
                            id: "questions",
                            isPreRendered: false,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center space-x-2.5",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                title: "Intrebari"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "py-1 px-2 bg-yellow rounded-md text-sm leading-none",
                                                children: questionsCount
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews, {
                                        product: product1,
                                        type: "questions",
                                        reviewsSummary: currentProduct === null || currentProduct === void 0 ? void 0 : (ref29 = currentProduct.reviews_summary) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.items) === null || ref30 === void 0 ? void 0 : ref30[0]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item/* default */.Z, {
                            id: "compare",
                            isPreRendered: false,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                        title: "Compara"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Catalog_ProductCompareSection, {
                                        product: product1
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            productRecommendations && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    ((ref31 = productRecommendations.also_bought) === null || ref31 === void 0 ? void 0 : ref31.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "lg:pt-4 lg:pb-5 py-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                as: "h2",
                                display: "h2",
                                title: "Alti vizitatori au cumparat",
                                border: "bottom",
                                classesProp: "mb-4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandableProductList/* default */.Z, {
                                externalTracking: true,
                                products: productRecommendations.also_bought.map(function(product, index) {
                                    return View_objectSpread({}, product, {
                                        index: index + 1,
                                        item_list_name: "alti vizitatori au cumparat"
                                    });
                                }),
                                onProductClick: function(product) {
                                    return handleProductClick(product);
                                }
                            }, (_sku3 = currentProduct.product.sku) !== null && _sku3 !== void 0 ? _sku3 : "")
                        ]
                    }),
                    !isWestaco && ((ref32 = productRecommendations.bought_together) === null || ref32 === void 0 ? void 0 : ref32.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "lg:pt-4 lg:pb-5 py-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                as: "h2",
                                display: "h2",
                                title: "Cumparate frecvent impreuna",
                                border: "bottom",
                                classesProp: "mb-4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandableProductList/* default */.Z, {
                                externalTracking: true,
                                products: productRecommendations.bought_together.map(function(product, index) {
                                    return View_objectSpread({}, product, {
                                        index: index + 1,
                                        item_list_name: "cumparate frecvent impreuna"
                                    });
                                }),
                                desktopVisibleProducts: 5,
                                onProductClick: function(product) {
                                    return handleProductClick(product);
                                }
                            }, (_sku4 = currentProduct.product.sku) !== null && _sku4 !== void 0 ? _sku4 : "")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "lg:pt-4 lg:pb-5 py-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsRecentlyViewed/* default */.Z, {
                    visibleProductSku: product1.sku,
                    onProductClick: handleProductClick
                }, (_sku5 = product1.sku) !== null && _sku5 !== void 0 ? _sku5 : "")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompareWidget/* default */.Z, {
                showsStickyCta: !isEol && isVisible && (isSaleable || hasStorePickup) && !isStickyFooterVisible
            })
        ]
    }));
};
/* harmony default export */ var Catalog_View = ((0,es/* connect */.$j)(function(state) {
    return {
        currentProduct: state.catalog.currentProduct,
        acc: state.catalog.currentCategory,
        hash: state.navigation.hash,
        cmsBlocks: state.app.cmsBlocks,
        user: state.user,
        cart: state.cart,
        credexConfig: state.credex.data,
        lockers: state.stores.lockers
    };
}, {
    apiCall: app_actions/* apiCall */.k_,
    trackProductClick: actions/* trackProductClick */.Cg,
    addProductToProductNavigationHistory: catalog_actions/* addProductToProductNavigationHistory */.Lb,
    addModal: app_actions/* addModal */.Y_,
    getAddresses: user_actions/* getAddresses */.ZK
})(CatalogView));

// EXTERNAL MODULE: ./containers/ErrorPage.js
var ErrorPage = __webpack_require__(75720);
// EXTERNAL MODULE: ./lib/structuredData.js
var structuredData = __webpack_require__(89229);
;// CONCATENATED MODULE: ./components/ProductSchema.js







function ProductSchema_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ProductSchema_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return ProductSchema_arrayLikeToArray(arr);
}
function ProductSchema_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ProductSchema_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function ProductSchema_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ProductSchema_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProductSchema_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ProductSchema_toConsumableArray(arr) {
    return ProductSchema_arrayWithoutHoles(arr) || ProductSchema_iterableToArray(arr) || ProductSchema_unsupportedIterableToArray(arr) || ProductSchema_nonIterableSpread();
}
function ProductSchema_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ProductSchema_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ProductSchema_arrayLikeToArray(o, minLen);
}
var ProductSchema_ref = (0,config["default"])(), ProductSchema_publicRuntimeConfig = ProductSchema_ref.publicRuntimeConfig, ProductSchema_settings = ProductSchema_publicRuntimeConfig.settings, ProductSchema_cdn = ProductSchema_settings.cdn, currencyCode = ProductSchema_settings.currencyCode, ProductSchema_baseUrl = ProductSchema_settings.baseUrl, productSchema = ProductSchema_settings.productSchema;
// Google rejects a longer name, the same limit as a Merchant Center title
var NAME_MAX_LENGTH = 150;
// Valid GS1 lengths: GTIN-8, UPC-A, EAN-13 and ITF-14
var GTIN_LENGTHS = [
    8,
    12,
    13,
    14
];
// GS1 prefixes reserved for internal or in-store use, as the first digits of
// the 13 digit form. They are valid inside a company but not globally, so
// Google reports them as not globally valid. GTIN-8 has its own ranges.
var RESTRICTED_GTIN13_PREFIXES = [
    "02",
    "04",
    "2"
];
var RESTRICTED_GTIN8_PREFIXES = [
    "0",
    "2"
];
var getProductStockStatus = function(product) {
    var ref1 = (0,helpers/* productHelper */.gU)(product), isSaleable = ref1.isSaleable, isPreorder = ref1.isPreorder, hasStorePickup = ref1.hasStorePickup, isEol = ref1.isEol, isVisible = ref1.isVisible;
    if (isEol) {
        return "Discontinued";
    }
    // We treat out of stock products with resealed items available as out of stock
    if (!isVisible || !isSaleable && !hasStorePickup) {
        return "OutOfStock";
    }
    if (!isSaleable && hasStorePickup) {
        return "InStoreOnly";
    }
    if (isPreorder) {
        return "PreOrder";
    }
    return "InStock";
};
var getOfferStockStatus = function(offer) {
    var stockStatus = get_default()(offer, "stock.status", 0);
    if (stockStatus === 3) {
        return "PreOrder";
    }
    // 1 is in stock, 2 ships on demand; both are orderable
    return stockStatus === 1 || stockStatus === 2 ? "InStock" : "OutOfStock";
};
var getProductRecommendedGenderUse = function(param) {
    var gender = param.gender;
    var lowerCaseGender = gender.toLowerCase();
    switch(lowerCaseGender){
        case "barbati":
            {
                return "Male";
            }
        case "femei":
            {
                return "Female";
            }
        default:
            {
                return "unisex";
            }
    }
};
var getProductImageUrl = function(product) {
    var ref2;
    if (((ref2 = product.gallery) === null || ref2 === void 0 ? void 0 : ref2.length) > 0) {
        return product.gallery.map(function(image) {
            return "".concat(ProductSchema_cdn).concat(image.file);
        });
    }
    if (product.image) {
        return [
            "".concat(ProductSchema_cdn).concat(product.image)
        ];
    }
};
var getPrice = function(offer) {
    return get_default()(offer, "price.selling_price", false);
};
// Dates are taken in UTC so the server and the browser agree on them during
// hydration whatever time zone each one runs in
var toUtcDate = function(date) {
    return date.toISOString().slice(0, 10);
};
// The offer is valid from today, for as many days as the website config allows.
// A validity that expires the next day is already in the past by the time
// Google recrawls a cached page, which makes it drop the price.
var getPriceValidityDates = function() {
    var today = new Date();
    return {
        validFrom: toUtcDate(today),
        priceValidUntil: toUtcDate((0,add/* default */.Z)(today, {
            days: productSchema.priceValidDays
        }))
    };
};
var hasValidGtinCheckDigit = function(gtin) {
    var digits = gtin.split("").map(Number);
    var checkDigit = digits.pop();
    // GS1 weights alternate 3 and 1, starting from the rightmost payload digit
    var weightedSum = digits.reverse().reduce(function(acc, digit, index) {
        return acc + digit * (index % 2 === 0 ? 3 : 1);
    }, 0);
    return (10 - weightedSum % 10) % 10 === checkDigit;
};
var isRestrictedGtin = function(gtin) {
    if (gtin.length === 8) {
        return RESTRICTED_GTIN8_PREFIXES.some(function(prefix) {
            return gtin.startsWith(prefix);
        });
    }
    // The ITF-14 packaging indicator is not part of the prefix, and a UPC-A is
    // the 13 digit form without its leading zero
    var gtin13 = gtin.length === 14 ? gtin.slice(1) : gtin.padStart(13, "0");
    return RESTRICTED_GTIN13_PREFIXES.some(function(prefix) {
        return gtin13.startsWith(prefix);
    });
};
// Many products carry an internal code in ean_codes instead of a real EAN, so
// we only publish a gtin we can verify. An unverifiable code is left out
// rather than replaced with the sku or the manufacturer number.
var getSchemaGtin = function(eanCodes) {
    var gtin = (eanCodes || "").split(",")[0].trim();
    if (!GTIN_LENGTHS.includes(gtin.length) || !/^\d+$/.test(gtin)) {
        return null;
    }
    if (isRestrictedGtin(gtin)) {
        return null;
    }
    return hasValidGtinCheckDigit(gtin) ? gtin : null;
};
var getSchemaName = function(name) {
    if (name.length <= NAME_MAX_LENGTH) {
        return name;
    }
    var nameStart = name.slice(0, NAME_MAX_LENGTH);
    var lastSpaceIndex = nameStart.lastIndexOf(" ");
    var truncatedName = lastSpaceIndex > 0 ? nameStart.slice(0, lastSpaceIndex) : nameStart;
    // A cut name should not end on the separator it was cut at
    return truncatedName.replace(/[\s,;:.-]+$/, "");
};
var getSchemaDescription = function(product) {
    var description = product.short_description || product.meta_description || product.name;
    // Some descriptions come with inline markup from the content editor
    return description.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
};
var getProductInfoByAttributeCode = function(param) {
    var product = param.product, attribute = param.attribute;
    var ref3;
    return ((ref3 = product.info) === null || ref3 === void 0 ? void 0 : ref3.groups) && product.info.groups.flatMap(function(group) {
        return group.attributes;
    }).find(function(attr) {
        return attr.attribute_code === attribute;
    });
};
var getSchemaReviewRating = function(reviewsSummary) {
    var reviewsData = get_default()(reviewsSummary, "items[0].reviews", null);
    if (reviewsData && reviewsData.value && reviewsData.value !== 0) {
        var reviewsCount = reviewsData.value;
        var reviewsTotalValue = reviewsData.total;
        var reviewRating = reviewsTotalValue / reviewsCount <= 5 ? parseFloat(reviewsTotalValue / reviewsCount) : 0;
        var reviewRatingPercentage = reviewRating !== 0 ? reviewRating / 5 * 100 : 0;
        // Google Structured Data Product Schema uses a 5 star scale
        var schemaScaleRatingValue = (reviewRatingPercentage / 100 * 5).toFixed(1);
        if (reviewRating) {
            return {
                "@type": "AggregateRating",
                // TODO: remove when review values are migrated
                ratingValue: schemaScaleRatingValue > 1 ? schemaScaleRatingValue : 1,
                reviewCount: reviewsCount
            };
        }
    }
};
// Emitting a Brand without a name is worse than emitting no brand at all
var getSchemaBrand = function(product) {
    return product.brand_name && {
        "@type": "Brand",
        name: product.brand_name
    };
};
var getSchemaPeopleAudience = function(param) {
    var gender = param.gender;
    var peopleAudience = {
        "@type": "PeopleAudience"
    };
    var recommendedGender = getProductRecommendedGenderUse({
        gender: gender
    });
    if (recommendedGender === "unisex") {
        peopleAudience.suggestedGender = recommendedGender;
    } else {
        peopleAudience.suggestedGender = "https://schema.org/".concat(recommendedGender);
    }
    return peopleAudience;
};
// No shippingRate on purpose: the delivery fee depends on cart value, weight,
// region and delivery mode, so a single number here would be wrong for most
// orders. Google takes the real rules from the Merchant Center shipping
// settings instead.
var getSchemaShippingDetails = function() {
    var handlingTime = productSchema.handlingTime, transitTime = productSchema.transitTime;
    return {
        "@type": "OfferShippingDetails",
        shippingDestination: {
            "@type": "DefinedRegion",
            addressCountry: "RO"
        },
        deliveryTime: {
            "@type": "ShippingDeliveryTime",
            handlingTime: {
                "@type": "QuantitativeValue",
                minValue: handlingTime.minValue,
                maxValue: handlingTime.maxValue,
                unitCode: "DAY"
            },
            transitTime: {
                "@type": "QuantitativeValue",
                minValue: transitTime.minValue,
                maxValue: transitTime.maxValue,
                unitCode: "DAY"
            }
        }
    };
};
var getSchemaReturnPolicy = function() {
    var _returnPolicy = productSchema.returnPolicy, merchantReturnDays = _returnPolicy.merchantReturnDays, returnFees = _returnPolicy.returnFees;
    return ProductSchema_objectSpread({
        "@type": "MerchantReturnPolicy",
        returnPolicyCategory: "https://schema.org/MerchantReturnFiniteReturnWindow",
        merchantReturnDays: merchantReturnDays,
        applicableCountry: "RO",
        returnMethod: [
            "https://schema.org/ReturnByMail",
            "https://schema.org/ReturnInStore", 
        ]
    }, returnFees && {
        returnFees: returnFees
    });
};
var getSchemaOffer = function(param) {
    var offer = param.offer, availability = param.availability, itemCondition = param.itemCondition, productUrl = param.productUrl, priceValidityDates = param.priceValidityDates;
    var ref4;
    return ProductSchema_objectSpread({
        "@type": "Offer",
        url: productUrl,
        price: getPrice(offer),
        priceCurrency: currencyCode,
        availability: "https://schema.org/".concat(availability),
        itemCondition: itemCondition,
        validFrom: priceValidityDates.validFrom,
        priceValidUntil: priceValidityDates.priceValidUntil,
        shippingDetails: getSchemaShippingDetails(),
        // Google reads the return policy from the offer, not from the product
        hasMerchantReturnPolicy: getSchemaReturnPolicy()
    }, (offer === null || offer === void 0 ? void 0 : (ref4 = offer.seller) === null || ref4 === void 0 ? void 0 : ref4.name) && {
        seller: {
            "@type": "Organization",
            name: offer.seller.name
        }
    });
};
// A product without a priced offer must not publish an empty Offer: Google
// reads it as a missing price and drops the product from Merchant Center.
// Such a product gets no offers key at all.
var getSchemaOffers = function(param1) {
    var mainOffer = param1.mainOffer, otherOffers = param1.otherOffers, productAvailability = param1.productAvailability, itemCondition = param1.itemCondition, productUrl = param1.productUrl;
    var priceValidityDates = getPriceValidityDates();
    var pricedOffers = ProductSchema_toConsumableArray(getPrice(mainOffer) ? [
        {
            offer: mainOffer,
            availability: productAvailability
        }
    ] : []).concat(ProductSchema_toConsumableArray(otherOffers.filter(function(offer) {
        return getPrice(offer);
    }).map(function(offer) {
        return {
            offer: offer,
            availability: getOfferStockStatus(offer)
        };
    })));
    if (!pricedOffers.length) {
        return null;
    }
    var offers = pricedOffers.map(function(param) {
        var offer = param.offer, availability = param.availability;
        return getSchemaOffer({
            offer: offer,
            availability: availability,
            itemCondition: itemCondition,
            productUrl: productUrl,
            priceValidityDates: priceValidityDates
        });
    });
    // A single offer goes out as an object, the way Google documents it
    return offers.length === 1 ? offers[0] : offers;
};
var ProductSchema = function(param) {
    var productData = param.productData;
    if (get_default()(productData, "product.name", false)) {
        var product = productData.product, reviews_summary = productData.reviews_summary;
        var ref5 = (0,helpers/* productHelper */.gU)(product), mainOffer = ref5.mainOffer, otherOffers = ref5.otherOffers, isResealed = ref5.isResealed, productNumber = ref5.productNumber;
        // Same shape as the canonical link, so the url never carries the query
        // string or whatever path the request came in with
        var productUrl = "".concat(ProductSchema_baseUrl, "/").concat(product.url_key, "/cpd/").concat(product.sku, "/");
        var productAvailability = getProductStockStatus(product);
        var itemCondition = isResealed ? "https://schema.org/UsedCondition" : "https://schema.org/NewCondition";
        var aggregateRating = getSchemaReviewRating(reviews_summary);
        var offers = getSchemaOffers({
            mainOffer: mainOffer,
            otherOffers: otherOffers,
            productAvailability: productAvailability,
            itemCondition: itemCondition,
            productUrl: productUrl
        });
        var brand = getSchemaBrand(product);
        var gtin = getSchemaGtin(product.ean_codes);
        var colorOption = getProductInfoByAttributeCode({
            product: product,
            attribute: "culoare_global"
        });
        var genderOption = getProductInfoByAttributeCode({
            product: product,
            attribute: "pentru_sex_global"
        });
        var materialOption = getProductInfoByAttributeCode({
            product: product,
            attribute: "material_global"
        });
        var schema = ProductSchema_objectSpread({
            "@context": "https://schema.org/",
            "@type": "Product",
            name: getSchemaName(product.name),
            url: productUrl
        }, (product.image || product.gallery) && {
            image: getProductImageUrl(product)
        }, offers && {
            offers: offers
        }, {
            description: getSchemaDescription(product),
            sku: product.sku
        }, brand && {
            brand: brand
        }, (genderOption === null || genderOption === void 0 ? void 0 : genderOption.value) && {
            audience: getSchemaPeopleAudience({
                gender: genderOption.value
            })
        }, (colorOption === null || colorOption === void 0 ? void 0 : colorOption.value) && {
            color: colorOption.value
        }, (materialOption === null || materialOption === void 0 ? void 0 : materialOption.value) && {
            material: materialOption.value
        }, aggregateRating && {
            aggregateRating: aggregateRating
        }, {
            // Kept next to the per offer policy for the consumers reading it here
            hasMerchantReturnPolicy: getSchemaReturnPolicy()
        }, gtin && {
            gtin: gtin
        }, productNumber && {
            mpn: productNumber
        });
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: (0,structuredData/* default */.Z)(schema)
            }
        }));
    }
    return null;
};
/* harmony default export */ var components_ProductSchema = (ProductSchema);

// EXTERNAL MODULE: ./components/PromoToasts/index.js + 1 modules
var PromoToasts = __webpack_require__(30866);
// EXTERNAL MODULE: ./store/stores/actions.js
var stores_actions = __webpack_require__(76208);
// EXTERNAL MODULE: ./lib/pageNames.js
var pageNames = __webpack_require__(21593);
;// CONCATENATED MODULE: ./pages/[urlKey]/cpd/[productSku].js

















function _productSku_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _productSku_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _productSku_arrayLikeToArray(arr);
}
function _productSku_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _productSku_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _productSku_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                _productSku_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                _productSku_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _productSku_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _productSku_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _productSku_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _productSku_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _productSku_defineProperties(Constructor, staticProps);
    return Constructor;
}
function _productSku_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _productSku_getPrototypeOf(o) {
    _productSku_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _productSku_getPrototypeOf(o);
}
function _productSku_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _productSku_setPrototypeOf(subClass, superClass);
}
function _productSku_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _productSku_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _productSku_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _productSku_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _productSku_possibleConstructorReturn(self, call) {
    if (call && (_productSku_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _productSku_assertThisInitialized(self);
}
function _productSku_setPrototypeOf(o, p) {
    _productSku_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _productSku_setPrototypeOf(o, p);
}
function _productSku_toConsumableArray(arr) {
    return _productSku_arrayWithoutHoles(arr) || _productSku_iterableToArray(arr) || _productSku_unsupportedIterableToArray(arr) || _productSku_nonIterableSpread();
}
var _productSku_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _productSku_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _productSku_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _productSku_arrayLikeToArray(o, minLen);
}
function _productSku_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _productSku_createSuper(Derived) {
    var hasNativeReflectConstruct = _productSku_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _productSku_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _productSku_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _productSku_possibleConstructorReturn(this, result);
    };
}
var _productSku_ref = (0,config["default"])(), _productSku_settings = _productSku_ref.publicRuntimeConfig.settings;
var View = /*#__PURE__*/ function(Component1) {
    "use strict";
    _productSku_inherits(View, Component1);
    var _super = _productSku_createSuper(View);
    function View() {
        _productSku_classCallCheck(this, View);
        return _super.apply(this, arguments);
    }
    _productSku_createClass(View, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _props = this.props, trackProduct1 = _props.trackProduct, currentProduct = _props.currentProduct;
                if (currentProduct) {
                    // Track product category breadcrumbs
                    var productBreadcrumbs = _productSku_toConsumableArray(currentProduct.breadcrumbs);
                    // Remove product name from breadcrumbs
                    productBreadcrumbs.pop();
                    // Track product
                    trackProduct1(_productSku_objectSpread({}, currentProduct.product, {
                        categoryPath: productBreadcrumbs
                    }), productBreadcrumbs, pageNames/* default.CATALOG_PRODUCT */.Z.CATALOG_PRODUCT);
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _props = this.props, urlAsPath = _props.urlAsPath, trackProduct2 = _props.trackProduct, currentProduct = _props.currentProduct;
                // Track page query change
                if (prevProps.urlAsPath !== urlAsPath && currentProduct) {
                    // Track product category breadcrumbs
                    var productBreadcrumbs = _productSku_toConsumableArray(currentProduct.breadcrumbs);
                    // Remove product name from breadcrumbs
                    productBreadcrumbs.pop();
                    // Track product
                    trackProduct2(_productSku_objectSpread({}, currentProduct.product, {
                        categoryPath: productBreadcrumbs
                    }), productBreadcrumbs, pageNames/* default.CATALOG_PRODUCT */.Z.CATALOG_PRODUCT);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var currentProduct = this.props.currentProduct;
                if (currentProduct && currentProduct.product) {
                    var _product = currentProduct.product, _meta_title = _product.meta_title, meta_title = _meta_title === void 0 ? "" : _meta_title, _meta_description = _product.meta_description, meta_description = _meta_description === void 0 ? "" : _meta_description, _meta_keywords = _product.meta_keywords, meta_keywords = _meta_keywords === void 0 ? "" : _meta_keywords, meta_robots = _product.meta_robots, seo_canonical = _product.seo_canonical, _seo_alternate_canonical = _product.seo_alternate_canonical, seo_alternate_canonical = _seo_alternate_canonical === void 0 ? "" : _seo_alternate_canonical, _name = _product.name, name = _name === void 0 ? "" : _name, url_key = _product.url_key, sku = _product.sku;
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                        children: meta_title || name || ""
                                    }),
                                    meta_description.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                        name: "description",
                                        content: meta_description
                                    }),
                                    meta_keywords.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                        name: "keywords",
                                        content: meta_keywords
                                    }),
                                    (meta_robots === null || meta_robots === void 0 ? void 0 : meta_robots.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                        name: "robots",
                                        content: meta_robots
                                    }),
                                    seo_canonical && !(seo_alternate_canonical === null || seo_alternate_canonical === void 0 ? void 0 : seo_alternate_canonical.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                        rel: "canonical",
                                        href: "".concat(_productSku_settings.baseUrl, "/").concat(url_key, "/cpd/").concat(sku, "/")
                                    }),
                                    seo_canonical && (seo_alternate_canonical === null || seo_alternate_canonical === void 0 ? void 0 : seo_alternate_canonical.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                        rel: "alternate",
                                        href: seo_alternate_canonical
                                    }),
                                    !!currentProduct.product.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                        property: "og:image",
                                        content: (0,helpers/* resizeImage */.tg)(currentProduct.product.image, "600x600")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProductSchema, {
                                productData: currentProduct
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Catalog_View, {}, currentProduct.product.sku),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoToasts/* default */.Z, {
                                type: "product",
                                params: {
                                    sku: currentProduct.product.sku
                                }
                            })
                        ]
                    }));
                }
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* default */.Z, {
                    layout: "404"
                }));
            }
        }
    ], [
        {
            key: "getInitialProps",
            value: function getInitialProps(ctx) {
                return _productSku_asyncToGenerator(runtime_default().mark(function _callee() {
                    var reduxStore, query, res, urlAsPath, stores, product;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                reduxStore = ctx.reduxStore, query = ctx.query, res = ctx.res, urlAsPath = ctx.asPath;
                                stores = reduxStore.getState().stores.data;
                                if (!query.productSku) {
                                    _ctx.next = 7;
                                    break;
                                }
                                _ctx.next = 5;
                                return reduxStore.dispatch((0,catalog_actions/* getProduct */.wv)(encodeURIComponent(query.productSku)));
                            case 5:
                                product = _ctx.sent;
                                if (!product && res) {
                                    res.statusCode = 404;
                                }
                            case 7:
                                if (reduxStore.getState().app.websiteAdminConfigs.featureFlags) {
                                    _ctx.next = 10;
                                    break;
                                }
                                _ctx.next = 10;
                                return reduxStore.dispatch((0,app_actions/* getWebsiteAdminConfig */.z5)({
                                    code: "featureFlagsWebsite"
                                }));
                            case 10:
                                _ctx.next = 12;
                                return reduxStore.dispatch((0,app_actions/* getCmsBlocks */.lD)([
                                    "altex_catalog_product_services"
                                ]));
                            case 12:
                                if (stores) {
                                    _ctx.next = 15;
                                    break;
                                }
                                _ctx.next = 15;
                                return reduxStore.dispatch((0,stores_actions/* getStores */.r8)());
                            case 15:
                                return _ctx.abrupt("return", {
                                    urlAsPath: urlAsPath,
                                    query: query
                                });
                            case 16:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        }
    ]);
    return View;
}(react.Component);
View.pageLayout = "default";
/* harmony default export */ var _productSku_ = ((0,withRouterPageLayout/* default */.Z)((0,es/* connect */.$j)(function(state) {
    return {
        currentProduct: state.catalog.currentProduct
    };
}, {
    trackProduct: actions/* trackProduct */.J3,
    getStores: stores_actions/* getStores */.r8
})(View)));


/***/ }),

/***/ 73337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GU": function() { return /* binding */ OnChange; }
/* harmony export */ });
/* unused harmony exports ExternallyChanged, OnBlur, OnFocus */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_final_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66688);



function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var ExternallyChangedState =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ExternallyChangedState, _React$Component);

  function ExternallyChangedState(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      previous: props.input.value,
      externallyChanged: false
    };
    return _this;
  }

  var _proto = ExternallyChangedState.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _this$props = this.props,
        value = _this$props.input.value,
        active = _this$props.meta.active;
    var previous = this.state.previous;

    if (value !== previous) {
      this.setState({
        previous: value,
        externallyChanged: !active
      });
    }
  };

  _proto.render = function render() {
    return this.props.children(this.state.externallyChanged);
  };

  return ExternallyChangedState;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);

var ExternallyChanged = function ExternallyChanged(_ref) {
  var name = _ref.name,
      children = _ref.children;
  return createElement(Field, {
    name: name,
    subscription: {
      active: true,
      value: true
    },
    allowNull: true,
    render: function render(props) {
      return createElement(ExternallyChangedState, _extends({}, props, {
        children: children
      }));
    }
  });
};

var OnBlurState =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(OnBlurState, _React$Component);

  function OnBlurState(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      previous: !!props.meta.active
    };
    return _this;
  }

  var _proto = OnBlurState.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _this$props = this.props,
        children = _this$props.children,
        active = _this$props.meta.active;
    var previous = this.state.previous;

    if (previous && !active) {
      children();
    }

    if (previous !== active) {
      this.setState({
        previous: active
      });
    }
  };

  _proto.render = function render() {
    return null;
  };

  return OnBlurState;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);

var OnBlur = function OnBlur(_ref) {
  var name = _ref.name,
      children = _ref.children;
  return createElement(Field, {
    name: name,
    subscription: {
      active: true
    },
    render: function render(props) {
      return createElement(OnBlurState, _extends({}, props, {
        children: children
      }));
    }
  });
};

var OnChangeState =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(OnChangeState, _React$Component);

  function OnChangeState(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      previous: props.input.value
    };
    return _this;
  }

  var _proto = OnChangeState.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _this$props = this.props,
        children = _this$props.children,
        value = _this$props.input.value;
    var previous = this.state.previous;

    if (value !== previous) {
      this.setState({
        previous: value
      });
      children(value, previous);
    }
  };

  _proto.render = function render() {
    return null;
  };

  return OnChangeState;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);

var OnChange = function OnChange(_ref) {
  var name = _ref.name,
      children = _ref.children;
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(react_final_form__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .gN, {
    name: name,
    subscription: {
      value: true
    },
    allowNull: true,
    render: function render(props) {
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(OnChangeState, _extends({}, props, {
        children: children
      }));
    }
  });
};

var OnFocusState =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(OnFocusState, _React$Component);

  function OnFocusState(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      previous: !!props.meta.active
    };
    return _this;
  }

  var _proto = OnFocusState.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _this$props = this.props,
        children = _this$props.children,
        active = _this$props.meta.active;
    var previous = this.state.previous;

    if (active && !previous) {
      this.setState({
        previous: active
      });
      children();
    } else if (!active && previous) {
      this.setState({
        previous: active
      });
    }
  };

  _proto.render = function render() {
    return null;
  };

  return OnFocusState;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);

var OnFocus = function OnFocus(_ref) {
  var name = _ref.name,
      children = _ref.children;
  return createElement(Field, {
    name: name,
    subscription: {
      active: true
    },
    render: function render(props) {
      return createElement(OnFocusState, _extends({}, props, {
        children: children
      }));
    }
  });
};




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,8208,1423,5337,5202,3782,2879,8626,740,5866,1961,1458,4434,8220,9774,2888,179], function() { return __webpack_exec__(87944); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);